<div class="container-fluid p-0">
  <app-header></app-header>
  <div class="row m-0 g-0">
    <div class="col-md-3 p-0">
      <app-folders></app-folders>
    </div>

        <div class="col-md-9 container" style="border-top-left-radius: 15px; border-top-right-radius: 15px; overflow: hidden; margin-top: 0 !important; margin-left: -7px;">
      <div class="card" style="height: 1000px">
        <div class="card-body">
          <div
            class="d-flex justify-content-start"
            style="margin-top: 0 !important"
          >
            <button
              type="button"
              class="btn custom-button"
              style="margin-bottom: 10px"
              (click)="goBack()"
            >
              Back
            </button>
          </div>

          <!-- new -->
          <div
            class="new-card"
                  style="border: 2px solid #4A148C; border-radius: 12px; padding: 10px 20px;background-color: #ffffff; box-shadow: 0 4px 12px rgba(103, 58, 183, 0.1);margin-bottom: -15px; font-family: 'Segoe UI', sans-serif; ">
            <div class="card-content">
              <div
                class="row d-flex align-items-center justify-content-between flex-wrap"
                style="gap: 12px; font-size: 15px; color: #333"
              >
                <div class="col-auto" style="min-width: 180px">
                  <strong style="color: #4a148c">Study Code:</strong>
                  {{ studyCode }}
                </div>
                <div class="col-auto" style="min-width: 180px">
                  <strong style="color: #4a148c">Study Name:</strong>
                  {{ studyName }}
                </div>
                <div class="col-auto" style="min-width: 180px">
                  <strong style="color: #4a148c">Subject Name:</strong>
                  {{ subjectName }}
                </div>
                <div class="col-auto" style="min-width: 180px">
                  <strong style="color: #4a148c">Site Location:</strong>
                  {{ siteLocation }}
                </div>
              </div>
            </div>
          </div>

          <!-- Baseline Record Form -->
          <div *ngIf="formName === 'baseline-record'" class="card mt-4">
            <div
              class="card-header d-flex justify-content-between align-items-center"
            >
              <h5 class="m-0">Baseline Record</h5>
              <!--<button type="button" class="btn custom-button">Create Field</button>-->
            </div>

            <div class="card-body scrollable-container">
              <form (ngSubmit)="submitForm()">
                <div
                  class="form-group"
                  data-label="1. Date of the Baseline Visit:"
                >
                 
                    <label>1. Date of the Baseline Visit:</label>
                     <div
                    class="label-wrapper d-flex align-items-center justify-content-between"
                  >
                     <input
                    type="date"
                    id="baselinedate"
                    class="form-control"
                    [(ngModel)]="formData.baselineDate"
                    name="baselineDate"
                    [min]="screeningMinDate"
                    [max]="todayDate"
                    [disabled]="isBaselineDateDisabled"
                    required
                  />
                    <div
                      class="menu-icon"
                      (click)="openOptionsModal($event, $event.target)"
                       style="margin-bottom: 8px"
                    >
                      ⋮
                    </div>
                  </div>
                  <!-- Small Modal (Right-side) -->
                  <div
                    class="options-modal"
                    *ngIf="
                      isOptionsModalOpen &&
                      fieldLabel === '1. Date of the Baseline Visit:'
                    "
                    (click)="$event.stopPropagation()"
                    style="margin-right: 55px; margin-top: 40px"
                  >
                    <div class="modal-buttons">
                      <button type="button" (click)="openModal()">Query</button>
                      <button  type="button" (click)="editStudy()">Edit</button>
                      <button type="button" (click)="openReviewModal()">
                        Review
                      </button>
                    </div>
                  </div>
                  <div class="modal-overlay" *ngIf="isReasonModalOpen">
                    <div class="modal-content">
                      <button class="close-btn" (click)="cancelEditReason()">
                        ×
                      </button>
                      <h4>Please provide a reason for editing:</h4>
                      <textarea
                        class="form-control"
                        [(ngModel)]="editReason"
                        rows="4"
                        placeholder="Enter reason here..."
                      ></textarea>
                      <div class="modal-footer">
                        <button
                          class="btn custom-button"
                          (click)="confirmEditReason()"
                        >
                          Confirm
                        </button>
                        <button
                          class="btn custom-button"
                          (click)="cancelEditReason()"
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>

                  <!-- Review Modal -->
                  <div
                    class="modal-overlay1"
                    *ngIf="showReviewModal"
                    (click)="closeReviewModal()"
                  >
                    <!-- Close Button -->
                    <span class="close-button1" (click)="closeReviewModal()"
                      >×</span
                    >
                    <div
                      class="modal-content1"
                      (click)="$event.stopPropagation()"
                    >
                      <div class="checkbox-group">
                        <div class="form-check" style="margin-top: 20px">
                          <input
                            type="checkbox"
                            id="reviewedByDataMonitor"
                            name="reviewedByDataMonitor"
                            [(ngModel)]="reviewOptions.dataMonitor"
                            [disabled]="
                              !hasBaselineDData ||
                              userDesignation !== 'data monitor'
                            "
                            (change)="onReviewCheckboxChange()"
                          />
                          <label for="reviewedByDataMonitor"
                            >Reviewed by Data Monitor</label
                          >
                        </div>
                      </div>
                      <div class="checkbox-group">
                        <div class="form-check">
                          <input
                            type="checkbox"
                            id="reviewedByMonitor"
                            name="reviewedByMonitor"
                            [(ngModel)]="reviewOptions.monitor"
                            [disabled]="
                              !hasBaselineDData ||
                              !reviewOptions.dataMonitor ||
                              userDesignation !== 'monitor'
                            "
                            (change)="onReviewCheckboxChange()"
                          />
                          <label for="reviewedByMonitor"
                            >Reviewed by Monitor</label
                          >
                        </div>
                      </div>
                      <div class="checkbox-group">
                        <div class="form-check">
                          <input
                            type="checkbox"
                            id="reviewedByPI"
                            name="reviewedByPI"
                            [(ngModel)]="reviewOptions.pi"
                            [disabled]="
                              !hasBaselineDData ||
                              !reviewOptions.dataMonitor ||
                              !reviewOptions.monitor ||
                              userDesignation !== 'pi'
                            "
                          />
                          <label for="reviewedByPI">Reviewed by PI</label>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="modal-overlay" *ngIf="isModalOpen">
                    <div class="modal-content">
                      <button class="close-btn" (click)="closeModal()">
                        &times;
                      </button>

                      <!-- Tab Bar -->
                      <div class="tab-bar">
                        <div
                          class="tab"
                          *ngFor="let tab of tabs; let idx = index"
                          [class.active]="selectedTab === idx"
                          (click)="selectTab(idx)"
                        >
                          {{ tab.title }}
                          <span
                            class="close-tab"
                            *ngIf="tabs.length > 1"
                            (click)="closeTab(idx, $event)"
                            >×</span
                          >
                        </div>

                        <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
                        <div
                          *ngIf="tabs[selectedTab].type === 'query'"
                          class="add-btn-wrapper"
                        >
                          <button  type="button" class="add-btn" (click)="addQuery(i)">
                            +
                          </button>
                          <span class="add-query-tooltip">Add Query</span>
                        </div>
                      </div>

                      <!-- Modal Body -->
                      <div class="modal-body">
                        <ng-container [ngSwitch]="tabs[selectedTab].type">
                          <!-- Query Tab -->
                          <div *ngSwitchCase="'query'">
                            <div
                              *ngFor="let query of queries; let i = index"
                              class="query-box"
                            >
                              <div class="input-checkbox-container">
                                <input
                                  type="text"
                                  class="form-control"
                                  [value]="''"
                                  (input)="query.text = $event.target.value"
                                  [readonly]="query.isClosed"
                                  [ngClass]="{ 'query-closed': query.isClosed }"
                                  placeholder="Enter your query"
                                />
                              </div>

                              <!-- Audit Trail -->
                              <div class="audit-trail">
                                <h4>Audit Trail</h4>
                                <div
                                  class="audit-entry"
                                  *ngFor="let entry of query.auditTrail"
                                >
                                  <strong>{{ entry.user }}</strong
                                  >-
                                  {{
                                    entry.timestamp
                                      | date : "dd-MMM-yyyy h:mm a"
                                  }}

                                  <p>{{ entry.message }}</p>
                                </div>
                              </div>
                              <div class="modal-footer">
                                <button
                                  class="btn custom-button"
                                  [ngClass]="{ 'btn-disabled': query.isClosed }"
                                  (click)="
                                    !query.isClosed && confirmCloseQuery(i)
                                  "
                                >
                                  Close
                                </button>
                                <button
                                  class="btn custom-button ms-2"
                                  (click)="confirmSubmitQuery(i)"
                                  [disabled]="query.isClosed"
                                 type="button">
                                  Submit
                                </button>
                              </div>
                            </div>
                          </div>

                          <!-- Field History Tab -->
                          <div *ngSwitchCase="'fieldHistory'">
                            <div
                              *ngIf="fieldHistoryData?.length > 0; else noData"
                            >
                              <div
                                *ngFor="let entry of fieldHistoryData"
                                class="history-box"
                              >
                                <div class="history-header">
                                  <strong>{{ entry.updated_by }}</strong> -
                                  {{ entry.updated_at | date : "medium" }}
                                </div>
                                <div class="history-value">
                                  {{ entry.value }}
                                </div>
                                <!-- ✅ Show edit reason if available -->
                                <div
                                  class="edit-reason"
                                  *ngIf="entry.edit_reason"
                                >
                                  <em
                                    >Reason for change:
                                    {{ entry.edit_reason }}</em
                                  >
                                </div>
                              </div>
                            </div>
                            <ng-template #noData>
                              <p>No history available for this field.</p>
                            </ng-template>
                          </div>
                        </ng-container>
                      </div>
                    </div>
                  </div>
                 
                </div>

                <div
                  class="form-group"
                  data-label="2. Was the subject recruited"
                >
                  <div
                    class="label-wrapper d-flex align-items-center justify-content-between"
                  >
                    <label>2. Was the subject recruited?</label>
                    <div class="radio-group">
                      <label class="radio-label">
                        <input
                          type="radio"
                          id="recruitedYes"
                          name="recruited"
                          value="yes"
                          [(ngModel)]="formData.recruited"
                          class="form-check-input"
                          [disabled]="isSubjectRecruitedDisabled"
                          required
                        />
                        <span>Yes</span>
                      </label>
                      <label class="radio-label">
                        <input
                          type="radio"
                          id="recruitedNo"
                          name="recruited"
                          value="no"
                          [(ngModel)]="formData.recruited"
                          class="form-check-input"
                          [disabled]="isSubjectRecruitedDisabled"
                          required
                        />
                        <span>No</span>
                      </label>
                    </div>
                    <div
                      class="menu-icon"
                      (click)="openOptionsModal($event, $event.target)"
                    >
                      ⋮
                    </div>
                  </div>
                  <!-- Small Modal (Right-side) -->
                  <div
                    class="options-modal"
                    *ngIf="
                      isOptionsModalOpen &&
                      fieldLabel === '2. Was the subject recruited'
                    "
                    (click)="$event.stopPropagation()"
                    style="margin-right: 55px; margin-top: 140px"
                  >
                    <div class="modal-buttons">
                      <button type="button" (click)="openModal()">Query</button>
                      <button type="button" (click)="editStudy()">Edit</button>
                      <button type="button" (click)="openReviewModal()">
                        Review
                      </button>
                    </div>
                  </div>
                  <div class="modal-overlay" *ngIf="isReasonModalOpen">
                    <div class="modal-content">
                      <button class="close-btn" (click)="cancelEditReason()">
                        ×
                      </button>
                      <h4>Please provide a reason for editing:</h4>
                      <textarea
                        class="form-control"
                        [(ngModel)]="editReason"
                        rows="4"
                        placeholder="Enter reason here..."
                      ></textarea>
                      <div class="modal-footer">
                        <button
                          class="btn custom-button"
                          (click)="confirmEditReason()"
                        >
                          Confirm
                        </button>
                        <button
                          class="btn custom-button"
                          (click)="cancelEditReason()"
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>

                  <!-- Review Modal -->
                  <div
                    class="modal-overlay1"
                    *ngIf="showReviewModal"
                    (click)="closeReviewModal()"
                  >
                    <!-- Close Button -->
                    <span class="close-button1" (click)="closeReviewModal()"
                      >×</span
                    >
                    <div
                      class="modal-content1"
                      (click)="$event.stopPropagation()"
                    >
                      <div class="checkbox-group">
                        <div class="form-check" style="margin-top: 20px">
                          <input
                            type="checkbox"
                            id="reviewedByDataMonitor"
                            name="reviewedByDataMonitor"
                            [(ngModel)]="reviewOptions.dataMonitor"
                            [disabled]="
                              !hasSubjectRecruitedData ||
                              userDesignation !== 'data monitor'
                            "
                            (change)="onReviewCheckboxChange()"
                          />
                          <label for="reviewedByDataMonitor"
                            >Reviewed by Data Monitor</label
                          >
                        </div>
                      </div>
                      <div class="checkbox-group">
                        <div class="form-check">
                          <input
                            type="checkbox"
                            id="reviewedByMonitor"
                            name="reviewedByMonitor"
                            [(ngModel)]="reviewOptions.monitor"
                            [disabled]="
                              !hasSubjectRecruitedData ||
                              !reviewOptions.dataMonitor ||
                              userDesignation !== 'monitor'
                            "
                            (change)="onReviewCheckboxChange()"
                          />
                          <label for="reviewedByMonitor"
                            >Reviewed by Monitor</label
                          >
                        </div>
                      </div>
                      <div class="checkbox-group">
                        <div class="form-check">
                          <input
                            type="checkbox"
                            id="reviewedByPI"
                            name="reviewedByPI"
                            [(ngModel)]="reviewOptions.pi"
                            [disabled]="
                              !hasSubjectRecruitedData ||
                              !reviewOptions.dataMonitor ||
                              !reviewOptions.monitor ||
                              userDesignation !== 'pi'
                            "
                          />
                          <label for="reviewedByPI">Reviewed by PI</label>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="modal-overlay" *ngIf="isModalOpen">
                    <div class="modal-content">
                      <button class="close-btn" (click)="closeModal()">
                        &times;
                      </button>

                      <!-- Tab Bar -->
                      <div class="tab-bar">
                        <div
                          class="tab"
                          *ngFor="let tab of tabs; let idx = index"
                          [class.active]="selectedTab === idx"
                          (click)="selectTab(idx)"
                        >
                          {{ tab.title }}
                          <span
                            class="close-tab"
                            *ngIf="tabs.length > 1"
                            (click)="closeTab(idx, $event)"
                            >×</span
                          >
                        </div>

                        <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
                        <div
                          *ngIf="tabs[selectedTab].type === 'query'"
                          class="add-btn-wrapper"
                        >
                          <button  type="button" class="add-btn" (click)="addQuery(i)">
                            +
                          </button>
                          <span class="add-query-tooltip">Add Query</span>
                        </div>
                      </div>

                      <!-- Modal Body -->
                      <div class="modal-body">
                        <ng-container [ngSwitch]="tabs[selectedTab].type">
                          <!-- Query Tab -->
                          <div *ngSwitchCase="'query'">
                            <div
                              *ngFor="let query of queries; let i = index"
                              class="query-box"
                            >
                              <div class="input-checkbox-container">
                                <input
                                  type="text"
                                  class="form-control"
                                  [value]="''"
                                  (input)="query.text = $event.target.value"
                                  [readonly]="query.isClosed"
                                  [ngClass]="{ 'query-closed': query.isClosed }"
                                  placeholder="Enter your query"
                                />
                              </div>

                              <!-- Audit Trail -->
                              <div class="audit-trail">
                                <h4>Audit Trail</h4>
                                <div
                                  class="audit-entry"
                                  *ngFor="let entry of query.auditTrail"
                                >
                                  <strong>{{ entry.user }}</strong
                                  >-
                                  {{
                                    entry.timestamp
                                      | date : "dd-MMM-yyyy h:mm a"
                                  }}

                                  <p>{{ entry.message }}</p>
                                </div>
                              </div>
                              <div class="modal-footer">
                                <button
                                  class="btn custom-button"
                                  (click)="confirmCloseQuery(i)"
                                type="button">
                                  Close Query
                                </button>
                                <button
                                  class="btn custom-button ms-2"
                                  (click)="confirmSubmitQuery(i)"
                                 type="button">
                                  Submit
                                </button>
                              </div>
                            </div>
                          </div>

                          <!-- Field History Tab -->
                          <div *ngSwitchCase="'fieldHistory'">
                            <div
                              *ngIf="fieldHistoryData?.length > 0; else noData"
                            >
                              <div
                                *ngFor="let entry of fieldHistoryData"
                                class="history-box"
                              >
                                <div class="history-header">
                                  <strong>{{ entry.updated_by }}</strong> -
                                  {{ entry.updated_at | date : "medium" }}
                                </div>
                                <div class="history-value">
                                  {{ entry.value }}
                                </div>
                                <!-- ✅ Show edit reason if available -->
                                <div
                                  class="edit-reason"
                                  *ngIf="entry.edit_reason"
                                >
                                  <em
                                    >Reason for change:
                                    {{ entry.edit_reason }}</em
                                  >
                                </div>
                              </div>
                            </div>
                            <ng-template #noData>
                              <p>No history available for this field.</p>
                            </ng-template>
                          </div>
                        </ng-container>
                      </div>
                    </div>
                  </div>

                  <div class="mt-4" *ngIf="formData.recruited === 'yes'">
                    <label>3. If yes, provide the recruitment No:</label>
                    <input
                      type="number"
                      class="form-control"
                      [(ngModel)]="formData.recruitmentNo"
                      name="recruitmentNo"
                      pattern="^[0-9]{4}$"
                      minlength="4"
                      maxlength="4"
                      required
                    />
                    <small class="text-muted">Enter a 4-digit number.</small>
                  </div>

                  <div class="mt-4" *ngIf="formData.recruited === 'yes'">
                    <label>4. Recruitment Date:</label>
                    <input
                      type="date"
                      class="form-control"
                      [(ngModel)]="formData.recruitmentDate"
                      name="recruitmentDate"
                      [min]="screeningMinDate"
                      [max]="todayDate"
                      required
                    />
                  </div>
                </div>

               <div class="text-end">
                   <!--<button type="button" class="btn custom-button" (click)="goBack()">Back</button> -->
                  <button type="submit" class="btn custom-button">
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>

          <!-- PRAKRITI ANALYSIS Form -->
          <div
            *ngIf="formName === 'baseline-prakriti-analysis'"
            class="card mt-4"
          >
            <div
              class="card-header d-flex justify-content-between align-items-center"
            >
              <h5 class="m-0">Prakriti Analysis</h5>
              <!--<button type="button" class="btn custom-button">Create Field</button>-->
            </div>

            <div class="card-body scrollable-container">
              <form (ngSubmit)="submitForm()">
                <div
                  class="form-group"
                  data-label="1. Was the prakriti analysis done for the subject"
                                    >
                
                          <div
                    class="label-wrapper d-flex align-items-center justify-content-between"
                  >
  <label
                    >1. Was the prakriti analysis done for the subject?</label
                  >

                    <div
                      class="menu-icon"
                      (click)="openOptionsModal($event, $event.target)"
                    >
                      ⋮
                    </div>
                  </div>
                  <div
                    class="label-wrapper d-flex align-items-center justify-content-between"
                  >
                    <div class="radio-group">
                      <label class="radio-label">
                        <input
                          type="radio"
                          [disabled]="isPrakritiAnalysisDisabled"
                          name="prakritiAnalysis"
                          value="yes"
                          [(ngModel)]="formData.prakritiAnalysis"
                          required
                        />
                        <span>Yes</span>
                      </label>
                      <label class="radio-label">
                        <input
                          type="radio"
                          [disabled]="isPrakritiAnalysisDisabled"
                          name="prakritiAnalysis"
                          value="no"
                          [(ngModel)]="formData.prakritiAnalysis"
                          required
                        />
                        <span>No</span>
                      </label>
                    </div>                
                  </div>
                  <!-- Small Modal (Right-side) -->
                  <div
                    class="options-modal"
                    *ngIf="
                      isOptionsModalOpen &&
                      fieldLabel ===
                        '1. Was the prakriti analysis done for the subject'
                    "
                    (click)="$event.stopPropagation()"
                    style="margin-right: 55px; margin-top: 40px"
                  >
                    <div class="modal-buttons">
                      <button type="button" (click)="openModal()">Query</button>
                      <button type="button" (click)="editStudy()">Edit</button>
                      <button type="button" (click)="openReviewModal()">
                        Review
                      </button>
                    </div>
                  </div>
                  <div class="modal-overlay" *ngIf="isReasonModalOpen">
                    <div class="modal-content">
                      <button class="close-btn" (click)="cancelEditReason()">
                        ×
                      </button>
                      <h4>Please provide a reason for editing:</h4>
                      <textarea
                        class="form-control"
                        [(ngModel)]="editReason"
                        rows="4"
                        placeholder="Enter reason here..."
                      ></textarea>
                      <div class="modal-footer">
                        <button
                          class="btn custom-button"
                          (click)="confirmEditReason()"
                        >
                          Confirm
                        </button>
                        <button
                          class="btn custom-button"
                          (click)="cancelEditReason()"
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                  <!-- Review Modal -->
                  <div
                    class="modal-overlay1"
                    *ngIf="showReviewModal"
                    (click)="closeReviewModal()"
                  >
                    <!-- Close Button -->
                    <span class="close-button1" (click)="closeReviewModal()"
                      >×</span
                    >
                    <div
                      class="modal-content1"
                      (click)="$event.stopPropagation()"
                    >
                      <div class="checkbox-group">
                        <div class="form-check" style="margin-top: 20px">
                          <input
                            type="checkbox"
                            id="reviewedByDataMonitor"
                            name="reviewedByDataMonitor"
                            [(ngModel)]="reviewOptions.dataMonitor"
                            [disabled]="
                              !hasPrakritiData ||
                              userDesignation !== 'data monitor'
                            "
                            (change)="onReviewCheckboxChange()"
                          />
                          <label for="reviewedByDataMonitor"
                            >Reviewed by Data Monitor</label
                          >
                        </div>
                      </div>
                      <div class="checkbox-group">
                        <div class="form-check">
                          <input
                            type="checkbox"
                            id="reviewedByMonitor"
                            name="reviewedByMonitor"
                            [(ngModel)]="reviewOptions.monitor"
                            [disabled]="
                              !hasPrakritiData ||
                              !reviewOptions.dataMonitor ||
                              userDesignation !== 'monitor'
                            "
                            (change)="onReviewCheckboxChange()"
                          />
                          <label for="reviewedByMonitor"
                            >Reviewed by Monitor</label
                          >
                        </div>
                      </div>
                      <div class="checkbox-group">
                        <div class="form-check">
                          <input
                            type="checkbox"
                            id="reviewedByPI"
                            name="reviewedByPI"
                            [(ngModel)]="reviewOptions.pi"
                            [disabled]="
                              !hasPrakritiData ||
                              !reviewOptions.dataMonitor ||
                              !reviewOptions.monitor ||
                              userDesignation !== 'pi'
                            "
                          />
                          <label for="reviewedByPI">Reviewed by PI</label>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="modal-overlay" *ngIf="isModalOpen">
                    <div class="modal-content">
                      <button class="close-btn" (click)="closeModal()">
                        &times;
                      </button>

                      <!-- Tab Bar -->
                      <div class="tab-bar">
                        <div
                          class="tab"
                          *ngFor="let tab of tabs; let idx = index"
                          [class.active]="selectedTab === idx"
                          (click)="selectTab(idx)"
                        >
                          {{ tab.title }}
                          <span
                            class="close-tab"
                            *ngIf="tabs.length > 1"
                            (click)="closeTab(idx, $event)"
                            >×</span
                          >
                        </div>

                        <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
                        <div
                          *ngIf="tabs[selectedTab].type === 'query'"
                          class="add-btn-wrapper"
                        >
                          <button  type="button" class="add-btn" (click)="addQuery(i)">
                            +
                          </button>
                          <span class="add-query-tooltip">Add Query</span>
                        </div>
                      </div>

                      <!-- Modal Body -->
                      <div class="modal-body">
                        <ng-container [ngSwitch]="tabs[selectedTab].type">
                          <!-- Query Tab -->
                          <div *ngSwitchCase="'query'">
                            <div
                              *ngFor="let query of queries; let i = index"
                              class="query-box"
                            >
                              <div class="input-checkbox-container">
                                <input
                                  type="text"
                                  class="form-control"
                                  [value]="''"
                                  (input)="query.text = $event.target.value"
                                  [readonly]="query.isClosed"
                                  [ngClass]="{ 'query-closed': query.isClosed }"
                                  placeholder="Enter your query"
                                />
                              </div>

                              <!-- Audit Trail -->
                              <div class="audit-trail">
                                <h4>Audit Trail</h4>
                                <div
                                  class="audit-entry"
                                  *ngFor="let entry of query.auditTrail"
                                >
                                  <strong>{{ entry.user }}</strong
                                  >-
                                  {{
                                    entry.timestamp
                                      | date : "dd-MMM-yyyy h:mm a"
                                  }}

                                  <p>{{ entry.message }}</p>
                                </div>
                              </div>
                              <div class="modal-footer">
                                <button
                                  class="btn custom-button"
                                  (click)="confirmCloseQuery(i)"
                                type="button">
                                  Close Query
                                </button>
                                <button
                                  class="btn custom-button ms-2"
                                  (click)="confirmSubmitQuery(i)"
                                 type="button">
                                  Submit
                                </button>
                              </div>
                            </div>
                          </div>

                          <!-- Field History Tab -->
                          <div *ngSwitchCase="'fieldHistory'">
                            <div
                              *ngIf="fieldHistoryData?.length > 0; else noData"
                            >
                              <div
                                *ngFor="let entry of fieldHistoryData"
                                class="history-box"
                              >
                                <div class="history-header">
                                  <strong>{{ entry.updated_by }}</strong> -
                                  {{ entry.updated_at | date : "medium" }}
                                </div>
                                <div class="history-value">
                                  {{ entry.value }}
                                </div>
                                <!-- ✅ Show edit reason if available -->
                                <div
                                  class="edit-reason"
                                  *ngIf="entry.edit_reason"
                                >
                                  <em
                                    >Reason for change:
                                    {{ entry.edit_reason }}</em
                                  >
                                </div>
                              </div>
                            </div>
                            <ng-template #noData>
                              <p>No history available for this field.</p>
                            </ng-template>
                          </div>
                        </ng-container>
                      </div>
                    </div>
                  </div>

                  <!-- Dropdown when Yes is selected -->
                  <div class="mt-4" *ngIf="formData.prakritiAnalysis === 'yes'">
                    <label>Select Prakriti Type:</label>
                    <select
                      class="form-control"
                      [(ngModel)]="formData.prakritiType"
                      name="prakritiType"
                      required
                    >
                      <option value="" disabled selected>Select one</option>
                      <option
                        *ngFor="let type of prakritiOptions"
                        [value]="type"
                      >
                        {{ type }}
                      </option>
                    </select>
                  </div>

                  <!-- Comment box when No is selected -->
                  <div class="mt-4" *ngIf="formData.prakritiAnalysis === 'no'">
                    <label>Comments:</label>
                    <textarea
                      class="form-control"
                      [(ngModel)]="formData.prakritiComment"
                      name="prakritiComment"
                      required
                    ></textarea>
                  </div>
                </div>

               <div class="text-end">
                   <!--<button type="button" class="btn custom-button" (click)="goBack()">Back</button> -->
                  <button type="submit" class="btn custom-button">
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>

          <!-- Vital Signs Form -->
          <div *ngIf="formName === 'baseline-vital-signs'" class="card mt-4">
            <div
              class="card-header d-flex justify-content-between align-items-center"
            >
              <h5 class="m-0">Vital Signs</h5>
              <!--<button type="button" class="btn custom-button">Create Field</button>-->
            </div>

            <div class="card-body">
              <form (ngSubmit)="submitForm()">
                <div
                  class="form-group"
                  data-label="1. Was Vital Signs evaluation performed"
                >
                   <div
                    class="label-wrapper d-flex align-items-center justify-content-between"
                  >
                                      <label>1. Was Vital Signs evaluation performed?</label>

                    <div
                      class="menu-icon"
                      (click)="openOptionsModal($event, $event.target)"
                    >
                      ⋮
                    </div>
                  </div>
                  <div
                    class="label-wrapper d-flex align-items-center justify-content-between"
                  >
                    <div class="radio-group">
                      <label class="radio-label">
                        <input
                          type="radio"
                          id="vitalYes"
                          [disabled]="isVitalSignsDisabled"
                          name="vitalSigns"
                          value="yes"
                          [(ngModel)]="formData.vitalSigns"
                          required
                        />
                        <!--<span>Yes</span>-->
                        <label for="vitalYes" class="ml-1">Yes</label>
                      </label>
                      <label class="radio-label">
                        <input
                          type="radio"
                          id="vitalNo"
                          [disabled]="isVitalSignsDisabled"
                          name="vitalSigns"
                          value="no"
                          [(ngModel)]="formData.vitalSigns"
                          required
                        />
                        <!--<span>No</span>-->
                        <label for="vitalNo" class="ml-1">No</label>
                      </label>
                    </div>
                  </div>
                  <!-- Small Modal (Right-side) -->
                  <div
                    class="options-modal"
                    *ngIf="
                      isOptionsModalOpen &&
                      fieldLabel === '1. Was Vital Signs evaluation performed'
                    "
                    (click)="$event.stopPropagation()"
                    style="margin-right: 55px; margin-top: 40px"
                  >
                    <div class="modal-buttons">
                      <button type="button" (click)="openModal()">Query</button>
                      <button type="button" (click)="editStudy()">Edit</button>
                      <button type="button" (click)="openReviewModal()">
                        Review
                      </button>
                    </div>
                  </div>
                  <div class="modal-overlay" *ngIf="isReasonModalOpen">
                    <div class="modal-content">
                      <button class="close-btn" (click)="cancelEditReason()">
                        ×
                      </button>
                      <h4>Please provide a reason for editing:</h4>
                      <textarea
                        class="form-control"
                        [(ngModel)]="editReason"
                        rows="4"
                        placeholder="Enter reason here..."
                      ></textarea>
                      <div class="modal-footer">
                        <button
                          class="btn custom-button"
                          (click)="confirmEditReason()"
                        >
                          Confirm
                        </button>
                        <button
                          class="btn custom-button"
                          (click)="cancelEditReason()"
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>

                  <!-- Review Modal -->
                  <div
                    class="modal-overlay1"
                    *ngIf="showReviewModal"
                    (click)="closeReviewModal()"
                  >
                    <!-- Close Button -->
                    <span class="close-button1" (click)="closeReviewModal()"
                      >×</span
                    >
                    <div
                      class="modal-content1"
                      (click)="$event.stopPropagation()"
                    >
                      <div class="checkbox-group">
                        <div class="form-check" style="margin-top: 20px">
                          <input
                            type="checkbox"
                            id="reviewedByDataMonitor"
                            name="reviewedByDataMonitor"
                            [(ngModel)]="reviewOptions.dataMonitor"
                            [disabled]="
                              !hasVitalSignData ||
                              userDesignation !== 'data monitor'
                            "
                            (change)="onReviewCheckboxChange()"
                          />
                          <label for="reviewedByDataMonitor"
                            >Reviewed by Data Monitor</label
                          >
                        </div>
                      </div>
                      <div class="checkbox-group">
                        <div class="form-check">
                          <input
                            type="checkbox"
                            id="reviewedByMonitor"
                            name="reviewedByMonitor"
                            [(ngModel)]="reviewOptions.monitor"
                            [disabled]="
                              !hasVitalSignData ||
                              !reviewOptions.dataMonitor ||
                              userDesignation !== 'monitor'
                            "
                            (change)="onReviewCheckboxChange()"
                          />
                          <label for="reviewedByMonitor"
                            >Reviewed by Monitor</label
                          >
                        </div>
                      </div>
                      <div class="checkbox-group">
                        <div class="form-check">
                          <input
                            type="checkbox"
                            id="reviewedByPI"
                            name="reviewedByPI"
                            [(ngModel)]="reviewOptions.pi"
                            [disabled]="
                              !hasVitalSignData ||
                              !reviewOptions.dataMonitor ||
                              !reviewOptions.monitor ||
                              userDesignation !== 'pi'
                            "
                          />
                          <label for="reviewedByPI">Reviewed by PI</label>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="modal-overlay" *ngIf="isModalOpen">
                    <div class="modal-content">
                      <button class="close-btn" (click)="closeModal()">
                        &times;
                      </button>

                      <!-- Tab Bar -->
                      <div class="tab-bar">
                        <div
                          class="tab"
                          *ngFor="let tab of tabs; let idx = index"
                          [class.active]="selectedTab === idx"
                          (click)="selectTab(idx)"
                        >
                          {{ tab.title }}
                          <span
                            class="close-tab"
                            *ngIf="tabs.length > 1"
                            (click)="closeTab(idx, $event)"
                            >×</span
                          >
                        </div>

                        <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
                        <div
                          *ngIf="tabs[selectedTab].type === 'query'"
                          class="add-btn-wrapper"
                        >
                          <button  type="button" class="add-btn" (click)="addQuery(i)">
                            +
                          </button>
                          <span class="add-query-tooltip">Add Query</span>
                        </div>
                      </div>

                      <!-- Modal Body -->
                      <div class="modal-body">
                        <ng-container [ngSwitch]="tabs[selectedTab].type">
                          <!-- Query Tab -->
                          <div *ngSwitchCase="'query'">
                            <div
                              *ngFor="let query of queries; let i = index"
                              class="query-box"
                            >
                              <div class="input-checkbox-container">
                                <input
                                  type="text"
                                  class="form-control"
                                  [value]="''"
                                  (input)="query.text = $event.target.value"
                                  [readonly]="query.isClosed"
                                  [ngClass]="{ 'query-closed': query.isClosed }"
                                  placeholder="Enter your query"
                                />
                              </div>

                              <!-- Audit Trail -->
                              <div class="audit-trail">
                                <h4>Audit Trail</h4>
                                <div
                                  class="audit-entry"
                                  *ngFor="let entry of query.auditTrail"
                                >
                                  <strong>{{ entry.user }}</strong
                                  >-
                                  {{
                                    entry.timestamp
                                      | date : "dd-MMM-yyyy h:mm a"
                                  }}

                                  <p>{{ entry.message }}</p>
                                </div>
                              </div>
                              <div class="modal-footer">
                                <button
                                  class="btn custom-button"
                                  (click)="confirmCloseQuery(i)"
                                type="button">
                                  Close Query
                                </button>
                                <button
                                  class="btn custom-button ms-2"
                                  (click)="confirmSubmitQuery(i)"
                                 type="button">
                                  Submit
                                </button>
                              </div>
                            </div>
                          </div>

                          <!-- Field History Tab -->
                          <div *ngSwitchCase="'fieldHistory'">
                            <div
                              *ngIf="fieldHistoryData?.length > 0; else noData"
                            >
                              <div
                                *ngFor="let entry of fieldHistoryData"
                                class="history-box"
                              >
                                <div class="history-header">
                                  <strong>{{ entry.updated_by }}</strong> -
                                  {{ entry.updated_at | date : "medium" }}
                                </div>
                                <div class="history-value">
                                  {{ entry.value }}
                                </div>
                                <!-- ✅ Show edit reason if available -->
                                <div
                                  class="edit-reason"
                                  *ngIf="entry.edit_reason"
                                >
                                  <em
                                    >Reason for change:
                                    {{ entry.edit_reason }}</em
                                  >
                                </div>
                              </div>
                            </div>
                            <ng-template #noData>
                              <p>No history available for this field.</p>
                            </ng-template>
                          </div>
                        </ng-container>
                      </div>
                    </div>
                  </div>
                  <!-- Show the button only when "Yes" is selected -->
                  <div class="mt-3" *ngIf="formData.vitalSigns === 'yes'">
                    <button
                      type="button"
                      class="btn btn-success"
                      (click)="navigateToVitalSigns()"
                    >
                      Add Vital Signs Data
                    </button>
                  </div>
                  <div class="mt-3" *ngIf="formData.vitalSigns === 'no'">
                    <label>Comments:</label>
                    <textarea
                      class="form-control"
                      [(ngModel)]="formData.vitalSignsComments"
                      name="vitalSignsComments"
                    ></textarea>
                  </div>
                </div>

               <div class="text-end">
                   <!--<button type="button" class="btn custom-button" (click)="goBack()">Back</button> -->
                  <button type="submit" class="btn custom-button">
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>

          <!-- Physical and Systemic Examination Form -->
          <div *ngIf="formName === 'baseline-physical-exam'" class="card mt-4">
            <div
              class="card-header d-flex justify-content-between align-items-center"
            >
              <h5 class="m-0">Physical and Systemic Examination</h5>
              <!--<button type="button" class="btn custom-button">Create Field</button>-->
            </div>

            <div class="card-body">
              <form (ngSubmit)="submitForm()">
                <div
                  class="form-group"
                  data-label="1. Was physical and systemic examination performed"
                >
                
                       <div
                    class="label-wrapper d-flex align-items-center justify-content-between"
                  >
  <label
                    >1. Was physical and systematic examination
                    performed?</label
                  >

                    <div
                      class="menu-icon"
                      (click)="openOptionsModal($event, $event.target)"
                    >
                      ⋮
                    </div>
                  </div>
                  <div
                    class="label-wrapper d-flex align-items-center justify-content-between"
                  >
                    <div class="radio-group">
                      <label class="radio-label">
                        <input
                          type="radio"
                          id="physYes"
                          [disabled]="isPhysicalExamDisabled"
                          name="physicalExam"
                          value="yes"
                          [(ngModel)]="formData.physicalExam"
                          required
                        />
                        <span>Yes</span>
                      </label>
                      <label class="radio-label">
                        <input
                          type="radio"
                          id="physNo"
                          [disabled]="isPhysicalExamDisabled"
                          name="physicalExam"
                          value="no"
                          [(ngModel)]="formData.physicalExam"
                          required
                        />
                        <span>No</span>
                      </label>
                    </div>             
                  </div>
                  <!-- Small Modal (Right-side) -->
                  <div
                    class="options-modal"
                    *ngIf="
                      isOptionsModalOpen &&
                      fieldLabel ===
                        '1. Was physical and systemic examination performed'
                    "
                    (click)="$event.stopPropagation()"
                    style="margin-right: 55px; margin-top: 40px"
                  >
                    <div class="modal-buttons">
                      <button type="button" (click)="openModal()">Query</button>
                      <button type="button" (click)="editStudy()">Edit</button>
                      <button type="button" (click)="openReviewModal()">
                        Review
                      </button>
                    </div>
                  </div>
                  <div class="modal-overlay" *ngIf="isReasonModalOpen">
                    <div class="modal-content">
                      <button class="close-btn" (click)="cancelEditReason()">
                        ×
                      </button>
                      <h4>Please provide a reason for editing:</h4>
                      <textarea
                        class="form-control"
                        [(ngModel)]="editReason"
                        rows="4"
                        placeholder="Enter reason here..."
                      ></textarea>
                      <div class="modal-footer">
                        <button
                          class="btn custom-button"
                          (click)="confirmEditReason()"
                        >
                          Confirm
                        </button>
                        <button
                          class="btn custom-button"
                          (click)="cancelEditReason()"
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>

                  <!-- Review Modal -->
                  <div
                    class="modal-overlay1"
                    *ngIf="showReviewModal"
                    (click)="closeReviewModal()"
                  >
                    <!-- Close Button -->
                    <span class="close-button1" (click)="closeReviewModal()"
                      >×</span
                    >
                    <div
                      class="modal-content1"
                      (click)="$event.stopPropagation()"
                    >
                      <div class="checkbox-group">
                        <div class="form-check" style="margin-top: 20px">
                          <input
                            type="checkbox"
                            id="reviewedByDataMonitor"
                            name="reviewedByDataMonitor"
                            [(ngModel)]="reviewOptions.dataMonitor"
                            [disabled]="
                              !hasPhysicalExamData ||
                              userDesignation !== 'data monitor'
                            "
                            (change)="onReviewCheckboxChange()"
                          />
                          <label for="reviewedByDataMonitor"
                            >Reviewed by Data Monitor</label
                          >
                        </div>
                      </div>
                      <div class="checkbox-group">
                        <div class="form-check">
                          <input
                            type="checkbox"
                            id="reviewedByMonitor"
                            name="reviewedByMonitor"
                            [(ngModel)]="reviewOptions.monitor"
                            [disabled]="
                              !hasPhysicalExamData ||
                              !reviewOptions.dataMonitor ||
                              userDesignation !== 'monitor'
                            "
                            (change)="onReviewCheckboxChange()"
                          />
                          <label for="reviewedByMonitor"
                            >Reviewed by Monitor</label
                          >
                        </div>
                      </div>
                      <div class="checkbox-group">
                        <div class="form-check">
                          <input
                            type="checkbox"
                            id="reviewedByPI"
                            name="reviewedByPI"
                            [(ngModel)]="reviewOptions.pi"
                            [disabled]="
                              !hasPhysicalExamData ||
                              !reviewOptions.dataMonitor ||
                              !reviewOptions.monitor ||
                              userDesignation !== 'pi'
                            "
                          />
                          <label for="reviewedByPI">Reviewed by PI</label>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="modal-overlay" *ngIf="isModalOpen">
                    <div class="modal-content">
                      <button class="close-btn" (click)="closeModal()">
                        &times;
                      </button>

                      <!-- Tab Bar -->
                      <div class="tab-bar">
                        <div
                          class="tab"
                          *ngFor="let tab of tabs; let idx = index"
                          [class.active]="selectedTab === idx"
                          (click)="selectTab(idx)"
                        >
                          {{ tab.title }}
                          <span
                            class="close-tab"
                            *ngIf="tabs.length > 1"
                            (click)="closeTab(idx, $event)"
                            >×</span
                          >
                        </div>

                        <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
                        <div
                          *ngIf="tabs[selectedTab].type === 'query'"
                          class="add-btn-wrapper"
                        >
                          <button  type="button" class="add-btn" (click)="addQuery(i)">
                            +
                          </button>
                          <span class="add-query-tooltip">Add Query</span>
                        </div>
                      </div>

                      <!-- Modal Body -->
                      <div class="modal-body">
                        <ng-container [ngSwitch]="tabs[selectedTab].type">
                          <!-- Query Tab -->
                          <div *ngSwitchCase="'query'">
                            <div
                              *ngFor="let query of queries; let i = index"
                              class="query-box"
                            >
                              <div class="input-checkbox-container">
                                <input
                                  type="text"
                                  class="form-control"
                                  [value]="''"
                                  (input)="query.text = $event.target.value"
                                  [readonly]="query.isClosed"
                                  [ngClass]="{ 'query-closed': query.isClosed }"
                                  placeholder="Enter your query"
                                />
                              </div>

                              <!-- Audit Trail -->
                              <div class="audit-trail">
                                <h4>Audit Trail</h4>
                                <div
                                  class="audit-entry"
                                  *ngFor="let entry of query.auditTrail"
                                >
                                  <strong>{{ entry.user }}</strong
                                  >-
                                  {{
                                    entry.timestamp
                                      | date : "dd-MMM-yyyy h:mm a"
                                  }}

                                  <p>{{ entry.message }}</p>
                                </div>
                              </div>
                              <div class="modal-footer">
                                <button
                                  class="btn custom-button"
                                  (click)="confirmCloseQuery(i)"
                                type="button">
                                  Close Query
                                </button>
                                <button
                                  class="btn custom-button ms-2"
                                  (click)="confirmSubmitQuery(i)"
                                 type="button">
                                  Submit
                                </button>
                              </div>
                            </div>
                          </div>

                          <!-- Field History Tab -->
                          <div *ngSwitchCase="'fieldHistory'">
                            <div
                              *ngIf="fieldHistoryData?.length > 0; else noData"
                            >
                              <div
                                *ngFor="let entry of fieldHistoryData"
                                class="history-box"
                              >
                                <div class="history-header">
                                  <strong>{{ entry.updated_by }}</strong> -
                                  {{ entry.updated_at | date : "medium" }}
                                </div>
                                <div class="history-value">
                                  {{ entry.value }}
                                </div>
                                <!-- ✅ Show edit reason if available -->
                                <div
                                  class="edit-reason"
                                  *ngIf="entry.edit_reason"
                                >
                                  <em
                                    >Reason for change:
                                    {{ entry.edit_reason }}</em
                                  >
                                </div>
                              </div>
                            </div>
                            <ng-template #noData>
                              <p>No history available for this field.</p>
                            </ng-template>
                          </div>
                        </ng-container>
                      </div>
                    </div>
                  </div>

                  <div class="mt-3" *ngIf="formData.physicalExam === 'no'">
                    <label>Comments:</label>
                    <textarea
                      class="form-control"
                      [(ngModel)]="formData.physicalExamComments"
                      name="physicalExamComments"
                    ></textarea>
                  </div>
                  <!-- Show the button only when "Yes" is selected -->
                  <div class="mt-3" *ngIf="formData.physicalExam === 'yes'">
                    <button
                      type="button"
                      class="btn btn-success"
                      (click)="navigateToPhysicalSystemic()"
                    >
                      Add Physical and Systemic Examination Data
                    </button>
                  </div>
                </div>

               <div class="text-end">
                   <!--<button type="button" class="btn custom-button" (click)="goBack()">Back</button> -->
                  <button type="submit" class="btn custom-button">
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>

          <!-- Pregnancy Declaration Form -->
          <!-- <div *ngIf="formName === 'baseline-pregnancy-declaration'" class="card mt-4" style="border: 2px solid #673AB7; border-radius: 8px; padding: 0px; background-color: #fff; >
            <div class="card-header d-flex justify-content-between align-items-center">
              <h5 class="m-0">Pregnancy Declaration</h5>
              <button type="button" class="btn custom-button">Create Field</button>
            </div>

            <div *ngIf = "gender !== 'Male'"  class="card-body">
              <form (ngSubmit)="submitForm()">
                <div class="form-group">
                  <label>1. Ask the subject “Are you currently pregnant?”</label>
                  <select class="form-control" [(ngModel)]="formData.pregnancyStatus" name="pregnancyStatus" required>
                    <option value="yes">Yes</option>
                    <option value="no">No</option>
                    <option value="na">NA</option>
                  </select>
                </div>

                <div class="text-end">
                  <button type="button" class="btn custom-button" (click)="goBack()">Back</button> 
                  <button type="submit" class="btn custom-button">Submit</button>
                </div>
              </form>
            </div>
          </div> -->
          <div
            *ngIf="formName === 'baseline-pregnancy-declaration'"
            class="card mt-4"
          >
            <div
              class="card-header d-flex justify-content-between align-items-center"
            >
              <h5 class="m-0">Urine Pregnancy Test</h5>
              <!--<button type="button" class="btn custom-button">Create Field</button>-->
            </div>

            <div *ngIf="gender !== 'Male'" class="card-body">
              <form (ngSubmit)="submitForm()">
                <!-- Date of Last Menstrual Period (LMP) -->
                <div
                  class="form-group"
                  data-label="Date of Last Menstrual Period (LMP)"
                >
    <div
                    class="label-wrapper d-flex align-items-center justify-content-between"
                  >
 <label>Date of Last Menstrual Period (LMP)</label>

                    <div
                      class="menu-icon"
                      (click)="openOptionsModal($event, $event.target)"
                      style="margin-bottom: 8px;"
                    >
                      ⋮
                    </div>
                  </div>
                  <div
                    class="label-wrapper d-flex align-items-center justify-content-between"
                  >
                    <input
                      type="date"
                      [disabled]="isLMPDateDisabled"
                      class="form-control"
                      [(ngModel)]="formData.lmpDate"
                      name="lmpDate"
                      [max]="todayDate"
                      required
                    />
                  </div>     
                </div>

                <!-- Small Modal (Right-side) -->
                <div
                  class="options-modal"
                  *ngIf="
                    isOptionsModalOpen &&
                    fieldLabel === 'Date of Last Menstrual Period (LMP)'
                  "
                  (click)="$event.stopPropagation()"
                  style="margin-right: 55px; margin-top: 40px"
                >
                  <div class="modal-buttons">
                    <button type="button" (click)="openModal()">Query</button>
                    <button type="button" (click)="editStudy()">Edit</button>
                    <button type="button" (click)="openReviewModal()">
                      Review
                    </button>
                  </div>
                </div>
                <div class="modal-overlay" *ngIf="isReasonModalOpen">
                  <div class="modal-content">
                    <button class="close-btn" (click)="cancelEditReason()">
                      ×
                    </button>
                    <h4>Please provide a reason for editing:</h4>
                    <textarea
                      class="form-control"
                      [(ngModel)]="editReason"
                      rows="4"
                      placeholder="Enter reason here..."
                    ></textarea>
                    <div class="modal-footer">
                      <button
                        class="btn custom-button"
                        (click)="confirmEditReason()"
                      >
                        Confirm
                      </button>
                      <button
                        class="btn custom-button"
                        (click)="cancelEditReason()"
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>

<!-- Review Modal -->
<div
  class="modal-overlay1"
  *ngIf="showReviewModal"
  (click)="closeReviewModal()"
>
  <div
    class="modal-content1"
    (click)="$event.stopPropagation()"
    style="max-width: 370px; position: relative; margin-left: -25px; margin-top: -5px; margin-bottom: -5px;"
  >
    <!-- Close Button -->
    <span
      class="close-button1"
      (click)="closeReviewModal()"
      style="position: absolute; top: 1px; right: 16px; font-size: 22px; cursor: pointer; color: #999; z-index: 10;"
    >
      ×
    </span>

    <div class="checkbox-group" style="padding-top: 1.5rem;">
      <div
        class="form-check"
        style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px; white-space: nowrap;"
      >
        <input
          type="checkbox"
          id="reviewedByDataMonitor"
          name="reviewedByDataMonitor"
          [(ngModel)]="reviewOptions.dataMonitor"
          [disabled]="!hasLMPData || userDesignation !== 'data monitor'"
          (change)="onReviewCheckboxChange()"
          style="display: none;"
        />
        <label
          for="reviewedByDataMonitor"
          style="position: relative; padding-left: 25px; cursor: pointer; font-size: 14px;"
        >
          Reviewed by Data Monitor
          <span
            style="position: absolute; left: 0; top: 2px; width: 20px; height: 20px; border: 2px solid #673AB7; border-radius: 4px; background-color: #fff;"
            [ngStyle]="reviewOptions.dataMonitor ? { backgroundColor: '#673AB7', borderColor: '#673AB7' } : {}"
          ></span>
          <span
            style="position: absolute; left: 7px; top: 5px; width: 6px; height: 12px; border: solid white; border-width: 0 2px 2px 0; transform: rotate(45deg); transition: opacity 0.3s ease;"
            [ngStyle]="reviewOptions.dataMonitor ? { opacity: 1 } : { opacity: 0 }"
          ></span>
        </label>
      </div>
    </div>

    <div class="checkbox-group">
      <div
        class="form-check"
        style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px; white-space: nowrap;"
      >
        <input
          type="checkbox"
          id="reviewedByMonitor"
          name="reviewedByMonitor"
          [(ngModel)]="reviewOptions.monitor"
          [disabled]="!hasLMPData || !reviewOptions.dataMonitor || userDesignation !== 'monitor'"
          (change)="onReviewCheckboxChange()"
          style="display: none;"
        />
        <label
          for="reviewedByMonitor"
          style="position: relative; padding-left: 25px; cursor: pointer; font-size: 14px;"
        >
          Reviewed by Monitor
          <span
            style="position: absolute; left: 0; top: 2px; width: 20px; height: 20px; border: 2px solid #673AB7; border-radius: 4px; background-color: #fff;"
            [ngStyle]="reviewOptions.monitor ? { backgroundColor: '#673AB7', borderColor: '#673AB7' } : {}"
          ></span>
          <span
            style="position: absolute; left: 7px; top: 5px; width: 6px; height: 12px; border: solid white; border-width: 0 2px 2px 0; transform: rotate(45deg); transition: opacity 0.3s ease;"
            [ngStyle]="reviewOptions.monitor ? { opacity: 1 } : { opacity: 0 }"
          ></span>
        </label>
      </div>
    </div>

    <div class="checkbox-group">
      <div
        class="form-check"
        style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px; white-space: nowrap;"
      >
        <input
          type="checkbox"
          id="reviewedByPI"
          name="reviewedByPI"
          [(ngModel)]="reviewOptions.pi"
          [disabled]="!hasLMPData || !reviewOptions.dataMonitor || !reviewOptions.monitor || userDesignation !== 'pi'"
          style="display: none;"
        />
        <label
          for="reviewedByPI"
          style="position: relative; padding-left: 25px; cursor: pointer; font-size: 14px;"
        >
          Reviewed by PI
          <span
            style="position: absolute; left: 0; top: 2px; width: 20px; height: 20px; border: 2px solid #673AB7; border-radius: 4px; background-color: #fff;"
            [ngStyle]="reviewOptions.pi ? { backgroundColor: '#673AB7', borderColor: '#673AB7' } : {}"
          ></span>
          <span
            style="position: absolute; left: 7px; top: 5px; width: 6px; height: 12px; border: solid white; border-width: 0 2px 2px 0; transform: rotate(45deg); transition: opacity 0.3s ease;"
            [ngStyle]="reviewOptions.pi ? { opacity: 1 } : { opacity: 0 }"
          ></span>
        </label>
      </div>
    </div>
  </div>
</div>

                <div class="modal-overlay" *ngIf="isModalOpen">
                  <div class="modal-content">
                    <button class="close-btn" (click)="closeModal()">
                      &times;
                    </button>

                    <!-- Tab Bar -->
                    <div class="tab-bar">
                      <div
                        class="tab"
                        *ngFor="let tab of tabs; let idx = index"
                        [class.active]="selectedTab === idx"
                        (click)="selectTab(idx)"
                      >
                        {{ tab.title }}
                        <span
                          class="close-tab"
                          *ngIf="tabs.length > 1"
                          (click)="closeTab(idx, $event)"
                          >×</span
                        >
                      </div>

                      <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
                      <div
                        *ngIf="tabs[selectedTab].type === 'query'"
                        class="add-btn-wrapper"
                      >
                        <button  type="button" class="add-btn" (click)="addQuery(i)">+</button>
                        <span class="add-query-tooltip">Add Query</span>
                      </div>
                    </div>

                    <!-- Modal Body -->
                    <div class="modal-body">
                      <ng-container [ngSwitch]="tabs[selectedTab].type">
                        <!-- Query Tab -->
                        <div *ngSwitchCase="'query'">
                          <div
                            *ngFor="let query of queries; let i = index"
                            class="query-box"
                          >
                            <div class="input-checkbox-container">
                              <input
                                type="text"
                                class="form-control"
                                [value]="''"
                                (input)="query.text = $event.target.value"
                                [readonly]="query.isClosed"
                                [ngClass]="{ 'query-closed': query.isClosed }"
                                placeholder="Enter your query"
                              />
                            </div>

                            <!-- Audit Trail -->
                            <div class="audit-trail">
                              <h4>Audit Trail</h4>
                              <div
                                class="audit-entry"
                                *ngFor="let entry of query.auditTrail"
                              >
                                <strong>{{ entry.user }}</strong
                                >-
                                {{
                                  entry.timestamp | date : "dd-MMM-yyyy h:mm a"
                                }}

                                <p>{{ entry.message }}</p>
                              </div>
                            </div>
                            <div class="modal-footer">
                              <button
                                class="btn custom-button"
                                (click)="confirmCloseQuery(i)"
                              >
                                Close Query
                              </button>
                              <button
                                class="btn custom-button ms-2"
                                (click)="confirmSubmitQuery(i)"
                              >
                                Submit
                              </button>
                            </div>
                          </div>
                        </div>

                        <!-- Field History Tab -->
                        <div *ngSwitchCase="'fieldHistory'">
                          <div
                            *ngIf="fieldHistoryData?.length > 0; else noData"
                          >
                            <div
                              *ngFor="let entry of fieldHistoryData"
                              class="history-box"
                            >
                              <div class="history-header">
                                <strong>{{ entry.updated_by }}</strong> -
                                {{ entry.updated_at | date : "medium" }}
                              </div>
                              <div class="history-value">
                                {{ entry.value }}
                              </div>
                              <!-- ✅ Show edit reason if available -->
                              <div
                                class="edit-reason"
                                *ngIf="entry.edit_reason"
                              >
                                <em
                                  >Reason for change:
                                  {{ entry.edit_reason }}</em
                                >
                              </div>
                            </div>
                          </div>
                          <ng-template #noData>
                            <p>No history available for this field.</p>
                          </ng-template>
                        </div>
                      </ng-container>
                    </div>
                  </div>
                </div>

                <!-- Was Urine Pregnancy Test (UPT) done? -->
                <div
                  class="form-group mt-2"
                  data-label="Was Urine Pregnancy Test (UPT) done"
                >
                    <div
                    class="label-wrapper d-flex align-items-center justify-content-between"
                  >
                  <label>Was Urine Pregnancy Test (UPT) done?</label>


                    <div
                      class="menu-icon"
                      (click)="openOptionsModal($event, $event.target)"
                      style="margin-bottom: 8px;"
                    >
                      ⋮
                    </div>
                  </div>
                  <div
                    class="label-wrapper d-flex align-items-center justify-content-between"
                  >
                    <select
                      class="form-control"
                      [disabled]="isUPTDoneDisabled"
                      [(ngModel)]="formData.uptDone"
                      name="uptDone"
                      (change)="handleUptDoneChange()"
                      required
                    >
                      <option value="">Select</option>
                      <option value="YES">Yes</option>
                      <option value="NO">No</option>
                      <option value="NA">Not Applicable</option>
                    </select>              
                  </div>

                  <!-- Small Modal (Right-side) -->
                  <div
                    class="options-modal"
                    *ngIf="
                      isOptionsModalOpen &&
                      fieldLabel === 'Was Urine Pregnancy Test (UPT) done'
                    "
                    (click)="$event.stopPropagation()"
                    style="margin-right: 55px; margin-top: 140px"
                  >
                    <div class="modal-buttons">
                      <button type="button" (click)="openModal()">Query</button>
                      <button type="button" (click)="editStudy()">Edit</button>
                      <button type="button" (click)="openReviewModal()">
                        Review
                      </button>
                    </div>
                  </div>
                  <div class="modal-overlay" *ngIf="isReasonModalOpen">
                    <div class="modal-content">
                      <button class="close-btn" (click)="cancelEditReason()">
                        ×
                      </button>
                      <h4>Please provide a reason for editing:</h4>
                      <textarea
                        class="form-control"
                        [(ngModel)]="editReason"
                        rows="4"
                        placeholder="Enter reason here..."
                      ></textarea>
                      <div class="modal-footer">
                        <button
                          class="btn custom-button"
                          (click)="confirmEditReason()"
                        >
                          Confirm
                        </button>
                        <button
                          class="btn custom-button"
                          (click)="cancelEditReason()"
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>

           <!-- Review Modal -->
<div
  class="modal-overlay1"
  *ngIf="showReviewModal"
  (click)="closeReviewModal()"
>
  <div
    class="modal-content1"
    (click)="$event.stopPropagation()"
    style="max-width: 370px; position: relative; margin-left: -25px; margin-top: -5px; margin-bottom: -5px;"
  >
    <!-- Close Button -->
    <span
      class="close-button1"
      (click)="closeReviewModal()"
    >×</span>

    <div class="checkbox-group" style="padding-top: 1.5rem;">
      <div class="form-check" style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px; white-space: nowrap;">
        <input
          type="checkbox"
          id="reviewedByDataMonitor"
          name="reviewedByDataMonitor"
          [(ngModel)]="reviewOptions.dataMonitor"
          [disabled]="
            !hasUPTData || userDesignation !== 'data monitor'
          "
          (change)="onReviewCheckboxChange()"
          style="display: none;"
        />
        <label for="reviewedByDataMonitor" style="position: relative; padding-left: 25px; cursor: pointer; font-size: 14px;">
          Reviewed by Data Monitor
          <span
            style="position: absolute; left: 0; top: 2px; width: 20px; height: 20px; border: 2px solid #673AB7; border-radius: 4px; background-color: #fff;"
            [ngStyle]="reviewOptions.dataMonitor ? { backgroundColor: '#673AB7', borderColor: '#673AB7' } : {}"
          ></span>
          <span
            style="position: absolute; left: 7px; top: 5px; width: 6px; height: 12px; border: solid white; border-width: 0 2px 2px 0; transform: rotate(45deg); transition: opacity 0.3s ease;"
            [ngStyle]="reviewOptions.dataMonitor ? { opacity: 1 } : { opacity: 0 }"
          ></span>
        </label>
      </div>
    </div>

    <div class="checkbox-group">
      <div class="form-check" style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px; white-space: nowrap;">
        <input
          type="checkbox"
          id="reviewedByMonitor"
          name="reviewedByMonitor"
          [(ngModel)]="reviewOptions.monitor"
          [disabled]="
            !hasUPTData ||
            !reviewOptions.dataMonitor ||
            userDesignation !== 'monitor'
          "
          (change)="onReviewCheckboxChange()"
          style="display: none;"
        />
        <label for="reviewedByMonitor" style="position: relative; padding-left: 25px; cursor: pointer; font-size: 14px;">
          Reviewed by Monitor
          <span
            style="position: absolute; left: 0; top: 2px; width: 20px; height: 20px; border: 2px solid #673AB7; border-radius: 4px; background-color: #fff;"
            [ngStyle]="reviewOptions.monitor ? { backgroundColor: '#673AB7', borderColor: '#673AB7' } : {}"
          ></span>
          <span
            style="position: absolute; left: 7px; top: 5px; width: 6px; height: 12px; border: solid white; border-width: 0 2px 2px 0; transform: rotate(45deg); transition: opacity 0.3s ease;"
            [ngStyle]="reviewOptions.monitor ? { opacity: 1 } : { opacity: 0 }"
          ></span>
        </label>
      </div>
    </div>
    <div class="checkbox-group">
      <div class="form-check" style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px; white-space: nowrap;">
        <input
          type="checkbox"
          id="reviewedByPI"
          name="reviewedByPI"
          [(ngModel)]="reviewOptions.pi"
          [disabled]="
            !hasUPTData ||
            !reviewOptions.dataMonitor ||
            !reviewOptions.monitor ||
            userDesignation !== 'pi'
          "
          style="display: none;"
        />
        <label for="reviewedByPI" style="position: relative; padding-left: 25px; cursor: pointer; font-size: 14px;">
          Reviewed by PI
          <span
            style="position: absolute; left: 0; top: 2px; width: 20px; height: 20px; border: 2px solid #673AB7; border-radius: 4px; background-color: #fff;"
            [ngStyle]="reviewOptions.pi ? { backgroundColor: '#673AB7', borderColor: '#673AB7' } : {}"
          ></span>
          <span
            style="position: absolute; left: 7px; top: 5px; width: 6px; height: 12px; border: solid white; border-width: 0 2px 2px 0; transform: rotate(45deg); transition: opacity 0.3s ease;"
            [ngStyle]="reviewOptions.pi ? { opacity: 1 } : { opacity: 0 }"
          ></span>
        </label>
      </div>
    </div>
  </div>
</div>


                  <div class="modal-overlay" *ngIf="isModalOpen">
                    <div class="modal-content">
                      <button class="close-btn" (click)="closeModal()">
                        &times;
                      </button>

                      <!-- Tab Bar -->
                      <div class="tab-bar">
                        <div
                          class="tab"
                          *ngFor="let tab of tabs; let idx = index"
                          [class.active]="selectedTab === idx"
                          (click)="selectTab(idx)"
                        >
                          {{ tab.title }}
                          <span
                            class="close-tab"
                            *ngIf="tabs.length > 1"
                            (click)="closeTab(idx, $event)"
                            >×</span
                          >
                        </div>

                        <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
                        <div
                          *ngIf="tabs[selectedTab].type === 'query'"
                          class="add-btn-wrapper"
                        >
                          <button  type="button" class="add-btn" (click)="addQuery(i)">
                            +
                          </button>
                          <span class="add-query-tooltip">Add Query</span>
                        </div>
                      </div>

                      <!-- Modal Body -->
                      <div class="modal-body">
                        <ng-container [ngSwitch]="tabs[selectedTab].type">
                          <!-- Query Tab -->
                          <div *ngSwitchCase="'query'">
                            <div
                              *ngFor="let query of queries; let i = index"
                              class="query-box"
                            >
                              <div class="input-checkbox-container">
                                <input
                                  type="text"
                                  class="form-control"
                                  [value]="''"
                                  (input)="query.text = $event.target.value"
                                  [readonly]="query.isClosed"
                                  [ngClass]="{ 'query-closed': query.isClosed }"
                                  placeholder="Enter your query"
                                />
                              </div>

                              <!-- Audit Trail -->
                              <div class="audit-trail">
                                <h4>Audit Trail</h4>
                                <div
                                  class="audit-entry"
                                  *ngFor="let entry of query.auditTrail"
                                >
                                  <strong>{{ entry.user }}</strong
                                  >-
                                  {{
                                    entry.timestamp
                                      | date : "dd-MMM-yyyy h:mm a"
                                  }}

                                  <p>{{ entry.message }}</p>
                                </div>
                              </div>
                              <div class="modal-footer">
                                <button
                                  class="btn custom-button"
                                  (click)="confirmCloseQuery(i)"
                                type="button">
                                  Close Query
                                </button>
                                <button
                                  class="btn custom-button ms-2"
                                  (click)="confirmSubmitQuery(i)"
                                 type="button">
                                  Submit
                                </button>
                              </div>
                            </div>
                          </div>

                          <!-- Field History Tab -->
                          <div *ngSwitchCase="'fieldHistory'">
                            <div
                              *ngIf="fieldHistoryData?.length > 0; else noData"
                            >
                              <div
                                *ngFor="let entry of fieldHistoryData"
                                class="history-box"
                              >
                                <div class="history-header">
                                  <strong>{{ entry.updated_by }}</strong> -
                                  {{ entry.updated_at | date : "medium" }}
                                </div>
                                <div class="history-value">
                                  {{ entry.value }}
                                </div>
                                <!-- ✅ Show edit reason if available -->
                                <div
                                  class="edit-reason"
                                  *ngIf="entry.edit_reason"
                                >
                                  <em
                                    >Reason for change:
                                    {{ entry.edit_reason }}</em
                                  >
                                </div>
                              </div>
                            </div>
                            <ng-template #noData>
                              <p>No history available for this field.</p>
                            </ng-template>
                          </div>
                        </ng-container>
                      </div>
                    </div>
                  </div>

                  <!-- UPT Result - Shown only if UPT Done is YES -->
                  <div
                    class=" mt-3"
                    data-label="UPT Result"
                    *ngIf="formData.uptDone === 'YES'"
                  >
                    
                            <div
                    class="label-wrapper d-flex align-items-center justify-content-between"
                  >
                <label>UPT Result</label>


                    <div
                      class="menu-icon"
                      (click)="openOptionsModal($event, $event.target)"
                      style="margin-bottom: 8px;"
                    >
                      ⋮
                    </div>
                  </div>
                    <div
                      class="label-wrapper d-flex align-items-center justify-content-between"
                    >
                      <select
                        class="form-control"
                        [disabled]="isUPTResultDisabled"
                        [(ngModel)]="formData.uptResult"
                        name="uptResult"
                        (change)="handleUptResultChange()"
                        required
                      >
                        <option value="">Select</option>
                        <option value="Positive">Positive</option>
                        <option value="Negative">Negative</option>
                        <option value="Referred for confirmation">
                          Referred for confirmation
                        </option>
                      </select>               
                    </div>
                  </div>
                  <!-- Small Modal (Right-side) -->
                  <div
                    class="options-modal"
                    *ngIf="isOptionsModalOpen && fieldLabel === 'UPT Result'"
                    (click)="$event.stopPropagation()"
                    style="margin-right: 55px; margin-top: 200px"
                  >
                    <div class="modal-buttons">
                      <button type="button" (click)="openModal()">Query</button>
                      <button type="button" (click)="editStudy()">Edit</button>
                      <button type="button" (click)="openReviewModal()">
                        Review
                      </button>
                    </div>
                  </div>
                  <div class="modal-overlay" *ngIf="isReasonModalOpen">
                    <div class="modal-content">
                      <button class="close-btn" (click)="cancelEditReason()">
                        ×
                      </button>
                      <h4>Please provide a reason for editing:</h4>
                      <textarea
                        class="form-control"
                        [(ngModel)]="editReason"
                        rows="4"
                        placeholder="Enter reason here..."
                      ></textarea>
                      <div class="modal-footer">
                        <button
                          class="btn custom-button"
                          (click)="confirmEditReason()"
                        >
                          Confirm
                        </button>
                        <button
                          class="btn custom-button"
                          (click)="cancelEditReason()"
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                <!-- Review Modal -->
<div class="modal-overlay1" *ngIf="showReviewModal" (click)="closeReviewModal()">
  <div
    class="modal-content1"
    (click)="$event.stopPropagation()"
    style="max-width: 370px; position: relative; margin-left: -25px; margin-top: -5px; margin-bottom: -5px;"
  >
    <!-- Close Button -->
    <span class="close-button1" (click)="closeReviewModal()"
      style="position: absolute; top: 1px; right: 16px; font-size: 22px; cursor: pointer; color: #999; z-index: 10;"
    >×</span>

    <div class="checkbox-group" style="padding-top: 1.5rem;">
      <div
        class="form-check"
        style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px; white-space: nowrap;"
      >
        <input
          type="checkbox"
          id="reviewedByDataMonitor"
          name="reviewedByDataMonitor"
          [(ngModel)]="reviewOptions.dataMonitor"
          [disabled]="
          !hasUPTResultData ||
           userDesignation !== 'data monitor'
           "
          (change)="onReviewCheckboxChange()"
          style="display: none;"
        />
        <label
          for="reviewedByDataMonitor"
          style="position: relative; padding-left: 25px; cursor: pointer; font-size: 14px;"
        >
          Reviewed by Data Monitor
          <span
            style="position: absolute; left: 0; top: 2px; width: 20px; height: 20px; border: 2px solid #673AB7; border-radius: 4px; background-color: #fff;"
            [ngStyle]="reviewOptions.dataMonitor ? { backgroundColor: '#673AB7', borderColor: '#673AB7' } : {}"
          ></span>
          <span
            style="position: absolute; left: 7px; top: 5px; width: 6px; height: 12px; border: solid white; border-width: 0 2px 2px 0; transform: rotate(45deg); transition: opacity 0.3s ease;"
            [ngStyle]="reviewOptions.dataMonitor ? { opacity: 1 } : { opacity: 0 }"
          ></span>
        </label>
      </div>
    </div>

    <div class="checkbox-group">
      <div
        class="form-check"
        style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px; white-space: nowrap;"
      >
        <input
          type="checkbox"
          id="reviewedByMonitor"
          name="reviewedByMonitor"
          [(ngModel)]="reviewOptions.monitor"
         [disabled]="
                              !hasUPTResultData ||
                              !reviewOptions.dataMonitor ||
                              userDesignation !== 'monitor'
                            "
          (change)="onReviewCheckboxChange()"
          style="display: none;"
        />
        <label
          for="reviewedByMonitor"
          style="position: relative; padding-left: 25px; cursor: pointer; font-size: 14px;"
        >
          Reviewed by Monitor
          <span
            style="position: absolute; left: 0; top: 2px; width: 20px; height: 20px; border: 2px solid #673AB7; border-radius: 4px; background-color: #fff;"
            [ngStyle]="reviewOptions.monitor ? { backgroundColor: '#673AB7', borderColor: '#673AB7' } : {}"
          ></span>
          <span
            style="position: absolute; left: 7px; top: 5px; width: 6px; height: 12px; border: solid white; border-width: 0 2px 2px 0; transform: rotate(45deg); transition: opacity 0.3s ease;"
            [ngStyle]="reviewOptions.monitor ? { opacity: 1 } : { opacity: 0 }"
          ></span>
        </label>
      </div>
    </div>

    <div class="checkbox-group">
      <div
        class="form-check"
        style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px; white-space: nowrap;"
      >
        <input
          type="checkbox"
          id="reviewedByPI"
          name="reviewedByPI"
          [(ngModel)]="reviewOptions.pi"
          [disabled]="!hasUPTResultData || !reviewOptions.dataMonitor || !reviewOptions.monitor || userDesignation !== 'pi'"
          style="display: none;"
        />
        <label
          for="reviewedByPI"
          style="position: relative; padding-left: 25px; cursor: pointer; font-size: 14px;"
        >
          Reviewed by PI
          <span
            style="position: absolute; left: 0; top: 2px; width: 20px; height: 20px; border: 2px solid #673AB7; border-radius: 4px; background-color: #fff;"
            [ngStyle]="reviewOptions.pi ? { backgroundColor: '#673AB7', borderColor: '#673AB7' } : {}"
          ></span>
          <span
            style="position: absolute; left: 7px; top: 5px; width: 6px; height: 12px; border: solid white; border-width: 0 2px 2px 0; transform: rotate(45deg); transition: opacity 0.3s ease;"
            [ngStyle]="reviewOptions.pi ? { opacity: 1 } : { opacity: 0 }"
          ></span>
        </label>
      </div>
    </div>
  </div>
</div>

                  <div class="modal-overlay" *ngIf="isModalOpen">
                    <div class="modal-content">
                      <button class="close-btn" (click)="closeModal()">
                        &times;
                      </button>

                      <!-- Tab Bar -->
                      <div class="tab-bar">
                        <div
                          class="tab"
                          *ngFor="let tab of tabs; let idx = index"
                          [class.active]="selectedTab === idx"
                          (click)="selectTab(idx)"
                        >
                          {{ tab.title }}
                          <span
                            class="close-tab"
                            *ngIf="tabs.length > 1"
                            (click)="closeTab(idx, $event)"
                            >×</span
                          >
                        </div>

                        <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
                        <div
                          *ngIf="tabs[selectedTab].type === 'query'"
                          class="add-btn-wrapper"
                        >
                          <button  type="button" class="add-btn" (click)="addQuery(i)">
                            +
                          </button>
                          <span class="add-query-tooltip">Add Query</span>
                        </div>
                      </div>

                      <!-- Modal Body -->
                      <div class="modal-body">
                        <ng-container [ngSwitch]="tabs[selectedTab].type">
                          <!-- Query Tab -->
                          <div *ngSwitchCase="'query'">
                            <div
                              *ngFor="let query of queries; let i = index"
                              class="query-box"
                            >
                              <div class="input-checkbox-container">
                                <input
                                  type="text"
                                  class="form-control"
                                  [value]="''"
                                  (input)="query.text = $event.target.value"
                                  [readonly]="query.isClosed"
                                  [ngClass]="{ 'query-closed': query.isClosed }"
                                  placeholder="Enter your query"
                                />
                              </div>

                              <!-- Audit Trail -->
                              <div class="audit-trail">
                                <h4>Audit Trail</h4>
                                <div
                                  class="audit-entry"
                                  *ngFor="let entry of query.auditTrail"
                                >
                                  <strong>{{ entry.user }}</strong
                                  >-
                                  {{
                                    entry.timestamp
                                      | date : "dd-MMM-yyyy h:mm a"
                                  }}

                                  <p>{{ entry.message }}</p>
                                </div>
                              </div>
                              <div class="modal-footer">
                                <button
                                  class="btn custom-button"
                                  (click)="confirmCloseQuery(i)"
                                type="button">
                                  Close Query
                                </button>
                                <button
                                  class="btn custom-button ms-2"
                                  (click)="confirmSubmitQuery(i)"
                                 type="button">
                                  Submit
                                </button>
                              </div>
                            </div>
                          </div>

                          <!-- Field History Tab -->
                          <div *ngSwitchCase="'fieldHistory'">
                            <div
                              *ngIf="fieldHistoryData?.length > 0; else noData"
                            >
                              <div
                                *ngFor="let entry of fieldHistoryData"
                                class="history-box"
                              >
                                <div class="history-header">
                                  <strong>{{ entry.updated_by }}</strong> -
                                  {{ entry.updated_at | date : "medium" }}
                                </div>
                                <div class="history-value">
                                  {{ entry.value }}
                                </div>
                                <!-- ✅ Show edit reason if available -->
                                <div
                                  class="edit-reason"
                                  *ngIf="entry.edit_reason"
                                >
                                  <em
                                    >Reason for change:
                                    {{ entry.edit_reason }}</em
                                  >
                                </div>
                              </div>
                            </div>
                            <ng-template #noData>
                              <p>No history available for this field.</p>
                            </ng-template>
                          </div>
                        </ng-container>
                      </div>
                    </div>
                  </div>
                </div>

               <div class="text-end">
                   <!--<button type="button" class="btn custom-button" (click)="goBack()">Back</button> -->
                  <button type="submit" class="btn custom-button">
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>

          <!-- Laboratory Investigation Form -->
          <div
            *ngIf="formName === 'baseline-lab-investigation'"
            class="card mt-4"
          >
            <div
              class="card-header d-flex justify-content-between align-items-center"
            >
              <h5 class="m-0">Laboratory Investigation</h5>
              <!--<button type="button" class="btn custom-button">Create Field</button>-->
            </div>

            <div class="card-body">
              <form (ngSubmit)="submitForm()">
                <div
                  class="form-group"
                  data-label="1. Was Laboratory Investigation performed"
                >
                  
                        <div
                    class="label-wrapper d-flex align-items-center justify-content-between"
                  >
                <label>1. Was Laboratory Investigation performed?</label>


                    <div
                      class="menu-icon"
                      (click)="openOptionsModal($event, $event.target)"
                    >
                      ⋮
                    </div>
                  </div>
                  <div
                    class="label-wrapper d-flex align-items-center justify-content-between"
                  >
                    <div class="radio-group">
                      <label class="radio-label">
                        <input
                          type="radio"
                          [disabled]="isLabDisabled"
                          id="labYes"
                          name="labInvestigation"
                          value="yes"
                          [(ngModel)]="formData.labInvestigation"
                          (change)="checkLabInvestigation()"
                          required
                        />
                        <span>Yes</span>
                      </label>
                      <label class="radio-label">
                        <input
                          type="radio"
                          [disabled]="isLabDisabled"
                          id="labNo"
                          name="labInvestigation"
                          value="no"
                          [(ngModel)]="formData.labInvestigation"
                          (change)="checkLabInvestigation()"
                          required
                        />
                        <span>No</span>
                      </label>
                    </div>     
                  </div>
                </div>
                <!-- Small Modal (Right-side) -->
                <div
                  class="options-modal"
                  *ngIf="
                    isOptionsModalOpen &&
                    fieldLabel === '1. Was Laboratory Investigation performed'
                  "
                  (click)="$event.stopPropagation()"
                  style="margin-right: 55px; margin-top: 40px"
                >
                  <div class="modal-buttons">
                    <button type="button" (click)="openModal()">Query</button>
                    <button type="button" (click)="editStudy()">Edit</button>
                    <button type="button" (click)="openReviewModal()">
                      Review
                    </button>
                  </div>
                </div>
                <div class="modal-overlay" *ngIf="isReasonModalOpen">
                  <div class="modal-content">
                    <button class="close-btn" (click)="cancelEditReason()">
                      ×
                    </button>
                    <h4>Please provide a reason for editing:</h4>
                    <textarea
                      class="form-control"
                      [(ngModel)]="editReason"
                      rows="4"
                      placeholder="Enter reason here..."
                    ></textarea>
                    <div class="modal-footer">
                      <button
                        class="btn custom-button"
                        (click)="confirmEditReason()"
                      >
                        Confirm
                      </button>
                      <button
                        class="btn custom-button"
                        (click)="cancelEditReason()"
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
               <!-- Review Modal -->
<div
  class="modal-overlay1"
  *ngIf="showReviewModal"
  (click)="closeReviewModal()"
>
  <!-- Close Button -->
  <span
    class="close-button1"
    (click)="closeReviewModal()"
    style="position: absolute; top: 1px; right: 16px; font-size: 22px; cursor: pointer; color: #999; z-index: 10;"
    >×</span
  >

  <div
    class="modal-content1"
    (click)="$event.stopPropagation()"
    style="max-width: 370px; position: relative; margin-left: -25px; margin-top: -5px; margin-bottom: -5px;"
  >
    <div class="checkbox-group">
      <div
        class="form-check"
        style="display: flex; align-items: center; gap: 10px; margin-top: 25px; margin-bottom: 10px; white-space: nowrap;"
      >
        <input
          type="checkbox"
          id="reviewedByDataMonitor"
          name="reviewedByDataMonitor"
          [(ngModel)]="reviewOptions.dataMonitor"
          [disabled]="
            !hasLabInvestigationData ||
            userDesignation !== 'data monitor'
          "
          (change)="onReviewCheckboxChange()"
          style="display: none;"
        />
        <label
          for="reviewedByDataMonitor"
          style="position: relative; padding-left: 25px; cursor: pointer; font-size: 14px;"
        >
          Reviewed by Data Monitor
          <span
            style="position: absolute; left: 0; top: 2px; width: 20px; height: 20px; border: 2px solid #673AB7; border-radius: 4px; background-color: #fff;"
            [ngStyle]="reviewOptions.dataMonitor ? { backgroundColor: '#673AB7', borderColor: '#673AB7' } : {}"
          ></span>
          <span
            style="position: absolute; left: 7px; top: 5px; width: 6px; height: 12px; border: solid white; border-width: 0 2px 2px 0; transform: rotate(45deg); transition: opacity 0.3s ease;"
            [ngStyle]="reviewOptions.dataMonitor ? { opacity: 1 } : { opacity: 0 }"
          ></span>
        </label>
      </div>
    </div>

    <div class="checkbox-group">
      <div
        class="form-check"
        style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px; white-space: nowrap;"
      >
        <input
          type="checkbox"
          id="reviewedByMonitor"
          name="reviewedByMonitor"
          [(ngModel)]="reviewOptions.monitor"
          [disabled]="
            !hasLabInvestigationData ||
            !reviewOptions.dataMonitor ||
            userDesignation !== 'monitor'
          "
          (change)="onReviewCheckboxChange()"
          style="display: none;"
        />
        <label
          for="reviewedByMonitor"
          style="position: relative; padding-left: 25px; cursor: pointer; font-size: 14px;"
        >
          Reviewed by Monitor
          <span
            style="position: absolute; left: 0; top: 2px; width: 20px; height: 20px; border: 2px solid #673AB7; border-radius: 4px; background-color: #fff;"
            [ngStyle]="reviewOptions.monitor ? { backgroundColor: '#673AB7', borderColor: '#673AB7' } : {}"
          ></span>
          <span
            style="position: absolute; left: 7px; top: 5px; width: 6px; height: 12px; border: solid white; border-width: 0 2px 2px 0; transform: rotate(45deg); transition: opacity 0.3s ease;"
            [ngStyle]="reviewOptions.monitor ? { opacity: 1 } : { opacity: 0 }"
          ></span>
        </label>
      </div>
    </div>

    <div class="checkbox-group">
      <div
        class="form-check"
        style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px; white-space: nowrap;"
      >
        <input
          type="checkbox"
          id="reviewedByPI"
          name="reviewedByPI"
          [(ngModel)]="reviewOptions.pi"
          [disabled]="
            !hasLabInvestigationData ||
            !reviewOptions.dataMonitor ||
            !reviewOptions.monitor ||
            userDesignation !== 'pi'
          "
          style="display: none;"
        />
        <label
          for="reviewedByPI"
          style="position: relative; padding-left: 25px; cursor: pointer; font-size: 14px;"
        >
          Reviewed by PI
          <span
            style="position: absolute; left: 0; top: 2px; width: 20px; height: 20px; border: 2px solid #673AB7; border-radius: 4px; background-color: #fff;"
            [ngStyle]="reviewOptions.pi ? { backgroundColor: '#673AB7', borderColor: '#673AB7' } : {}"
          ></span>
          <span
            style="position: absolute; left: 7px; top: 5px; width: 6px; height: 12px; border: solid white; border-width: 0 2px 2px 0; transform: rotate(45deg); transition: opacity 0.3s ease;"
            [ngStyle]="reviewOptions.pi ? { opacity: 1 } : { opacity: 0 }"
          ></span>
        </label>
      </div>
    </div>
  </div>
</div>

                <div class="modal-overlay" *ngIf="isModalOpen">
                  <div class="modal-content">
                    <button class="close-btn" (click)="closeModal()">
                      &times;
                    </button>

                    <!-- Tab Bar -->
                    <div class="tab-bar">
                      <div
                        class="tab"
                        *ngFor="let tab of tabs; let idx = index"
                        [class.active]="selectedTab === idx"
                        (click)="selectTab(idx)"
                      >
                        {{ tab.title }}
                        <span
                          class="close-tab"
                          *ngIf="tabs.length > 1"
                          (click)="closeTab(idx, $event)"
                          >×</span
                        >
                      </div>

                      <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
                      <div
                        *ngIf="tabs[selectedTab].type === 'query'"
                        class="add-btn-wrapper"
                      >
                        <button  type="button" class="add-btn" (click)="addQuery(i)">+</button>
                        <span class="add-query-tooltip">Add Query</span>
                      </div>
                    </div>

                    <!-- Modal Body -->
                    <div class="modal-body">
                      <ng-container [ngSwitch]="tabs[selectedTab].type">
                        <!-- Query Tab -->
                        <div *ngSwitchCase="'query'">
                          <div
                            *ngFor="let query of queries; let i = index"
                            class="query-box"
                          >
                            <div class="input-checkbox-container">
                              <input
                                type="text"
                                class="form-control"
                                [value]="''"
                                (input)="query.text = $event.target.value"
                                [readonly]="query.isClosed"
                                [ngClass]="{ 'query-closed': query.isClosed }"
                                placeholder="Enter your query"
                              />
                            </div>

                            <!-- Audit Trail -->
                            <div class="audit-trail">
                              <h4>Audit Trail</h4>
                              <div
                                class="audit-entry"
                                *ngFor="let entry of query.auditTrail"
                              >
                                <strong>{{ entry.user }}</strong
                                >-
                                {{
                                  entry.timestamp | date : "dd-MMM-yyyy h:mm a"
                                }}

                                <p>{{ entry.message }}</p>
                              </div>
                            </div>
                            <div class="modal-footer">
                              <button
                                class="btn custom-button"
                                (click)="confirmCloseQuery(i)"
                              >
                                Close Query
                              </button>
                              <button
                                class="btn custom-button ms-2"
                                (click)="confirmSubmitQuery(i)"
                              >
                                Submit
                              </button>
                            </div>
                          </div>
                        </div>

                        <!-- Field History Tab -->
                        <div *ngSwitchCase="'fieldHistory'">
                          <div
                            *ngIf="fieldHistoryData?.length > 0; else noData"
                          >
                            <div
                              *ngFor="let entry of fieldHistoryData"
                              class="history-box"
                            >
                              <div class="history-header">
                                <strong>{{ entry.updated_by }}</strong> -
                                {{ entry.updated_at | date : "medium" }}
                              </div>
                              <div class="history-value">
                                {{ entry.value }}
                              </div>
                              <!-- ✅ Show edit reason if available -->
                              <div
                                class="edit-reason"
                                *ngIf="entry.edit_reason"
                              >
                                <em
                                  >Reason for change:
                                  {{ entry.edit_reason }}</em
                                >
                              </div>
                            </div>
                          </div>
                          <ng-template #noData>
                            <p>No history available for this field.</p>
                          </ng-template>
                        </div>
                      </ng-container>
                    </div>
                  </div>
                </div>
                <div class="mt-3" *ngIf="formData.labInvestigation === 'no'">
                  <label>Comments:</label>
                  <textarea
                    class="form-control"
                    [(ngModel)]="formData.labInvestigationComments"
                    name="labInvestigationComments"
                  ></textarea>
                </div>
                <!-- Show the button only when "Yes" is selected -->
                <div class="mt-3" *ngIf="formData.labInvestigation === 'yes'">
                  <button
                    type="button"
                    class="btn btn-success"
                    (click)="navigateToLaboratory()"
                  >
                    Add Laboratory Investigation Data
                  </button>
                </div>

                <div class="mt-4" *ngIf="formData.labInvestigation === 'yes'">
                  <label>2. Date of Sample Collection:</label>
                  <input
                    type="date"
                    class="form-control"
                    [(ngModel)]="formData.sampleCollectionDate"
                    name="sampleCollectionDate"
                    required
                  />
                </div>

               <div class="text-end">
                   <!--<button type="button" class="btn custom-button" (click)="goBack()">Back</button> -->
                  <button type="submit" class="btn custom-button">
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>

          <!-- Anthropometric Data Form -->
          <div
            *ngIf="formName === 'baseline-anthropometric-data'"
            class="card mt-4"
          >
            <div
              class="card-header d-flex justify-content-between align-items-center"
            >
              <h5 class="m-0">Anthropometric Data</h5>
              <!--<button type="button" class="btn custom-button">Create Field</button>-->
            </div>

            <div class="card-body">
              <form (ngSubmit)="validateForm()" #form="ngForm">
                <!-- Weight Field -->
                <div class="form-group" data-label="1. Weight:">
                 
                                    <div
                    class="label-wrapper d-flex align-items-center justify-content-between"
                  >
                 <label for="weight">1. Weight (kg):</label>


                    <div
                      class="menu-icon"
                      (click)="openOptionsModal($event, $event.target)"
                      style="margin-bottom: 8px;"
                    >
                      ⋮
                    </div>
                  </div>
                  <div
                    class="label-wrapper d-flex align-items-center justify-content-between"
                  >
                    <input
                      type="text"
                      id="weight"
                      [disabled]="isWeightDisabled"
                      [(ngModel)]="formData.weight"
                      name="weight"
                      class="form-control"
                      placeholder="000.00 kg"
                      pattern="^\d{3}\.\d{2}$"
                      (input)="calculateBMI()"
                      #weight="ngModel"
                    />
                  </div>
                  <!-- Small Modal (Right-side) -->
                  <div
                    class="options-modal"
                    *ngIf="isOptionsModalOpen && fieldLabel === '1. Weight:'"
                    (click)="$event.stopPropagation()"
                    style="margin-right: 55px; margin-top: 40px"
                  >
                    <div class="modal-buttons">
                      <button type="button" (click)="openModal()">Query</button>
                      <button type="button" (click)="editStudy()">Edit</button>
                      <button type="button" (click)="openReviewModal()">
                        Review
                      </button>
                    </div>
                  </div>
                  <div class="modal-overlay" *ngIf="isReasonModalOpen">
                    <div class="modal-content">
                      <button class="close-btn" (click)="cancelEditReason()">
                        ×
                      </button>
                      <h4>Please provide a reason for editing:</h4>
                      <textarea
                        class="form-control"
                        [(ngModel)]="editReason"
                        rows="4"
                        placeholder="Enter reason here..."
                      ></textarea>
                      <div class="modal-footer">
                        <button
                          class="btn custom-button"
                          (click)="confirmEditReason()"
                        >
                          Confirm
                        </button>
                        <button
                          class="btn custom-button"
                          (click)="cancelEditReason()"
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>

                  <!-- Review Modal -->
                  <div
                    class="modal-overlay1"
                    *ngIf="showReviewModal"
                    (click)="closeReviewModal()"
                  >
                    <!-- Close Button -->
                    <span class="close-button1" (click)="closeReviewModal()"
                      >×</span
                    >
                    <div
                      class="modal-content1"
                      (click)="$event.stopPropagation()"
                    >
                      <div class="checkbox-group">
                        <div class="form-check" style="margin-top: 20px">
                          <input
                            type="checkbox"
                            id="reviewedByDataMonitor"
                            name="reviewedByDataMonitor"
                            [(ngModel)]="reviewOptions.dataMonitor"
                            [disabled]="
                              !hasWeightData ||
                              userDesignation !== 'data monitor'
                            "
                            (change)="onReviewCheckboxChange()"
                          />
                          <label for="reviewedByDataMonitor"
                            >Reviewed by Data Monitor</label
                          >
                        </div>
                      </div>
                      <div class="checkbox-group">
                        <div class="form-check">
                          <input
                            type="checkbox"
                            id="reviewedByMonitor"
                            name="reviewedByMonitor"
                            [(ngModel)]="reviewOptions.monitor"
                            [disabled]="
                              !hasWeightData ||
                              !reviewOptions.dataMonitor ||
                              userDesignation !== 'monitor'
                            "
                            (change)="onReviewCheckboxChange()"
                          />
                          <label for="reviewedByMonitor"
                            >Reviewed by Monitor</label
                          >
                        </div>
                      </div>
                      <div class="checkbox-group">
                        <div class="form-check">
                          <input
                            type="checkbox"
                            id="reviewedByPI"
                            name="reviewedByPI"
                            [(ngModel)]="reviewOptions.pi"
                            [disabled]="
                              !hasWeightData ||
                              !reviewOptions.dataMonitor ||
                              !reviewOptions.monitor ||
                              userDesignation !== 'pi'
                            "
                          />
                          <label for="reviewedByPI">Reviewed by PI</label>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="modal-overlay" *ngIf="isModalOpen">
                    <div class="modal-content">
                      <button class="close-btn" (click)="closeModal()">
                        &times;
                      </button>

                      <!-- Tab Bar -->
                      <div class="tab-bar">
                        <div
                          class="tab"
                          *ngFor="let tab of tabs; let idx = index"
                          [class.active]="selectedTab === idx"
                          (click)="selectTab(idx)"
                        >
                          {{ tab.title }}
                          <span
                            class="close-tab"
                            *ngIf="tabs.length > 1"
                            (click)="closeTab(idx, $event)"
                            >×</span
                          >
                        </div>

                        <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
                        <div
                          *ngIf="tabs[selectedTab].type === 'query'"
                          class="add-btn-wrapper"
                        >
                          <button  type="button" class="add-btn" (click)="addQuery(i)">
                            +
                          </button>
                          <span class="add-query-tooltip">Add Query</span>
                        </div>
                      </div>

                      <!-- Modal Body -->
                      <div class="modal-body">
                        <ng-container [ngSwitch]="tabs[selectedTab].type">
                          <!-- Query Tab -->
                          <div *ngSwitchCase="'query'">
                            <div
                              *ngFor="let query of queries; let i = index"
                              class="query-box"
                            >
                              <div class="input-checkbox-container">
                                <input
                                  type="text"
                                  class="form-control"
                                  [value]="''"
                                  (input)="query.text = $event.target.value"
                                  [readonly]="query.isClosed"
                                  [ngClass]="{ 'query-closed': query.isClosed }"
                                  placeholder="Enter your query"
                                />
                              </div>

                              <!-- Audit Trail -->
                              <div class="audit-trail">
                                <h4>Audit Trail</h4>
                                <div
                                  class="audit-entry"
                                  *ngFor="let entry of query.auditTrail"
                                >
                                  <strong>{{ entry.user }}</strong
                                  >-
                                  {{
                                    entry.timestamp
                                      | date : "dd-MMM-yyyy h:mm a"
                                  }}

                                  <p>{{ entry.message }}</p>
                                </div>
                              </div>
                              <div class="modal-footer">
                                <button
                                  class="btn custom-button"
                                  (click)="confirmCloseQuery(i)"
                                type="button">
                                  Close Query
                                </button>
                                <button
                                  class="btn custom-button ms-2"
                                  (click)="confirmSubmitQuery(i)"
                                 type="button">
                                  Submit
                                </button>
                              </div>
                            </div>
                          </div>

                          <!-- Field History Tab -->
                          <div *ngSwitchCase="'fieldHistory'">
                            <div
                              *ngIf="fieldHistoryData?.length > 0; else noData"
                            >
                              <div
                                *ngFor="let entry of fieldHistoryData"
                                class="history-box"
                              >
                                <div class="history-header">
                                  <strong>{{ entry.updated_by }}</strong> -
                                  {{ entry.updated_at | date : "medium" }}
                                </div>
                                <div class="history-value">
                                  {{ entry.value }}
                                </div>
                                <!-- ✅ Show edit reason if available -->
                                <div
                                  class="edit-reason"
                                  *ngIf="entry.edit_reason"
                                >
                                  <em
                                    >Reason for change:
                                    {{ entry.edit_reason }}</em
                                  >
                                </div>
                              </div>
                            </div>
                            <ng-template #noData>
                              <p>No history available for this field.</p>
                            </ng-template>
                          </div>
                        </ng-container>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Height Field -->
                <div class="form-group mt-2" data-label="2. Height:">
                                                    <div
                    class="label-wrapper d-flex align-items-center justify-content-between"
                  >
                               <label for="height">2. Height (m):</label>



                    <div
                      class="menu-icon"
                      (click)="openOptionsModal($event, $event.target)"
                      style="margin-bottom: 8px;"
                    >
                      ⋮
                    </div>
                  </div>
                  <div
                    class="label-wrapper d-flex align-items-center justify-content-between"
                  >
                    <input
                      type="text"
                      id="height"
                      [disabled]="isHeightDisabled"
                      [(ngModel)]="formData.height"
                      name="height"
                      class="form-control"
                      placeholder="00.00 m"
                      pattern="^\d{2}\.\d{2}$"
                      (input)="calculateBMI()"
                      #height="ngModel"
                    />
                  </div>
                  <!-- Small Modal (Right-side) -->
                  <div
                    class="options-modal"
                    *ngIf="isOptionsModalOpen && fieldLabel === '2. Height:'"
                    (click)="$event.stopPropagation()"
                    style="margin-right: 55px; margin-top: 142px"
                  >
                    <div class="modal-buttons">
                      <button type="button" (click)="openModal()">Query</button>
                      <button type="button" (click)="editStudy()">Edit</button>
                      <button type="button" (click)="openReviewModal()">
                        Review
                      </button>
                    </div>
                  </div>
                  <div class="modal-overlay" *ngIf="isReasonModalOpen">
                    <div class="modal-content">
                      <button class="close-btn" (click)="cancelEditReason()">
                        ×
                      </button>
                      <h4>Please provide a reason for editing:</h4>
                      <textarea
                        class="form-control"
                        [(ngModel)]="editReason"
                        rows="4"
                        placeholder="Enter reason here..."
                      ></textarea>
                      <div class="modal-footer">
                        <button
                          class="btn custom-button"
                          (click)="confirmEditReason()"
                        >
                          Confirm
                        </button>
                        <button
                          class="btn custom-button"
                          (click)="cancelEditReason()"
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                  <!-- Review Modal -->
                  <div
                    class="modal-overlay1"
                    *ngIf="showReviewModal"
                    (click)="closeReviewModal()"
                  >
                    <!-- Close Button -->
                    <span class="close-button1" (click)="closeReviewModal()"
                      >×</span
                    >
                    <div
                      class="modal-content1"
                      (click)="$event.stopPropagation()"
                    >
                      <div class="checkbox-group">
                        <div class="form-check" style="margin-top: 20px">
                          <input
                            type="checkbox"
                            id="reviewedByDataMonitor"
                            name="reviewedByDataMonitor"
                            [(ngModel)]="reviewOptions.dataMonitor"
                            [disabled]="
                              !hasHeightData ||
                              userDesignation !== 'data monitor'
                            "
                            (change)="onReviewCheckboxChange()"
                          />
                          <label for="reviewedByDataMonitor"
                            >Reviewed by Data Monitor</label
                          >
                        </div>
                      </div>
                      <div class="checkbox-group">
                        <div class="form-check">
                          <input
                            type="checkbox"
                            id="reviewedByMonitor"
                            name="reviewedByMonitor"
                            [(ngModel)]="reviewOptions.monitor"
                            [disabled]="
                              !hasHeightData ||
                              !reviewOptions.dataMonitor ||
                              userDesignation !== 'monitor'
                            "
                            (change)="onReviewCheckboxChange()"
                          />
                          <label for="reviewedByMonitor"
                            >Reviewed by Monitor</label
                          >
                        </div>
                      </div>
                      <div class="checkbox-group">
                        <div class="form-check">
                          <input
                            type="checkbox"
                            id="reviewedByPI"
                            name="reviewedByPI"
                            [(ngModel)]="reviewOptions.pi"
                            [disabled]="
                              !hasHeightData ||
                              !reviewOptions.dataMonitor ||
                              !reviewOptions.monitor ||
                              userDesignation !== 'pi'
                            "
                          />
                          <label for="reviewedByPI">Reviewed by PI</label>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="modal-overlay" *ngIf="isModalOpen">
                    <div class="modal-content">
                      <button class="close-btn" (click)="closeModal()">
                        &times;
                      </button>

                      <!-- Tab Bar -->
                      <div class="tab-bar">
                        <div
                          class="tab"
                          *ngFor="let tab of tabs; let idx = index"
                          [class.active]="selectedTab === idx"
                          (click)="selectTab(idx)"
                        >
                          {{ tab.title }}
                          <span
                            class="close-tab"
                            *ngIf="tabs.length > 1"
                            (click)="closeTab(idx, $event)"
                            >×</span
                          >
                        </div>

                        <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
                        <div
                          *ngIf="tabs[selectedTab].type === 'query'"
                          class="add-btn-wrapper"
                        >
                          <button  type="button" class="add-btn" (click)="addQuery(i)">
                            +
                          </button>
                          <span class="add-query-tooltip">Add Query</span>
                        </div>
                      </div>

                      <!-- Modal Body -->
                      <div class="modal-body">
                        <ng-container [ngSwitch]="tabs[selectedTab].type">
                          <!-- Query Tab -->
                          <div *ngSwitchCase="'query'">
                            <div
                              *ngFor="let query of queries; let i = index"
                              class="query-box"
                            >
                              <div class="input-checkbox-container">
                                <input
                                  type="text"
                                  class="form-control"
                                  [value]="''"
                                  (input)="query.text = $event.target.value"
                                  [readonly]="query.isClosed"
                                  [ngClass]="{ 'query-closed': query.isClosed }"
                                  placeholder="Enter your query"
                                />
                              </div>

                              <!-- Audit Trail -->
                              <div class="audit-trail">
                                <h4>Audit Trail</h4>
                                <div
                                  class="audit-entry"
                                  *ngFor="let entry of query.auditTrail"
                                >
                                  <strong>{{ entry.user }}</strong
                                  >-
                                  {{
                                    entry.timestamp
                                      | date : "dd-MMM-yyyy h:mm a"
                                  }}

                                  <p>{{ entry.message }}</p>
                                </div>
                              </div>
                              <div class="modal-footer">
                                <button
                                  class="btn custom-button"
                                  (click)="confirmCloseQuery(i)"
                                type="button">
                                  Close Query
                                </button>
                                <button
                                  class="btn custom-button ms-2"
                                  (click)="confirmSubmitQuery(i)"
                                 type="button">
                                  Submit
                                </button>
                              </div>
                            </div>
                          </div>

                          <!-- Field History Tab -->
                          <div *ngSwitchCase="'fieldHistory'">
                            <div
                              *ngIf="fieldHistoryData?.length > 0; else noData"
                            >
                              <div
                                *ngFor="let entry of fieldHistoryData"
                                class="history-box"
                              >
                                <div class="history-header">
                                  <strong>{{ entry.updated_by }}</strong> -
                                  {{ entry.updated_at | date : "medium" }}
                                </div>
                                <div class="history-value">
                                  {{ entry.value }}
                                </div>
                                <!-- ✅ Show edit reason if available -->
                                <div
                                  class="edit-reason"
                                  *ngIf="entry.edit_reason"
                                >
                                  <em
                                    >Reason for change:
                                    {{ entry.edit_reason }}</em
                                  >
                                </div>
                              </div>
                            </div>
                            <ng-template #noData>
                              <p>No history available for this field.</p>
                            </ng-template>
                          </div>
                        </ng-container>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Waist Circumference Field -->
                <div
                  class="form-group mt-2"
                  data-label="3. Waist circumference (part of IDRS Assessment):"
                >
             
                       <div
                    class="label-wrapper d-flex align-items-center justify-content-between"
                  >
                                   <label for="waist"
                    >3. Waist Circumference (cm) (Part of IDRS
                    Assessment):</label
                  >



                    <div
                      class="menu-icon"
                      (click)="openOptionsModal($event, $event.target)"
                      style="margin-bottom: 8px;"
                    >
                      ⋮
                    </div>
                  </div>
                  <div
                    class="label-wrapper d-flex align-items-center justify-content-between"
                  >
                    <input
                      type="text"
                      id="waist"
                      [disabled]="isWaistDisabled"
                      [(ngModel)]="formData.waistCircumference"
                      name="waistCircumference"
                      class="form-control"
                      placeholder="000.00 cm"
                      pattern="^\d{3}\.\d{2}$"
                      #waist="ngModel"
                    />            
                  </div>
                  <!-- Small Modal (Right-side) -->
                  <div
                    class="options-modal"
                    *ngIf="
                      isOptionsModalOpen &&
                      fieldLabel ===
                        '3. Waist circumference (part of IDRS Assessment):'
                    "
                    (click)="$event.stopPropagation()"
                    style="margin-right: 55px; margin-top: 240px"
                  >
                    <div class="modal-buttons">
                      <button type="button" (click)="openModal()">Query</button>
                      <button type="button" (click)="editStudy()">Edit</button>
                      <button type="button" (click)="openReviewModal()">
                        Review
                      </button>
                    </div>
                  </div>
                  <div class="modal-overlay" *ngIf="isReasonModalOpen">
                    <div class="modal-content">
                      <button class="close-btn" (click)="cancelEditReason()">
                        ×
                      </button>
                      <h4>Please provide a reason for editing:</h4>
                      <textarea
                        class="form-control"
                        [(ngModel)]="editReason"
                        rows="4"
                        placeholder="Enter reason here..."
                      ></textarea>
                      <div class="modal-footer">
                        <button
                          class="btn custom-button"
                          (click)="confirmEditReason()"
                        >
                          Confirm
                        </button>
                        <button
                          class="btn custom-button"
                          (click)="cancelEditReason()"
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                  <!-- Review Modal -->
                  <div
                    class="modal-overlay1"
                    *ngIf="showReviewModal"
                    (click)="closeReviewModal()"
                  >
                    <!-- Close Button -->
                    <span class="close-button1" (click)="closeReviewModal()"
                      >×</span
                    >
                    <div
                      class="modal-content1"
                      (click)="$event.stopPropagation()"
                    >
                      <div class="checkbox-group">
                        <div class="form-check" style="margin-top: 20px">
                          <input
                            type="checkbox"
                            id="reviewedByDataMonitor"
                            name="reviewedByDataMonitor"
                            [(ngModel)]="reviewOptions.dataMonitor"
                            [disabled]="
                              !hasWaistData ||
                              userDesignation !== 'data monitor'
                            "
                            (change)="onReviewCheckboxChange()"
                          />
                          <label for="reviewedByDataMonitor"
                            >Reviewed by Data Monitor</label
                          >
                        </div>
                      </div>
                      <div class="checkbox-group">
                        <div class="form-check">
                          <input
                            type="checkbox"
                            id="reviewedByMonitor"
                            name="reviewedByMonitor"
                            [(ngModel)]="reviewOptions.monitor"
                            [disabled]="
                              !hasWaistData ||
                              !reviewOptions.dataMonitor ||
                              userDesignation !== 'monitor'
                            "
                            (change)="onReviewCheckboxChange()"
                          />
                          <label for="reviewedByMonitor"
                            >Reviewed by Monitor</label
                          >
                        </div>
                      </div>
                      <div class="checkbox-group">
                        <div class="form-check">
                          <input
                            type="checkbox"
                            id="reviewedByPI"
                            name="reviewedByPI"
                            [(ngModel)]="reviewOptions.pi"
                            [disabled]="
                              !hasWaistData ||
                              !reviewOptions.dataMonitor ||
                              !reviewOptions.monitor ||
                              userDesignation !== 'pi'
                            "
                          />
                          <label for="reviewedByPI">Reviewed by PI</label>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="modal-overlay" *ngIf="isModalOpen">
                    <div class="modal-content">
                      <button class="close-btn" (click)="closeModal()">
                        &times;
                      </button>

                      <!-- Tab Bar -->
                      <div class="tab-bar">
                        <div
                          class="tab"
                          *ngFor="let tab of tabs; let idx = index"
                          [class.active]="selectedTab === idx"
                          (click)="selectTab(idx)"
                        >
                          {{ tab.title }}
                          <span
                            class="close-tab"
                            *ngIf="tabs.length > 1"
                            (click)="closeTab(idx, $event)"
                            >×</span
                          >
                        </div>

                        <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
                        <div
                          *ngIf="tabs[selectedTab].type === 'query'"
                          class="add-btn-wrapper"
                        >
                          <button  type="button" class="add-btn" (click)="addQuery(i)">
                            +
                          </button>
                          <span class="add-query-tooltip">Add Query</span>
                        </div>
                      </div>

                      <!-- Modal Body -->
                      <div class="modal-body">
                        <ng-container [ngSwitch]="tabs[selectedTab].type">
                          <!-- Query Tab -->
                          <div *ngSwitchCase="'query'">
                            <div
                              *ngFor="let query of queries; let i = index"
                              class="query-box"
                            >
                              <div class="input-checkbox-container">
                                <input
                                  type="text"
                                  class="form-control"
                                  [value]="''"
                                  (input)="query.text = $event.target.value"
                                  [readonly]="query.isClosed"
                                  [ngClass]="{ 'query-closed': query.isClosed }"
                                  placeholder="Enter your query"
                                />
                              </div>

                              <!-- Audit Trail -->
                              <div class="audit-trail">
                                <h4>Audit Trail</h4>
                                <div
                                  class="audit-entry"
                                  *ngFor="let entry of query.auditTrail"
                                >
                                  <strong>{{ entry.user }}</strong
                                  >-
                                  {{
                                    entry.timestamp
                                      | date : "dd-MMM-yyyy h:mm a"
                                  }}

                                  <p>{{ entry.message }}</p>
                                </div>
                              </div>
                              <div class="modal-footer">
                                <button
                                  class="btn custom-button"
                                  (click)="confirmCloseQuery(i)"
                                type="button">
                                  Close Query
                                </button>
                                <button
                                  class="btn custom-button ms-2"
                                  (click)="confirmSubmitQuery(i)"
                                 type="button">
                                  Submit
                                </button>
                              </div>
                            </div>
                          </div>

                          <!-- Field History Tab -->
                          <div *ngSwitchCase="'fieldHistory'">
                            <div
                              *ngIf="fieldHistoryData?.length > 0; else noData"
                            >
                              <div
                                *ngFor="let entry of fieldHistoryData"
                                class="history-box"
                              >
                                <div class="history-header">
                                  <strong>{{ entry.updated_by }}</strong> -
                                  {{ entry.updated_at | date : "medium" }}
                                </div>
                                <div class="history-value">
                                  {{ entry.value }}
                                </div>
                                <!-- ✅ Show edit reason if available -->
                                <div
                                  class="edit-reason"
                                  *ngIf="entry.edit_reason"
                                >
                                  <em
                                    >Reason for change:
                                    {{ entry.edit_reason }}</em
                                  >
                                </div>
                              </div>
                            </div>
                            <ng-template #noData>
                              <p>No history available for this field.</p>
                            </ng-template>
                          </div>
                        </ng-container>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- BMI (Auto-Calculated) -->
                <div
                  class="form-group mt-2"
                  data-label="4. Body Mass Index [BMI = Weight (kg)/ Height2 (m)]:"
                >         
                      <div
                    class="label-wrapper d-flex align-items-center justify-content-between"
                  >
  <label for="bmi">4. Body Mass Index (BMI):</label>
                    <div
                      class="menu-icon"
                      (click)="openOptionsModal($event, $event.target)"
                      style="margin-bottom: 8px;"
                    >
                      ⋮
                    </div>
                  </div>
                  <div
                    class="label-wrapper d-flex align-items-center justify-content-between"
                  >
                    <input
                      type="text"
                      [disabled]="isBMIDisabled"
                      id="bmi"
                      [(ngModel)]="formData.bmi"
                      name="bmi"
                      class="form-control"
                      placeholder="00.0 BMI"
                      readonly
                    />
                
                  </div>
                  <!-- Small Modal (Right-side) -->
                  <div
                    class="options-modal"
                    *ngIf="
                      isOptionsModalOpen &&
                      fieldLabel ===
                        '4. Body Mass Index [BMI = Weight (kg)/ Height2 (m)]:'
                    "
                    (click)="$event.stopPropagation()"
                    style="margin-right: 55px; margin-top: 340px"
                  >
                    <div class="modal-buttons">
                      <button type="button" (click)="openModal()">Query</button>
                      <button type="button" (click)="editStudy()">Edit</button>
                      <button type="button" (click)="openReviewModal()">
                        Review
                      </button>
                    </div>
                  </div>
                  <div class="modal-overlay" *ngIf="isReasonModalOpen">
                    <div class="modal-content">
                      <button class="close-btn" (click)="cancelEditReason()">
                        ×
                      </button>
                      <h4>Please provide a reason for editing:</h4>
                      <textarea
                        class="form-control"
                        [(ngModel)]="editReason"
                        rows="4"
                        placeholder="Enter reason here..."
                      ></textarea>
                      <div class="modal-footer">
                        <button
                          class="btn custom-button"
                          (click)="confirmEditReason()"
                        >
                          Confirm
                        </button>
                        <button
                          class="btn custom-button"
                          (click)="cancelEditReason()"
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                  <!-- Review Modal -->
                  <div
                    class="modal-overlay1"
                    *ngIf="showReviewModal"
                    (click)="closeReviewModal()"
                  >
                    <!-- Close Button -->
                    <span class="close-button1" (click)="closeReviewModal()"
                      >×</span
                    >
                    <div
                      class="modal-content1"
                      (click)="$event.stopPropagation()"
                    >
                      <div class="checkbox-group">
                        <div class="form-check" style="margin-top: 20px">
                          <input
                            type="checkbox"
                            id="reviewedByDataMonitor"
                            name="reviewedByDataMonitor"
                            [(ngModel)]="reviewOptions.dataMonitor"
                            [disabled]="
                              !hasBMIData || userDesignation !== 'data monitor'
                            "
                            (change)="onReviewCheckboxChange()"
                          />
                          <label for="reviewedByDataMonitor"
                            >Reviewed by Data Monitor</label
                          >
                        </div>
                      </div>
                      <div class="checkbox-group">
                        <div class="form-check">
                          <input
                            type="checkbox"
                            id="reviewedByMonitor"
                            name="reviewedByMonitor"
                            [(ngModel)]="reviewOptions.monitor"
                            [disabled]="
                              !hasBMIData ||
                              !reviewOptions.dataMonitor ||
                              userDesignation !== 'monitor'
                            "
                            (change)="onReviewCheckboxChange()"
                          />
                          <label for="reviewedByMonitor"
                            >Reviewed by Monitor</label
                          >
                        </div>
                      </div>
                      <div class="checkbox-group">
                        <div class="form-check">
                          <input
                            type="checkbox"
                            id="reviewedByPI"
                            name="reviewedByPI"
                            [(ngModel)]="reviewOptions.pi"
                            [disabled]="
                              !hasBMIData ||
                              !reviewOptions.dataMonitor ||
                              !reviewOptions.monitor ||
                              userDesignation !== 'pi'
                            "
                          />
                          <label for="reviewedByPI">Reviewed by PI</label>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="modal-overlay" *ngIf="isModalOpen">
                    <div class="modal-content">
                      <button class="close-btn" (click)="closeModal()">
                        &times;
                      </button>

                      <!-- Tab Bar -->
                      <div class="tab-bar">
                        <div
                          class="tab"
                          *ngFor="let tab of tabs; let idx = index"
                          [class.active]="selectedTab === idx"
                          (click)="selectTab(idx)"
                        >
                          {{ tab.title }}
                          <span
                            class="close-tab"
                            *ngIf="tabs.length > 1"
                            (click)="closeTab(idx, $event)"
                            >×</span
                          >
                        </div>

                        <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
                        <div
                          *ngIf="tabs[selectedTab].type === 'query'"
                          class="add-btn-wrapper"
                        >
                          <button  type="button" class="add-btn" (click)="addQuery(i)">
                            +
                          </button>
                          <span class="add-query-tooltip">Add Query</span>
                        </div>
                      </div>

                      <!-- Modal Body -->
                      <div class="modal-body">
                        <ng-container [ngSwitch]="tabs[selectedTab].type">
                          <!-- Query Tab -->
                          <div *ngSwitchCase="'query'">
                            <div
                              *ngFor="let query of queries; let i = index"
                              class="query-box"
                            >
                              <div class="input-checkbox-container">
                                <input
                                  type="text"
                                  class="form-control"
                                  [value]="''"
                                  (input)="query.text = $event.target.value"
                                  [readonly]="query.isClosed"
                                  [ngClass]="{ 'query-closed': query.isClosed }"
                                  placeholder="Enter your query"
                                />
                              </div>

                              <!-- Audit Trail -->
                              <div class="audit-trail">
                                <h4>Audit Trail</h4>
                                <div
                                  class="audit-entry"
                                  *ngFor="let entry of query.auditTrail"
                                >
                                  <strong>{{ entry.user }}</strong
                                  >-
                                  {{
                                    entry.timestamp
                                      | date : "dd-MMM-yyyy h:mm a"
                                  }}

                                  <p>{{ entry.message }}</p>
                                </div>
                              </div>
                              <div class="modal-footer">
                                <button
                                  class="btn custom-button"
                                  (click)="confirmCloseQuery(i)"
                                type="button">
                                  Close Query
                                </button>
                                <button
                                  class="btn custom-button ms-2"
                                  (click)="confirmSubmitQuery(i)"
                                 type="button">
                                  Submit
                                </button>
                              </div>
                            </div>
                          </div>

                          <!-- Field History Tab -->
                          <div *ngSwitchCase="'fieldHistory'">
                            <div
                              *ngIf="fieldHistoryData?.length > 0; else noData"
                            >
                              <div
                                *ngFor="let entry of fieldHistoryData"
                                class="history-box"
                              >
                                <div class="history-header">
                                  <strong>{{ entry.updated_by }}</strong> -
                                  {{ entry.updated_at | date : "medium" }}
                                </div>
                                <div class="history-value">
                                  {{ entry.value }}
                                </div>
                                <!-- ✅ Show edit reason if available -->
                                <div
                                  class="edit-reason"
                                  *ngIf="entry.edit_reason"
                                >
                                  <em
                                    >Reason for change:
                                    {{ entry.edit_reason }}</em
                                  >
                                </div>
                              </div>
                            </div>
                            <ng-template #noData>
                              <p>No history available for this field.</p>
                            </ng-template>
                          </div>
                        </ng-container>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Buttons: Back & Submit -->
               <div class="text-end">
                   <!--<button type="button" class="btn custom-button" (click)="goBack()">Back</button> -->
                  <button type="submit" class="btn custom-button">
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>

          <!-- Diet Assessment Form -->
          <div
            *ngIf="formName === 'baseline-diet-assessment'"
            class="card mt-4"
          >
            <div
              class="card-header d-flex justify-content-between align-items-center"
            >
              <h5 class="m-0">Diet Assessment</h5>
              <!--<button type="button" class="btn custom-button">Create Field</button>-->
            </div>

            <div class="card-body">
              <form (ngSubmit)="submitForm()">
                <div
                  class="form-group"
                  data-label="1. Was the Diet Assessment done using the 24-Hour Diet Recall Checklist"
                >
               
                  <div
                    class="label-wrapper d-flex align-items-center justify-content-between"
                  >
   <label
                    >1. Was the Diet Assessment done using the 24-Hour Diet
                    Recall Checklist?</label
                  >
                    <div
                      class="menu-icon"
                      (click)="openOptionsModal($event, $event.target)"
                    >
                      ⋮
                    </div>
                  </div>
                  <div
                    class="label-wrapper d-flex align-items-center justify-content-between"
                  >
                    <div class="radio-group">
                      <label class="radio-label">
                        <input
                          type="radio"
                          [disabled]="isDietDisabled"
                          id="dietYes"
                          name="dietAssessment"
                          value="yes"
                          [(ngModel)]="formData.dietAssessment"
                          required
                        />
                        <span>Yes</span>
                      </label>
                      <label class="radio-label">
                        <input
                          type="radio"
                          id="dietNo"
                          name="dietAssessment"
                          value="no"
                          [(ngModel)]="formData.dietAssessment"
                          required
                        />
                        <span>No</span>
                      </label>
                    </div>
                 
                  </div>
                  <!-- Small Modal (Right-side) -->
                  <div
                    class="options-modal"
                    *ngIf="
                      isOptionsModalOpen &&
                      fieldLabel ===
                        '1. Was the Diet Assessment done using the 24-Hour Diet Recall Checklist'
                    "
                    (click)="$event.stopPropagation()"
                    style="margin-right: 55px; margin-top: 40px"
                  >
                    <div class="modal-buttons">
                      <button type="button" (click)="openModal()">Query</button>
                      <button type="button" (click)="editStudy()">Edit</button>
                      <button type="button" (click)="openReviewModal()">
                        Review
                      </button>
                    </div>
                  </div>
                  <div class="modal-overlay" *ngIf="isReasonModalOpen">
                    <div class="modal-content">
                      <button class="close-btn" (click)="cancelEditReason()">
                        ×
                      </button>
                      <h4>Please provide a reason for editing:</h4>
                      <textarea
                        class="form-control"
                        [(ngModel)]="editReason"
                        rows="4"
                        placeholder="Enter reason here..."
                      ></textarea>
                      <div class="modal-footer">
                        <button
                          class="btn custom-button"
                          (click)="confirmEditReason()"
                        >
                          Confirm
                        </button>
                        <button
                          class="btn custom-button"
                          (click)="cancelEditReason()"
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                  <!-- Review Modal -->
                  <div
                    class="modal-overlay1"
                    *ngIf="showReviewModal"
                    (click)="closeReviewModal()"
                  >
                    <!-- Close Button -->
                    <span class="close-button1" (click)="closeReviewModal()"
                      >×</span
                    >
                    <div
                      class="modal-content1"
                      (click)="$event.stopPropagation()"
                    >
                      <div class="checkbox-group">
                        <div class="form-check" style="margin-top: 20px">
                          <input
                            type="checkbox"
                            id="reviewedByDataMonitor"
                            name="reviewedByDataMonitor"
                            [(ngModel)]="reviewOptions.dataMonitor"
                            [disabled]="
                              !hasDietData || userDesignation !== 'data monitor'
                            "
                            (change)="onReviewCheckboxChange()"
                          />
                          <label for="reviewedByDataMonitor"
                            >Reviewed by Data Monitor</label
                          >
                        </div>
                      </div>
                      <div class="checkbox-group">
                        <div class="form-check">
                          <input
                            type="checkbox"
                            id="reviewedByMonitor"
                            name="reviewedByMonitor"
                            [(ngModel)]="reviewOptions.monitor"
                            [disabled]="
                              !hasDietData ||
                              !reviewOptions.dataMonitor ||
                              userDesignation !== 'monitor'
                            "
                            (change)="onReviewCheckboxChange()"
                          />
                          <label for="reviewedByMonitor"
                            >Reviewed by Monitor</label
                          >
                        </div>
                      </div>
                      <div class="checkbox-group">
                        <div class="form-check">
                          <input
                            type="checkbox"
                            id="reviewedByPI"
                            name="reviewedByPI"
                            [(ngModel)]="reviewOptions.pi"
                            [disabled]="
                              !hasDietData ||
                              !reviewOptions.dataMonitor ||
                              !reviewOptions.monitor ||
                              userDesignation !== 'pi'
                            "
                          />
                          <label for="reviewedByPI">Reviewed by PI</label>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="modal-overlay" *ngIf="isModalOpen">
                    <div class="modal-content">
                      <button class="close-btn" (click)="closeModal()">
                        &times;
                      </button>

                      <!-- Tab Bar -->
                      <div class="tab-bar">
                        <div
                          class="tab"
                          *ngFor="let tab of tabs; let idx = index"
                          [class.active]="selectedTab === idx"
                          (click)="selectTab(idx)"
                        >
                          {{ tab.title }}
                          <span
                            class="close-tab"
                            *ngIf="tabs.length > 1"
                            (click)="closeTab(idx, $event)"
                            >×</span
                          >
                        </div>

                        <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
                        <div
                          *ngIf="tabs[selectedTab].type === 'query'"
                          class="add-btn-wrapper"
                        >
                          <button  type="button" class="add-btn" (click)="addQuery(i)">
                            +
                          </button>
                          <span class="add-query-tooltip">Add Query</span>
                        </div>
                      </div>

                      <!-- Modal Body -->
                      <div class="modal-body">
                        <ng-container [ngSwitch]="tabs[selectedTab].type">
                          <!-- Query Tab -->
                          <div *ngSwitchCase="'query'">
                            <div
                              *ngFor="let query of queries; let i = index"
                              class="query-box"
                            >
                              <div class="input-checkbox-container">
                                <input
                                  type="text"
                                  class="form-control"
                                  [value]="''"
                                  (input)="query.text = $event.target.value"
                                  [readonly]="query.isClosed"
                                  [ngClass]="{ 'query-closed': query.isClosed }"
                                  placeholder="Enter your query"
                                />
                              </div>

                              <!-- Audit Trail -->
                              <div class="audit-trail">
                                <h4>Audit Trail</h4>
                                <div
                                  class="audit-entry"
                                  *ngFor="let entry of query.auditTrail"
                                >
                                  <strong>{{ entry.user }}</strong
                                  >-
                                  {{
                                    entry.timestamp
                                      | date : "dd-MMM-yyyy h:mm a"
                                  }}

                                  <p>{{ entry.message }}</p>
                                </div>
                              </div>
                              <div class="modal-footer">
                                <button
                                  class="btn custom-button"
                                  (click)="confirmCloseQuery(i)"
                                type="button">
                                  Close Query
                                </button>
                                <button
                                  class="btn custom-button ms-2"
                                  (click)="confirmSubmitQuery(i)"
                                 type="button">
                                  Submit
                                </button>
                              </div>
                            </div>
                          </div>

                          <!-- Field History Tab -->
                          <div *ngSwitchCase="'fieldHistory'">
                            <div
                              *ngIf="fieldHistoryData?.length > 0; else noData"
                            >
                              <div
                                *ngFor="let entry of fieldHistoryData"
                                class="history-box"
                              >
                                <div class="history-header">
                                  <strong>{{ entry.updated_by }}</strong> -
                                  {{ entry.updated_at | date : "medium" }}
                                </div>
                                <div class="history-value">
                                  {{ entry.value }}
                                </div>
                                <!-- ✅ Show edit reason if available -->
                                <div
                                  class="edit-reason"
                                  *ngIf="entry.edit_reason"
                                >
                                  <em
                                    >Reason for change:
                                    {{ entry.edit_reason }}</em
                                  >
                                </div>
                              </div>
                            </div>
                            <ng-template #noData>
                              <p>No history available for this field.</p>
                            </ng-template>
                          </div>
                        </ng-container>
                      </div>
                    </div>
                  </div>

                  <div class="mt-3" *ngIf="formData.dietAssessment === 'no'">
                    <label>Comments:</label>
                    <textarea
                      class="form-control"
                      [(ngModel)]="formData.dietAssessmentComments"
                      name="dietAssessmentComments"
                    ></textarea>
                  </div>
                </div>

               <div class="text-end">
                   <!--<button type="button" class="btn custom-button" (click)="goBack()">Back</button> -->
                  <button type="submit" class="btn custom-button">
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>

          <!-- Lifestyle Assessment Form -->
          <div
            *ngIf="formName === 'baseline-lifestyle-assessment'"
            class="card mt-4"
          >
            <div
              class="card-header d-flex justify-content-between align-items-center"
            >
              <h5 class="m-0">Lifestyle Assessment</h5>
              <!--<button type="button" class="btn custom-button">Create Field</button>-->
            </div>

            <div class="card-body">
              <form (ngSubmit)="submitForm()">
                <div
                  class="form-group"
                  data-label="1. Was the Lifestyle Assessment done using the FANTASTIC Lifestyle Checklist"
                >
                
                           <div
                    class="label-wrapper d-flex align-items-center justify-content-between"
                  >
  <label
                    >1. Was the Lifestyle Assessment done using the FANTASTIC
                    Lifestyle Checklist?</label
                  >
                    <div
                      class="menu-icon"
                      (click)="openOptionsModal($event, $event.target)"
                    >
                      ⋮
                    </div>
                  </div>
                  <div
                    class="label-wrapper d-flex align-items-center justify-content-between"
                  >
                    <div class="radio-group">
                      <label class="radio-label">
                        <input
                          type="radio"
                          [disabled]="isLifestyleDisabled"
                          id="lifestyleYes"
                          name="lifestyleAssessment"
                          value="yes"
                          [(ngModel)]="formData.lifestyleAssessment"
                          required
                        />
                        <span>Yes</span>
                      </label>
                      <label class="radio-label">
                        <input
                          type="radio"
                          [disabled]="isLifestyleDisabled"
                          id="lifestyleNo"
                          name="lifestyleAssessment"
                          value="no"
                          [(ngModel)]="formData.lifestyleAssessment"
                          required
                        />
                        <span>No</span>
                      </label>
                    </div>
                
                  </div>
                  <!-- Small Modal (Right-side) -->
                  <div
                    class="options-modal"
                    *ngIf="
                      isOptionsModalOpen &&
                      fieldLabel ===
                        '1. Was the Lifestyle Assessment done using the FANTASTIC Lifestyle Checklist'
                    "
                    (click)="$event.stopPropagation()"
                    style="margin-right: 55px; margin-top: 40px"
                  >
                    <div class="modal-buttons">
                      <button type="button" (click)="openModal()">Query</button>
                      <button type="button" (click)="editStudy()">Edit</button>
                      <button type="button" (click)="openReviewModal()">
                        Review
                      </button>
                    </div>
                  </div>
                  <div class="modal-overlay" *ngIf="isReasonModalOpen">
                    <div class="modal-content">
                      <button class="close-btn" (click)="cancelEditReason()">
                        ×
                      </button>
                      <h4>Please provide a reason for editing:</h4>
                      <textarea
                        class="form-control"
                        [(ngModel)]="editReason"
                        rows="4"
                        placeholder="Enter reason here..."
                      ></textarea>
                      <div class="modal-footer">
                        <button
                          class="btn custom-button"
                          (click)="confirmEditReason()"
                        >
                          Confirm
                        </button>
                        <button
                          class="btn custom-button"
                          (click)="cancelEditReason()"
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                  <!-- Review Modal -->
                  <div
                    class="modal-overlay1"
                    *ngIf="showReviewModal"
                    (click)="closeReviewModal()"
                  >
                    <!-- Close Button -->
                    <span class="close-button1" (click)="closeReviewModal()"
                      >×</span
                    >
                    <div
                      class="modal-content1"
                      (click)="$event.stopPropagation()"
                    >
                      <div class="checkbox-group">
                        <div class="form-check" style="margin-top: 20px">
                          <input
                            type="checkbox"
                            id="reviewedByDataMonitor"
                            name="reviewedByDataMonitor"
                            [(ngModel)]="reviewOptions.dataMonitor"
                            [disabled]="
                              !hasLifestyleData ||
                              userDesignation !== 'data monitor'
                            "
                            (change)="onReviewCheckboxChange()"
                          />
                          <label for="reviewedByDataMonitor"
                            >Reviewed by Data Monitor</label
                          >
                        </div>
                      </div>
                      <div class="checkbox-group">
                        <div class="form-check">
                          <input
                            type="checkbox"
                            id="reviewedByMonitor"
                            name="reviewedByMonitor"
                            [(ngModel)]="reviewOptions.monitor"
                            [disabled]="
                              !hasLifestyleData ||
                              !reviewOptions.dataMonitor ||
                              userDesignation !== 'monitor'
                            "
                            (change)="onReviewCheckboxChange()"
                          />
                          <label for="reviewedByMonitor"
                            >Reviewed by Monitor</label
                          >
                        </div>
                      </div>
                      <div class="checkbox-group">
                        <div class="form-check">
                          <input
                            type="checkbox"
                            id="reviewedByPI"
                            name="reviewedByPI"
                            [(ngModel)]="reviewOptions.pi"
                            [disabled]="
                              !hasLifestyleData ||
                              !reviewOptions.dataMonitor ||
                              !reviewOptions.monitor ||
                              userDesignation !== 'pi'
                            "
                          />
                          <label for="reviewedByPI">Reviewed by PI</label>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="modal-overlay" *ngIf="isModalOpen">
                    <div class="modal-content">
                      <button class="close-btn" (click)="closeModal()">
                        &times;
                      </button>

                      <!-- Tab Bar -->
                      <div class="tab-bar">
                        <div
                          class="tab"
                          *ngFor="let tab of tabs; let idx = index"
                          [class.active]="selectedTab === idx"
                          (click)="selectTab(idx)"
                        >
                          {{ tab.title }}
                          <span
                            class="close-tab"
                            *ngIf="tabs.length > 1"
                            (click)="closeTab(idx, $event)"
                            >×</span
                          >
                        </div>

                        <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
                        <div
                          *ngIf="tabs[selectedTab].type === 'query'"
                          class="add-btn-wrapper"
                        >
                          <button  type="button" class="add-btn" (click)="addQuery(i)">
                            +
                          </button>
                          <span class="add-query-tooltip">Add Query</span>
                        </div>
                      </div>

                      <!-- Modal Body -->
                      <div class="modal-body">
                        <ng-container [ngSwitch]="tabs[selectedTab].type">
                          <!-- Query Tab -->
                          <div *ngSwitchCase="'query'">
                            <div
                              *ngFor="let query of queries; let i = index"
                              class="query-box"
                            >
                              <div class="input-checkbox-container">
                                <input
                                  type="text"
                                  class="form-control"
                                  [value]="''"
                                  (input)="query.text = $event.target.value"
                                  [readonly]="query.isClosed"
                                  [ngClass]="{ 'query-closed': query.isClosed }"
                                  placeholder="Enter your query"
                                />
                              </div>

                              <!-- Audit Trail -->
                              <div class="audit-trail">
                                <h4>Audit Trail</h4>
                                <div
                                  class="audit-entry"
                                  *ngFor="let entry of query.auditTrail"
                                >
                                  <strong>{{ entry.user }}</strong
                                  >-
                                  {{
                                    entry.timestamp
                                      | date : "dd-MMM-yyyy h:mm a"
                                  }}

                                  <p>{{ entry.message }}</p>
                                </div>
                              </div>
                              <div class="modal-footer">
                                <button
                                  class="btn custom-button"
                                  (click)="confirmCloseQuery(i)"
                                type="button">
                                  Close Query
                                </button>
                                <button
                                  class="btn custom-button ms-2"
                                  (click)="confirmSubmitQuery(i)"
                                 type="button">
                                  Submit
                                </button>
                              </div>
                            </div>
                          </div>

                          <!-- Field History Tab -->
                          <div *ngSwitchCase="'fieldHistory'">
                            <div
                              *ngIf="fieldHistoryData?.length > 0; else noData"
                            >
                              <div
                                *ngFor="let entry of fieldHistoryData"
                                class="history-box"
                              >
                                <div class="history-header">
                                  <strong>{{ entry.updated_by }}</strong> -
                                  {{ entry.updated_at | date : "medium" }}
                                </div>
                                <div class="history-value">
                                  {{ entry.value }}
                                </div>
                                <!-- ✅ Show edit reason if available -->
                                <div
                                  class="edit-reason"
                                  *ngIf="entry.edit_reason"
                                >
                                  <em
                                    >Reason for change:
                                    {{ entry.edit_reason }}</em
                                  >
                                </div>
                              </div>
                            </div>
                            <ng-template #noData>
                              <p>No history available for this field.</p>
                            </ng-template>
                          </div>
                        </ng-container>
                      </div>
                    </div>
                  </div>

                  <div
                    class="mt-3"
                    *ngIf="formData.lifestyleAssessment === 'no'"
                  >
                    <label>Comments:</label>
                    <textarea
                      class="form-control"
                      [(ngModel)]="formData.lifestyleAssessmentComments"
                      name="lifestyleAssessmentComments"
                    ></textarea>
                  </div>
                </div>

               <div class="text-end">
                   <!--<button type="button" class="btn custom-button" (click)="goBack()">Back</button> -->
                  <button type="submit" class="btn custom-button">
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>

          <!-- Details of Intervention Form -->
          <div
            *ngIf="formName === 'baseline-intervention-details'"
            class="card mt-4"
          >
            <div
              class="card-header d-flex justify-content-between align-items-center"
            >
              <h5 class="m-0">Details of Intervention</h5>
              <!--<button type="button" class="btn custom-button">Create Field</button>-->
            </div>

            <div class="card-body">
              <form (ngSubmit)="submitForm()">
                <div class="form-group">
                         <div
                    class="label-wrapper d-flex align-items-center justify-content-between"
                  >
                    <label>1. ADT - Ayurveda Diet Therapy</label>
                    <div
                      class="menu-icon"
                      (click)="openOptionsModal($event, $event.target)"
                    >
                      ⋮
                  </div>
                  </div>

                  <div class="checkbox-group">
                    <div
                      class="form-check"
                      [disabled]="isADT1Disabled"
                      data-label="1. ADT - Ayurveda Diet Therapy: Health drink - asana pānaka"
                    >
                      <input
                        type="checkbox"
                        id="healthDrink"
                        name="adtHealthDrink"
                        [(ngModel)]="formData.adtHealthDrink"
                      />
                      <label for="healthDrink"
                        >Health drink - asana pānaka</label
                      >

                      <!-- Small Modal (Right-side) -->
                      <div
                        class="options-modal"
                        *ngIf="
                          isOptionsModalOpen &&
                          fieldLabel ===
                            '1. ADT - Ayurveda Diet Therapy: Health drink - asana pānaka'
                        "
                        (click)="$event.stopPropagation()"
                        style="margin-right: 55px; margin-top: 40px"
                      >
                        <div class="modal-buttons">
                          <button type="button" (click)="openModal()">Query</button>
                          <button type="button" (click)="editStudy()">Edit</button>
                          <button type="button" (click)="openReviewModal()">
                            Review
                          </button>
                        </div>
                      </div>
                      <div class="modal-overlay" *ngIf="isReasonModalOpen">
                        <div class="modal-content">
                          <button
                            class="close-btn"
                            (click)="cancelEditReason()"
                          >
                            ×
                          </button>
                          <h4>Please provide a reason for editing:</h4>
                          <textarea
                            class="form-control"
                            [(ngModel)]="editReason"
                            rows="4"
                            placeholder="Enter reason here..."
                          ></textarea>
                          <div class="modal-footer">
                            <button
                              class="btn custom-button"
                              (click)="confirmEditReason()"
                            >
                              Confirm
                            </button>
                            <button
                              class="btn custom-button"
                              (click)="cancelEditReason()"
                            >
                              Cancel
                            </button>
                          </div>
                        </div>
                      </div>

                      <!-- Review Modal -->
                      <div
                        class="modal-overlay1"
                        *ngIf="showReviewModal"
                        (click)="closeReviewModal()"
                      >
                        <!-- Close Button -->
                        <span class="close-button1" (click)="closeReviewModal()"
                          >×</span
                        >
                        <div
                          class="modal-content1"
                          (click)="$event.stopPropagation()"
                        >
                          <div class="checkbox-group">
                            <div class="form-check" style="margin-top: 20px">
                              <input
                                type="checkbox"
                                id="reviewedByDataMonitor"
                                name="reviewedByDataMonitor"
                                [(ngModel)]="reviewOptions.dataMonitor"
                                [disabled]="
                              !hasADT1Data ||
                              userDesignation !== 'data monitor'
                            "
                            (change)="onReviewCheckboxChange()"
                              />
                              <label for="reviewedByDataMonitor"
                                >Reviewed by Data Monitor</label
                              >
                            </div>
                          </div>
                          <div class="checkbox-group">
                            <div class="form-check">
                              <input
                                type="checkbox"
                                id="reviewedByMonitor"
                                name="reviewedByMonitor"
                                [(ngModel)]="reviewOptions.monitor"
                                 [disabled]="
                              !hasADT1Data ||
                              !reviewOptions.dataMonitor ||
                              userDesignation !== 'monitor'
                            "
                            (change)="onReviewCheckboxChange()"
                              />
                              <label for="reviewedByMonitor"
                                >Reviewed by Monitor</label
                              >
                            </div>
                          </div>
                          <div class="checkbox-group">
                            <div class="form-check">
                              <input
                                type="checkbox"
                                id="reviewedByPI"
                                name="reviewedByPI"
                                [(ngModel)]="reviewOptions.pi"
                                 [disabled]="
                              !hasADT1Data ||
                              !reviewOptions.dataMonitor ||
                              !reviewOptions.monitor ||
                              userDesignation !== 'pi'
                            "
                              />
                              <label for="reviewedByPI">Reviewed by PI</label>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="modal-overlay" *ngIf="isModalOpen">
                        <div class="modal-content">
                          <button class="close-btn" (click)="closeModal()">
                            &times;
                          </button>

                          <!-- Tab Bar -->
                          <div class="tab-bar">
                            <div
                              class="tab"
                              *ngFor="let tab of tabs; let idx = index"
                              [class.active]="selectedTab === idx"
                              (click)="selectTab(idx)"
                            >
                              {{ tab.title }}
                              <span
                                class="close-tab"
                                *ngIf="tabs.length > 1"
                                (click)="closeTab(idx, $event)"
                                >×</span
                              >
                            </div>

                            <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
                            <div
                              *ngIf="tabs[selectedTab].type === 'query'"
                              class="add-btn-wrapper"
                            >
                              <button  type="button" class="add-btn" (click)="addQuery(i)">
                                +
                              </button>
                              <span class="add-query-tooltip">Add Query</span>
                            </div>
                          </div>

                          <!-- Modal Body -->
                          <div class="modal-body">
                            <ng-container [ngSwitch]="tabs[selectedTab].type">
                              <!-- Query Tab -->
                              <div *ngSwitchCase="'query'">
                                <div
                                  *ngFor="let query of queries; let i = index"
                                  class="query-box"
                                >
                                  <div class="input-checkbox-container">
                                    <input
                                      type="text"
                                      class="form-control"
                                      [value]="''"
                                      (input)="query.text = $event.target.value"
                                      [readonly]="query.isClosed"
                                      [ngClass]="{
                                        'query-closed': query.isClosed
                                      }"
                                      placeholder="Enter your query"
                                    />
                                  </div>

                                  <!-- Audit Trail -->
                                  <div class="audit-trail">
                                    <h4>Audit Trail</h4>
                                    <div
                                      class="audit-entry"
                                      *ngFor="let entry of query.auditTrail"
                                    >
                                      <strong>{{ entry.user }}</strong
                                      >-
                                      {{
                                        entry.timestamp
                                          | date : "dd-MMM-yyyy h:mm a"
                                      }}

                                      <p>{{ entry.message }}</p>
                                    </div>
                                  </div>
                                  <div class="modal-footer">
                                    <button
                                      class="btn custom-button"
                                      [ngClass]="{
                                        'btn-disabled': query.isClosed
                                      }"
                                      (click)="
                                        !query.isClosed && confirmCloseQuery(i)
                                      "
                                    >
                                      Close
                                    </button>
                                    <button
                                      class="btn custom-button ms-2"
                                      (click)="confirmSubmitQuery(i)"
                                      [disabled]="query.isClosed"
                                    >
                                      Submit
                                    </button>
                                  </div>
                                </div>
                              </div>

                              <!-- Field History Tab -->
                              <div *ngSwitchCase="'fieldHistory'">
                                <div
                                  *ngIf="
                                    fieldHistoryData?.length > 0;
                                    else noData
                                  "
                                >
                                  <div
                                    *ngFor="let entry of fieldHistoryData"
                                    class="history-box"
                                  >
                                    <div class="history-header">
                                      <strong>{{ entry.updated_by }}</strong> -
                                      {{ entry.updated_at | date : "medium" }}
                                    </div>
                                    <div class="history-value">
                                      {{ entry.value }}
                                    </div>
                                    <!-- ✅ Show edit reason if available -->
                                    <div
                                      class="edit-reason"
                                      *ngIf="entry.edit_reason"
                                    >
                                      <em
                                        >Reason for change:
                                        {{ entry.edit_reason }}</em
                                      >
                                    </div>
                                  </div>
                                </div>
                                <ng-template #noData>
                                  <p>No history available for this field.</p>
                                </ng-template>
                              </div>
                            </ng-container>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="form-check"
                      data-label="2. ADT - Ayurveda Diet Therapy: Triphala tablets"
                    >
                      <input
                        type="checkbox"
                        [disabled]="isADT2Disabled"
                        id="triphalaTablets"
                        name="adtTriphalaTablets"
                        [(ngModel)]="formData.adtTriphalaTablets"
                      />
                      <label for="triphalaTablets">Triphala tablets</label>
                    </div>
                    <!-- Small Modal (Right-side) -->
                    <div
                      class="options-modal"
                      *ngIf="
                        isOptionsModalOpen &&
                        fieldLabel ===
                          '2. ADT - Ayurveda Diet Therapy: Triphala tablets'
                      "
                      (click)="$event.stopPropagation()"
                      style="margin-right: 55px; margin-top: 160px"
                    >
                      <div class="modal-buttons">
                        <button type="button" (click)="openModal()">Query</button>
                        <button type="button" (click)="editStudy()">Edit</button>
                        <button type="button"    (click)="openReviewModal()">Review</button>
                      </div>
                    </div>
                    <div class="modal-overlay" *ngIf="isReasonModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="cancelEditReason()">
                          ×
                        </button>
                        <h4>Please provide a reason for editing:</h4>
                        <textarea
                          class="form-control"
                          [(ngModel)]="editReason"
                          rows="4"
                          placeholder="Enter reason here..."
                        ></textarea>
                        <div class="modal-footer">
                          <button
                            class="btn custom-button"
                            (click)="confirmEditReason()"
                          >
                            Confirm
                          </button>
                          <button
                            class="btn custom-button"
                            (click)="cancelEditReason()"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>

                    <!-- Review Modal -->
                    <div
                      class="modal-overlay1"
                      *ngIf="showReviewModal"
                      (click)="closeReviewModal()"
                    >
                      <!-- Close Button -->
                      <span class="close-button1" (click)="closeReviewModal()"
                        >×</span
                      >
                      <div
                        class="modal-content1"
                        (click)="$event.stopPropagation()"
                      >
                        <div class="checkbox-group">
                          <div class="form-check" style="margin-top: 20px">
                            <input
                              type="checkbox"
                              id="reviewedByDataMonitor"
                              name="reviewedByDataMonitor"
                              [(ngModel)]="reviewOptions.dataMonitor"
                               [disabled]="
                              !hasADT2Data ||
                              userDesignation !== 'data monitor'
                            "
                            (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByDataMonitor"
                              >Reviewed by Data Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByMonitor"
                              name="reviewedByMonitor"
                              [(ngModel)]="reviewOptions.monitor"
                               [disabled]="
                              !hasADT2Data ||
                              !reviewOptions.dataMonitor ||
                              userDesignation !== 'monitor'
                            "
                            (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByMonitor"
                              >Reviewed by Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByPI"
                              name="reviewedByPI"
                              [(ngModel)]="reviewOptions.pi"
                              [disabled]="
                              !hasADT2Data ||
                              !reviewOptions.dataMonitor ||
                              !reviewOptions.monitor ||
                              userDesignation !== 'pi'
                            "
                            />
                            <label for="reviewedByPI">Reviewed by PI</label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="modal-overlay" *ngIf="isModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="closeModal()">
                          &times;
                        </button>

                        <!-- Tab Bar -->
                        <div class="tab-bar">
                          <div
                            class="tab"
                            *ngFor="let tab of tabs; let idx = index"
                            [class.active]="selectedTab === idx"
                            (click)="selectTab(idx)"
                          >
                            {{ tab.title }}
                            <span
                              class="close-tab"
                              *ngIf="tabs.length > 1"
                              (click)="closeTab(idx, $event)"
                              >×</span
                            >
                          </div>

                          <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
                          <div
                            *ngIf="tabs[selectedTab].type === 'query'"
                            class="add-btn-wrapper"
                          >
                            <button  type="button" class="add-btn" (click)="addQuery(i)">
                              +
                            </button>
                            <span class="add-query-tooltip">Add Query</span>
                          </div>
                        </div>

                        <!-- Modal Body -->
                        <div class="modal-body">
                          <ng-container [ngSwitch]="tabs[selectedTab].type">
                            <!-- Query Tab -->
                            <div *ngSwitchCase="'query'">
                              <div
                                *ngFor="let query of queries; let i = index"
                                class="query-box"
                              >
                                <div class="input-checkbox-container">
                                  <input
                                    type="text"
                                    class="form-control"
                                    [value]="''"
                                    (input)="query.text = $event.target.value"
                                    [readonly]="query.isClosed"
                                    [ngClass]="{
                                      'query-closed': query.isClosed
                                    }"
                                    placeholder="Enter your query"
                                  />
                                </div>

                                <!-- Audit Trail -->
                                <div class="audit-trail">
                                  <h4>Audit Trail</h4>
                                  <div
                                    class="audit-entry"
                                    *ngFor="let entry of query.auditTrail"
                                  >
                                    <strong>{{ entry.user }}</strong
                                    >-
                                    {{
                                      entry.timestamp
                                        | date : "dd-MMM-yyyy h:mm a"
                                    }}

                                    <p>{{ entry.message }}</p>
                                  </div>
                                </div>
                                <div class="modal-footer">
                                  <button
                                    class="btn custom-button"
                                    [ngClass]="{
                                      'btn-disabled': query.isClosed
                                    }"
                                    (click)="
                                      !query.isClosed && confirmCloseQuery(i)
                                    "
                                  >
                                    Close
                                  </button>
                                  <button
                                    class="btn custom-button ms-2"
                                    (click)="confirmSubmitQuery(i)"
                                    [disabled]="query.isClosed"
                                  >
                                    Submit
                                  </button>
                                </div>
                              </div>
                            </div>

                            <!-- Field History Tab -->
                            <div *ngSwitchCase="'fieldHistory'">
                              <div
                                *ngIf="
                                  fieldHistoryData?.length > 0;
                                  else noData
                                "
                              >
                                <div
                                  *ngFor="let entry of fieldHistoryData"
                                  class="history-box"
                                >
                                  <div class="history-header">
                                    <strong>{{ entry.updated_by }}</strong> -
                                    {{ entry.updated_at | date : "medium" }}
                                  </div>
                                  <div class="history-value">
                                    {{ entry.value }}
                                  </div>
                                  <!-- ✅ Show edit reason if available -->
                                  <div
                                    class="edit-reason"
                                    *ngIf="entry.edit_reason"
                                  >
                                    <em
                                      >Reason for change:
                                      {{ entry.edit_reason }}</em
                                    >
                                  </div>
                                </div>
                              </div>
                              <ng-template #noData>
                                <p>No history available for this field.</p>
                              </ng-template>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </div>

                    <div
                      class="form-check"
                      data-label="3. ADT - Ayurveda Diet Therapy: Dietary guidelines"
                    >
                      <input
                        type="checkbox"
                        [disabled]="isADT3Disabled"
                        id="dietaryGuidelines"
                        name="adtDietaryGuidelines"
                        [(ngModel)]="formData.adtDietaryGuidelines"
                      />
                      <label for="dietaryGuidelines">Dietary guidelines</label>
                    </div>
                    <!-- Small Modal (Right-side) -->
                    <div
                      class="options-modal"
                      *ngIf="
                        isOptionsModalOpen &&
                        fieldLabel ===
                          '3. ADT - Ayurveda Diet Therapy: Dietary guidelines'
                      "
                      (click)="$event.stopPropagation()"
                      style="margin-right: 50px; margin-top: -10px"
                    >
                      <div class="modal-buttons">
                        <button type="button" (click)="openModal()">Query</button>
                        <button type="button" (click)="editStudy()">Edit</button>
                        <button type="button"    (click)="openReviewModal()">Review</button>
                      </div>
                    </div>
                    <div class="modal-overlay" *ngIf="isReasonModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="cancelEditReason()">
                          ×
                        </button>
                        <h4>Please provide a reason for editing:</h4>
                        <textarea
                          class="form-control"
                          [(ngModel)]="editReason"
                          rows="4"
                          placeholder="Enter reason here..."
                        ></textarea>
                        <div class="modal-footer">
                          <button
                            class="btn custom-button"
                            (click)="confirmEditReason()"
                          >
                            Confirm
                          </button>
                          <button
                            class="btn custom-button"
                            (click)="cancelEditReason()"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>

                    <!-- Review Modal -->
                    <div
                      class="modal-overlay1"
                      *ngIf="showReviewModal"
                      (click)="closeReviewModal()"
                    >
                      <!-- Close Button -->
                      <span class="close-button1" (click)="closeReviewModal()"
                        >×</span
                      >
                      <div
                        class="modal-content1"
                        (click)="$event.stopPropagation()"
                      >
                        <div class="checkbox-group">
                          <div class="form-check" style="margin-top: 20px">
                            <input
                              type="checkbox"
                              id="reviewedByDataMonitor"
                              name="reviewedByDataMonitor"
                              [(ngModel)]="reviewOptions.dataMonitor"
                               [disabled]="
                              !hasADT3Data ||
                              userDesignation !== 'data monitor'
                            "
                            (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByDataMonitor"
                              >Reviewed by Data Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByMonitor"
                              name="reviewedByMonitor"
                              [(ngModel)]="reviewOptions.monitor"
                              [disabled]="
                              !hasADT3Data ||
                              !reviewOptions.dataMonitor ||
                              userDesignation !== 'monitor'
                            "
                            (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByMonitor"
                              >Reviewed by Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByPI"
                              name="reviewedByPI"
                              [(ngModel)]="reviewOptions.pi"
                               [disabled]="
                              !hasADT3Data ||
                              !reviewOptions.dataMonitor ||
                              !reviewOptions.monitor ||
                              userDesignation !== 'pi'
                            "
                            />
                            <label for="reviewedByPI">Reviewed by PI</label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="modal-overlay" *ngIf="isModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="closeModal()">
                          &times;
                        </button>

                        <!-- Tab Bar -->
                        <div class="tab-bar">
                          <div
                            class="tab"
                            *ngFor="let tab of tabs; let idx = index"
                            [class.active]="selectedTab === idx"
                            (click)="selectTab(idx)"
                          >
                            {{ tab.title }}
                            <span
                              class="close-tab"
                              *ngIf="tabs.length > 1"
                              (click)="closeTab(idx, $event)"
                              >×</span
                            >
                          </div>

                          <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
                          <div
                            *ngIf="tabs[selectedTab].type === 'query'"
                            class="add-btn-wrapper"
                          >
                            <button  type="button" class="add-btn" (click)="addQuery(i)">
                              +
                            </button>
                            <span class="add-query-tooltip">Add Query</span>
                          </div>
                        </div>

                        <!-- Modal Body -->
                        <div class="modal-body">
                          <ng-container [ngSwitch]="tabs[selectedTab].type">
                            <!-- Query Tab -->
                            <div *ngSwitchCase="'query'">
                              <div
                                *ngFor="let query of queries; let i = index"
                                class="query-box"
                              >
                                <div class="input-checkbox-container">
                                  <input
                                    type="text"
                                    class="form-control"
                                    [value]="''"
                                    (input)="query.text = $event.target.value"
                                    [readonly]="query.isClosed"
                                    [ngClass]="{
                                      'query-closed': query.isClosed
                                    }"
                                    placeholder="Enter your query"
                                  />
                                </div>

                                <!-- Audit Trail -->
                                <div class="audit-trail">
                                  <h4>Audit Trail</h4>
                                  <div
                                    class="audit-entry"
                                    *ngFor="let entry of query.auditTrail"
                                  >
                                    <strong>{{ entry.user }}</strong
                                    >-
                                    {{
                                      entry.timestamp
                                        | date : "dd-MMM-yyyy h:mm a"
                                    }}

                                    <p>{{ entry.message }}</p>
                                  </div>
                                </div>
                                <div class="modal-footer">
                                  <button
                                    class="btn custom-button"
                                    [ngClass]="{
                                      'btn-disabled': query.isClosed
                                    }"
                                    (click)="
                                      !query.isClosed && confirmCloseQuery(i)
                                    "
                                  >
                                    Close
                                  </button>
                                  <button
                                    class="btn custom-button ms-2"
                                    (click)="confirmSubmitQuery(i)"
                                    [disabled]="query.isClosed"
                                  >
                                    Submit
                                  </button>
                                </div>
                              </div>
                            </div>

                            <!-- Field History Tab -->
                            <div *ngSwitchCase="'fieldHistory'">
                              <div
                                *ngIf="
                                  fieldHistoryData?.length > 0;
                                  else noData
                                "
                              >
                                <div
                                  *ngFor="let entry of fieldHistoryData"
                                  class="history-box"
                                >
                                  <div class="history-header">
                                    <strong>{{ entry.updated_by }}</strong> -
                                    {{ entry.updated_at | date : "medium" }}
                                  </div>
                                  <div class="history-value">
                                    {{ entry.value }}
                                  </div>
                                  <!-- ✅ Show edit reason if available -->
                                  <div
                                    class="edit-reason"
                                    *ngIf="entry.edit_reason"
                                  >
                                    <em
                                      >Reason for change:
                                      {{ entry.edit_reason }}</em
                                    >
                                  </div>
                                </div>
                              </div>
                              <ng-template #noData>
                                <p>No history available for this field.</p>
                              </ng-template>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="form-group">
                  <label
                    >2. ABLI - Ayurveda Behavioural Lifestyle
                    Intervention</label
                  >
                  <div class="checkbox-group">
                    <div
                      class="form-check"
                      data-label="4. ABLI - Ayurveda Behavioural Lifestyle Intervention: Udvartana"
                    >
                      <input
                        type="checkbox"
                        id="udvartana"
                        name="abliUdvartana"
                        [(ngModel)]="formData.abliUdvartana"
                      />
                      <label for="udvartana">Udvartana</label>
                    </div>
                    <div
                      class="form-check"
                      data-label="5. ABLI - Ayurveda Behavioural Lifestyle Intervention: Lifestyle guidelines"
                    >
                      <input
                        type="checkbox"
                        id="lifestyleGuidelines"
                        name="abliLifestyleGuidelines"
                        [(ngModel)]="formData.abliLifestyleGuidelines"
                      />
                      <label for="lifestyleGuidelines"
                        >Lifestyle guidelines</label
                      >
                    </div>
                  </div>
                </div>

               <div class="text-end">
                   <!--<button type="button" class="btn custom-button" (click)="goBack()">Back</button> -->
                  <button type="submit" class="btn custom-button">
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>

          <!-- Study Product Dispensing Form -->
          <div
            *ngIf="formName === 'baseline-product-dispensing'"
            class="card mt-4"
          >
            <div
              class="card-header d-flex justify-content-between align-items-center"
            >
              <h5 class="m-0">Study Product Dispensing</h5>
              <!--<button type="button" class="btn custom-button">Create Field</button>-->
            </div>

            <div class="card-body">
              <!--<form (ngSubmit)="submitForm()">-->
              <form (ngSubmit)="validateForm()" #form="ngForm">
                <div class="form-container">
                <!-- Existing Fields -->
                <div
                  class="form-group"
                  data-label="1. Were all the Study Products dispensed to the subject as per protocol"
                >
               
                     <div
                    class="label-wrapper d-flex align-items-center justify-content-between"
                  >
   <label
                    >1. Were all the Study Products dispensed to the subject as
                    per protocol?</label
                  >
                    <div
                      class="menu-icon"
                      (click)="openOptionsModal($event, $event.target)"
                    >
                      ⋮
                    </div>
                  </div>
                  <div
                    class="label-wrapper d-flex align-items-center justify-content-between"
                  >
                    <div class="radio-group">
                      <label class="radio-label">
                        <input
                          type="radio"
                          [disabled]="isStudyProductsDisabled"
                          id="dispensedYes"
                          name="studyProductsDispensed"
                          value="yes"
                          [(ngModel)]="formData.studyProductsDispensed"
                          required
                        />
                        <span>Yes</span>
                      </label>
                      <label class="radio-label">
                        <input
                          type="radio"
                          [disabled]="isStudyProductsDisabled"
                          id="dispensedNo"
                          name="studyProductsDispensed"
                          value="no"
                          [(ngModel)]="formData.studyProductsDispensed"
                          required
                        />
                        <span>No</span>
                      </label>
                    </div>
               
                  </div>

                  <!-- Small Modal (Right-side) -->
                  <div
                    class="options-modal"
                    *ngIf="
                      isOptionsModalOpen &&
                      fieldLabel ===
                        '1. Were all the Study Products dispensed to the subject as per protocol'
                    "
                    (click)="$event.stopPropagation()"
                    style="margin-right: 55px; margin-top: -20px"
                  >
                    <div class="modal-buttons">
                      <button type="button" (click)="openModal()">Query</button>
                      <button type="button" (click)="editStudy()">Edit</button>
                      <button type="button" (click)="openReviewModal()">Review</button>
                    </div>
                  </div>
                  <div class="modal-overlay" *ngIf="isReasonModalOpen">
                    <div class="modal-content">
                      <button class="close-btn" (click)="cancelEditReason()">
                        ×
                      </button>
                      <h4>Please provide a reason for editing:</h4>
                      <textarea
                        class="form-control"
                        [(ngModel)]="editReason"
                        rows="4"
                        placeholder="Enter reason here..."
                      ></textarea>
                      <div class="modal-footer">
                        <button
                          class="btn custom-button"
                          (click)="confirmEditReason()"
                        >
                          Confirm
                        </button>
                        <button
                          class="btn custom-button"
                          (click)="cancelEditReason()"
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>

                  <!-- Review Modal -->
                  <div
                    class="modal-overlay1"
                    *ngIf="showReviewModal"
                    (click)="closeReviewModal()"
                  >
                    <!-- Close Button -->
                    <span class="close-button1" (click)="closeReviewModal()"
                      >×</span
                    >
                    <div
                      class="modal-content1"
                      (click)="$event.stopPropagation()"
                    >
                      <div class="checkbox-group">
                        <div class="form-check" style="margin-top: 20px">
                          <input
                            type="checkbox"
                            id="reviewedByDataMonitor"
                            name="reviewedByDataMonitor"
                            [(ngModel)]="reviewOptions.dataMonitor"
                            [disabled]="
                              !hasDispensedData ||
                              userDesignation !== 'data monitor'
                            "
                            (change)="onReviewCheckboxChange()"
                          />
                          <label for="reviewedByDataMonitor"
                            >Reviewed by Data Monitor</label
                          >
                        </div>
                      </div>
                      <div class="checkbox-group">
                        <div class="form-check">
                          <input
                            type="checkbox"
                            id="reviewedByMonitor"
                            name="reviewedByMonitor"
                            [(ngModel)]="reviewOptions.monitor"
                             [disabled]="
                              !hasDispensedData ||
                              !reviewOptions.dataMonitor ||
                              userDesignation !== 'monitor'
                            "
                            (change)="onReviewCheckboxChange()"
                          />
                          <label for="reviewedByMonitor"
                            >Reviewed by Monitor</label
                          >
                        </div>
                      </div>
                      <div class="checkbox-group">
                        <div class="form-check">
                          <input
                            type="checkbox"
                            id="reviewedByPI"
                            name="reviewedByPI"
                            [(ngModel)]="reviewOptions.pi"
                             [disabled]="
                              !hasDispensedData ||
                              !reviewOptions.dataMonitor ||
                              !reviewOptions.monitor ||
                              userDesignation !== 'pi'
                            "
                          />
                          <label for="reviewedByPI">Reviewed by PI</label>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="modal-overlay" *ngIf="isModalOpen">
                    <div class="modal-content">
                      <button class="close-btn" (click)="closeModal()">
                        &times;
                      </button>

                      <!-- Tab Bar -->
                      <div class="tab-bar">
                        <div
                          class="tab"
                          *ngFor="let tab of tabs; let idx = index"
                          [class.active]="selectedTab === idx"
                          (click)="selectTab(idx)"
                        >
                          {{ tab.title }}
                          <span
                            class="close-tab"
                            *ngIf="tabs.length > 1"
                            (click)="closeTab(idx, $event)"
                            >×</span
                          >
                        </div>

                        <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
                        <div
                          *ngIf="tabs[selectedTab].type === 'query'"
                          class="add-btn-wrapper"
                        >
                          <button  type="button" class="add-btn" (click)="addQuery(i)">
                            +
                          </button>
                          <span class="add-query-tooltip">Add Query</span>
                        </div>
                      </div>

                      <!-- Modal Body -->
                      <div class="modal-body">
                        <ng-container [ngSwitch]="tabs[selectedTab].type">
                          <!-- Query Tab -->
                          <div *ngSwitchCase="'query'">
                            <div
                              *ngFor="let query of queries; let i = index"
                              class="query-box"
                            >
                              <div class="input-checkbox-container">
                                <input
                                  type="text"
                                  class="form-control"
                                  [value]="''"
                                  (input)="query.text = $event.target.value"
                                  [readonly]="query.isClosed"
                                  [ngClass]="{ 'query-closed': query.isClosed }"
                                  placeholder="Enter your query"
                                />
                              </div>

                              <!-- Audit Trail -->
                              <div class="audit-trail">
                                <h4>Audit Trail</h4>
                                <div
                                  class="audit-entry"
                                  *ngFor="let entry of query.auditTrail"
                                >
                                  <strong>{{ entry.user }}</strong
                                  >-
                                  {{
                                    entry.timestamp
                                      | date : "dd-MMM-yyyy h:mm a"
                                  }}

                                  <p>{{ entry.message }}</p>
                                </div>
                              </div>
                              <div class="modal-footer">
                                <button
                                  class="btn custom-button"
                                  (click)="confirmCloseQuery(i)"
                                type="button">
                                  Close Query
                                </button>
                                <button
                                  class="btn custom-button ms-2"
                                  (click)="confirmSubmitQuery(i)"
                                 type="button">
                                  Submit
                                </button>
                              </div>
                            </div>
                          </div>

                          <!-- Field History Tab -->
                          <div *ngSwitchCase="'fieldHistory'">
                            <div
                              *ngIf="fieldHistoryData?.length > 0; else noData"
                            >
                              <div
                                *ngFor="let entry of fieldHistoryData"
                                class="history-box"
                              >
                                <div class="history-header">
                                  <strong>{{ entry.updated_by }}</strong> -
                                  {{ entry.updated_at | date : "medium" }}
                                </div>
                                <div class="history-value">
                                  {{ entry.value }}
                                </div>
                                <!-- ✅ Show edit reason if available -->
                                <div
                                  class="edit-reason"
                                  *ngIf="entry.edit_reason"
                                >
                                  <em
                                    >Reason for change:
                                    {{ entry.edit_reason }}</em
                                  >
                                </div>
                              </div>
                            </div>
                            <ng-template #noData>
                              <p>No history available for this field.</p>
                            </ng-template>
                          </div>
                        </ng-container>
                      </div>
                    </div>
                  </div>

                  <div
                    class="mt-3"
                    *ngIf="formData.studyProductsDispensed === 'no'"
                  >
                    <label>Comments:</label>
                    <textarea
                      class="form-control"
                      [(ngModel)]="formData.studyProductsDispensedComments"
                      name="studyProductsDispensedComments"
                    ></textarea>
                  </div>
                </div>

                <div
                  class="form-group"
                  data-label="2. Was the Product Consumption Guide given to the patient"
                >
               
                              <div
                    class="label-wrapper d-flex align-items-center justify-content-between"
                  >
   <label
                    >2. Was the Product Consumption Guide given to the
                    patient?</label
                  >
                    <div
                      class="menu-icon"
                      (click)="openOptionsModal($event, $event.target)"
                    >
                      ⋮
                    </div>
                  </div>
                  <div
                    class="label-wrapper d-flex align-items-center justify-content-between"
                  >
                    <div class="radio-group">
                      <label class="radio-label">
                        <input
                          type="radio"
                          [disabled]="isProductConsumptionGuideDisabled"
                          id="guideYes"
                          name="productConsumptionGuide"
                          value="yes"
                          [(ngModel)]="formData.productConsumptionGuide"
                          required
                        />
                        <span>Yes</span>
                      </label>
                      <label class="radio-label">
                        <input
                          type="radio"
                          [disabled]="isProductConsumptionGuideDisabled"
                          id="guideNo"
                          name="productConsumptionGuide"
                          value="no"
                          [(ngModel)]="formData.productConsumptionGuide"
                          required
                        />
                        <span>No</span>
                      </label>
                    </div>
                 
                  </div>
                  <!-- Small Modal (Right-side) -->
                  <div
                    class="options-modal"
                    *ngIf="
                      isOptionsModalOpen &&
                      fieldLabel ===
                        '2. Was the Product Consumption Guide given to the patient'
                    "
                    (click)="$event.stopPropagation()"
                    style="margin-right: 55px; margin-top: 55px"
                  >
                    <div class="modal-buttons">
                      <button type="button" (click)="openModal()">Query</button>
                      <button type="button" (click)="editStudy()">Edit</button>
                      <button type="button" (click)="openReviewModal()">Review</button>
                    </div>
                  </div>
                  <div class="modal-overlay" *ngIf="isReasonModalOpen">
                    <div class="modal-content">
                      <button class="close-btn" (click)="cancelEditReason()">
                        ×
                      </button>
                      <h4>Please provide a reason for editing:</h4>
                      <textarea
                        class="form-control"
                        [(ngModel)]="editReason"
                        rows="4"
                        placeholder="Enter reason here..."
                      ></textarea>
                      <div class="modal-footer">
                        <button
                          class="btn custom-button"
                          (click)="confirmEditReason()"
                        >
                          Confirm
                        </button>
                        <button
                          class="btn custom-button"
                          (click)="cancelEditReason()"
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                  <!-- Review Modal -->
                  <div
                    class="modal-overlay1"
                    *ngIf="showReviewModal"
                    (click)="closeReviewModal()"
                  >
                    <!-- Close Button -->
                    <span class="close-button1" (click)="closeReviewModal()"
                      >×</span
                    >
                    <div
                      class="modal-content1"
                      (click)="$event.stopPropagation()"
                    >
                      <div class="checkbox-group">
                        <div class="form-check" style="margin-top: 20px">
                          <input
                            type="checkbox"
                            id="reviewedByDataMonitor"
                            name="reviewedByDataMonitor"
                            [(ngModel)]="reviewOptions.dataMonitor"
                             [disabled]="
                              !hasGuideData ||
                              userDesignation !== 'data monitor'
                            "
                            (change)="onReviewCheckboxChange()"
                          />
                          <label for="reviewedByDataMonitor"
                            >Reviewed by Data Monitor</label
                          >
                        </div>
                      </div>
                      <div class="checkbox-group">
                        <div class="form-check">
                          <input
                            type="checkbox"
                            id="reviewedByMonitor"
                            name="reviewedByMonitor"
                            [(ngModel)]="reviewOptions.monitor"
                             [disabled]="
                              !hasGuideData ||
                              !reviewOptions.dataMonitor ||
                              userDesignation !== 'monitor'
                            "
                            (change)="onReviewCheckboxChange()"
                          />
                          <label for="reviewedByMonitor"
                            >Reviewed by Monitor</label
                          >
                        </div>
                      </div>
                      <div class="checkbox-group">
                        <div class="form-check">
                          <input
                            type="checkbox"
                            id="reviewedByPI"
                            name="reviewedByPI"
                            [(ngModel)]="reviewOptions.pi"
                             [disabled]="
                              !hasGuideData ||
                              !reviewOptions.dataMonitor ||
                              !reviewOptions.monitor ||
                              userDesignation !== 'pi'
                            "
                          />
                          <label for="reviewedByPI">Reviewed by PI</label>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="modal-overlay" *ngIf="isModalOpen">
                    <div class="modal-content">
                      <button class="close-btn" (click)="closeModal()">
                        &times;
                      </button>

                      <!-- Tab Bar -->
                      <div class="tab-bar">
                        <div
                          class="tab"
                          *ngFor="let tab of tabs; let idx = index"
                          [class.active]="selectedTab === idx"
                          (click)="selectTab(idx)"
                        >
                          {{ tab.title }}
                          <span
                            class="close-tab"
                            *ngIf="tabs.length > 1"
                            (click)="closeTab(idx, $event)"
                            >×</span
                          >
                        </div>

                        <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
                        <div
                          *ngIf="tabs[selectedTab].type === 'query'"
                          class="add-btn-wrapper"
                        >
                          <button  type="button" class="add-btn" (click)="addQuery(i)">
                            +
                          </button>
                          <span class="add-query-tooltip">Add Query</span>
                        </div>
                      </div>

                      <!-- Modal Body -->
                      <div class="modal-body">
                        <ng-container [ngSwitch]="tabs[selectedTab].type">
                          <!-- Query Tab -->
                          <div *ngSwitchCase="'query'">
                            <div
                              *ngFor="let query of queries; let i = index"
                              class="query-box"
                            >
                              <div class="input-checkbox-container">
                                <input
                                  type="text"
                                  class="form-control"
                                  [value]="''"
                                  (input)="query.text = $event.target.value"
                                  [readonly]="query.isClosed"
                                  [ngClass]="{ 'query-closed': query.isClosed }"
                                  placeholder="Enter your query"
                                />
                              </div>

                              <!-- Audit Trail -->
                              <div class="audit-trail">
                                <h4>Audit Trail</h4>
                                <div
                                  class="audit-entry"
                                  *ngFor="let entry of query.auditTrail"
                                >
                                  <strong>{{ entry.user }}</strong
                                  >-
                                  {{
                                    entry.timestamp
                                      | date : "dd-MMM-yyyy h:mm a"
                                  }}

                                  <p>{{ entry.message }}</p>
                                </div>
                              </div>
                              <div class="modal-footer">
                                <button
                                  class="btn custom-button"
                                  (click)="confirmCloseQuery(i)"
                                type="button">
                                  Close Query
                                </button>
                                <button
                                  class="btn custom-button ms-2"
                                  (click)="confirmSubmitQuery(i)"
                                 type="button">
                                  Submit
                                </button>
                              </div>
                            </div>
                          </div>

                          <!-- Field History Tab -->
                          <div *ngSwitchCase="'fieldHistory'">
                            <div
                              *ngIf="fieldHistoryData?.length > 0; else noData"
                            >
                              <div
                                *ngFor="let entry of fieldHistoryData"
                                class="history-box"
                              >
                                <div class="history-header">
                                  <strong>{{ entry.updated_by }}</strong> -
                                  {{ entry.updated_at | date : "medium" }}
                                </div>
                                <div class="history-value">
                                  {{ entry.value }}
                                </div>
                                <!-- ✅ Show edit reason if available -->
                                <div
                                  class="edit-reason"
                                  *ngIf="entry.edit_reason"
                                >
                                  <em
                                    >Reason for change:
                                    {{ entry.edit_reason }}</em
                                  >
                                </div>
                              </div>
                            </div>
                            <ng-template #noData>
                              <p>No history available for this field.</p>
                            </ng-template>
                          </div>
                        </ng-container>
                      </div>
                    </div>
                  </div>

                  <div
                    class="mt-3"
                    *ngIf="formData.productConsumptionGuide === 'no'"
                  >
                    <label>Comments:</label>
                    <textarea
                      class="form-control"
                      [(ngModel)]="formData.productConsumptionGuideComments"
                      name="productConsumptionGuideComments"
                    ></textarea>
                  </div>
                </div>

                <div
                  class="form-group"
                  data-label="3. Was the Daily Product Consumption Log given to the subject"
                >
               

                              <div
                    class="label-wrapper d-flex align-items-center justify-content-between"
                  >
   <label
                    >3. Was the Daily Product Consumption Log given to the
                    subject?</label
                  >
                    <div
                      class="menu-icon"
                      (click)="openOptionsModal($event, $event.target)"
                    >
                      ⋮
                    </div>
                  </div>
                  <div
                    class="label-wrapper d-flex align-items-center justify-content-between"
                  >
                    <div class="radio-group">
                      <label class="radio-label">
                        <input
                          type="radio"
                          [disabled]="isProductLogDisabled"
                          id="logYes"
                          name="dailyProductConsumptionLog"
                          value="yes"
                          [(ngModel)]="formData.dailyProductConsumptionLog"
                          required
                        />
                        <span>Yes</span>
                      </label>
                      <label class="radio-label">
                        <input
                          type="radio"
                          [disabled]="isProductLogDisabled"
                          id="logNo"
                          name="dailyProductConsumptionLog"
                          value="no"
                          [(ngModel)]="formData.dailyProductConsumptionLog"
                          required
                        />
                        <span>No</span>
                      </label>
                    </div>
                
                  </div>
                  <!-- Small Modal (Right-side) -->
                  <div
                    class="options-modal"
                    *ngIf="
                      isOptionsModalOpen &&
                      fieldLabel ===
                        '3. Was the Daily Product Consumption Log given to the subject'
                    "
                    (click)="$event.stopPropagation()"
                    style="margin-right: 55px; margin-top: 125px"
                  >
                    <div class="modal-buttons">
                      <button type="button" (click)="openModal()">Query</button>
                      <button type="button" (click)="editStudy()">Edit</button>
                      <button type="button"  (click)="openReviewModal()">Review</button>
                    </div>
                  </div>
                  <div class="modal-overlay" *ngIf="isReasonModalOpen">
                    <div class="modal-content">
                      <button class="close-btn" (click)="cancelEditReason()">
                        ×
                      </button>
                      <h4>Please provide a reason for editing:</h4>
                      <textarea
                        class="form-control"
                        [(ngModel)]="editReason"
                        rows="4"
                        placeholder="Enter reason here..."
                      ></textarea>
                      <div class="modal-footer">
                        <button
                          class="btn custom-button"
                          (click)="confirmEditReason()"
                        >
                          Confirm
                        </button>
                        <button
                          class="btn custom-button"
                          (click)="cancelEditReason()"
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                  <!-- Review Modal -->
                  <div
                    class="modal-overlay1"
                    *ngIf="showReviewModal"
                    (click)="closeReviewModal()"
                  >
                    <!-- Close Button -->
                    <span class="close-button1" (click)="closeReviewModal()"
                      >×</span
                    >
                    <div
                      class="modal-content1"
                      (click)="$event.stopPropagation()"
                    >
                      <div class="checkbox-group">
                        <div class="form-check" style="margin-top: 20px">
                          <input
                            type="checkbox"
                            id="reviewedByDataMonitor"
                            name="reviewedByDataMonitor"
                            [(ngModel)]="reviewOptions.dataMonitor"
                             [disabled]="
                              !hasLogData ||
                              userDesignation !== 'data monitor'
                            "
                            (change)="onReviewCheckboxChange()"
                          />
                          <label for="reviewedByDataMonitor"
                            >Reviewed by Data Monitor</label
                          >
                        </div>
                      </div>
                      <div class="checkbox-group">
                        <div class="form-check">
                          <input
                            type="checkbox"
                            id="reviewedByMonitor"
                            name="reviewedByMonitor"
                            [(ngModel)]="reviewOptions.monitor"
                            [disabled]="
                              !hasLogData ||
                              !reviewOptions.dataMonitor ||
                              userDesignation !== 'monitor'
                            "
                            (change)="onReviewCheckboxChange()"
                          />
                          <label for="reviewedByMonitor"
                            >Reviewed by Monitor</label
                          >
                        </div>
                      </div>
                      <div class="checkbox-group">
                        <div class="form-check">
                          <input
                            type="checkbox"
                            id="reviewedByPI"
                            name="reviewedByPI"
                            [(ngModel)]="reviewOptions.pi"
                             [disabled]="
                              !hasLogData ||
                              !reviewOptions.dataMonitor ||
                              !reviewOptions.monitor ||
                              userDesignation !== 'pi'
                            "
                          />
                          <label for="reviewedByPI">Reviewed by PI</label>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="modal-overlay" *ngIf="isModalOpen">
                    <div class="modal-content">
                      <button class="close-btn" (click)="closeModal()">
                        &times;
                      </button>

                      <!-- Tab Bar -->
                      <div class="tab-bar">
                        <div
                          class="tab"
                          *ngFor="let tab of tabs; let idx = index"
                          [class.active]="selectedTab === idx"
                          (click)="selectTab(idx)"
                        >
                          {{ tab.title }}
                          <span
                            class="close-tab"
                            *ngIf="tabs.length > 1"
                            (click)="closeTab(idx, $event)"
                            >×</span
                          >
                        </div>

                        <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
                        <div
                          *ngIf="tabs[selectedTab].type === 'query'"
                          class="add-btn-wrapper"
                        >
                          <button  type="button" class="add-btn" (click)="addQuery(i)">
                            +
                          </button>
                          <span class="add-query-tooltip">Add Query</span>
                        </div>
                      </div>

                      <!-- Modal Body -->
                      <div class="modal-body">
                        <ng-container [ngSwitch]="tabs[selectedTab].type">
                          <!-- Query Tab -->
                          <div *ngSwitchCase="'query'">
                            <div
                              *ngFor="let query of queries; let i = index"
                              class="query-box"
                            >
                              <div class="input-checkbox-container">
                                <input
                                  type="text"
                                  class="form-control"
                                  [value]="''"
                                  (input)="query.text = $event.target.value"
                                  [readonly]="query.isClosed"
                                  [ngClass]="{ 'query-closed': query.isClosed }"
                                  placeholder="Enter your query"
                                />
                              </div>

                              <!-- Audit Trail -->
                              <div class="audit-trail">
                                <h4>Audit Trail</h4>
                                <div
                                  class="audit-entry"
                                  *ngFor="let entry of query.auditTrail"
                                >
                                  <strong>{{ entry.user }}</strong
                                  >-
                                  {{
                                    entry.timestamp
                                      | date : "dd-MMM-yyyy h:mm a"
                                  }}

                                  <p>{{ entry.message }}</p>
                                </div>
                              </div>
                              <div class="modal-footer">
                                <button
                                  class="btn custom-button"
                                  (click)="confirmCloseQuery(i)"
                                type="button">
                                  Close Query
                                </button>
                                <button
                                  class="btn custom-button ms-2"
                                  (click)="confirmSubmitQuery(i)"
                                 type="button">
                                  Submit
                                </button>
                              </div>
                            </div>
                          </div>

                          <!-- Field History Tab -->
                          <div *ngSwitchCase="'fieldHistory'">
                            <div
                              *ngIf="fieldHistoryData?.length > 0; else noData"
                            >
                              <div
                                *ngFor="let entry of fieldHistoryData"
                                class="history-box"
                              >
                                <div class="history-header">
                                  <strong>{{ entry.updated_by }}</strong> -
                                  {{ entry.updated_at | date : "medium" }}
                                </div>
                                <div class="history-value">
                                  {{ entry.value }}
                                </div>
                                <!-- ✅ Show edit reason if available -->
                                <div
                                  class="edit-reason"
                                  *ngIf="entry.edit_reason"
                                >
                                  <em
                                    >Reason for change:
                                    {{ entry.edit_reason }}</em
                                  >
                                </div>
                              </div>
                            </div>
                            <ng-template #noData>
                              <p>No history available for this field.</p>
                            </ng-template>
                          </div>
                        </ng-container>
                      </div>
                    </div>
                  </div>

                  <div
                    class="mt-3"
                    *ngIf="formData.dailyProductConsumptionLog === 'no'"
                  >
                    <label>Comments:</label>
                    <textarea
                      class="form-control"
                      [(ngModel)]="formData.dailyProductConsumptionLogComments"
                      name="dailyProductConsumptionLogComments"
                    ></textarea>
                  </div>
                </div>

                <div
                  class="form-group"
                  data-label="4. Date of dispensing of the Study Products"
                >
                                             <div
                    class="label-wrapper d-flex align-items-center justify-content-between"
                  >
                  <label>4. Date of dispensing of the Study Products:</label>

                    <div
                      class="menu-icon"
                      (click)="openOptionsModal($event, $event.target)"
                      style="margin-bottom: 8px;"
                    >
                      ⋮
                    </div>
                  </div>
                  <div
                    class="label-wrapper d-flex align-items-center justify-content-between"
                  >
                    <input
                      type="date"
                      [disabled]="isDispensingDateDisabled"
                      class="form-control"
                      [(ngModel)]="formData.studyProductsDispensingDate"
                      name="studyProductsDispensingDate"
                      [min]="screeningMinDate"
                      [max]="todayDate"
                      required
                    />
                
                  </div>
                  <!-- Small Modal (Right-side) -->
                  <div
                    class="options-modal"
                    *ngIf="
                      isOptionsModalOpen &&
                      fieldLabel ===
                        '4. Date of dispensing of the Study Products'
                    "
                    (click)="$event.stopPropagation()"
                    style="margin-right: 55px; margin-top: 203px"
                  >
                    <div class="modal-buttons">
                      <button type="button" (click)="openModal()">Query</button>
                      <button type="button" (click)="editStudy()">Edit</button>
                      <button type="button"   (click)="openReviewModal()">Review</button>
                    </div>
                  </div>
                  <div class="modal-overlay" *ngIf="isReasonModalOpen">
                    <div class="modal-content">
                      <button class="close-btn" (click)="cancelEditReason()">
                        ×
                      </button>
                      <h4>Please provide a reason for editing:</h4>
                      <textarea
                        class="form-control"
                        [(ngModel)]="editReason"
                        rows="4"
                        placeholder="Enter reason here..."
                      ></textarea>
                      <div class="modal-footer">
                        <button
                          class="btn custom-button"
                          (click)="confirmEditReason()"
                        >
                          Confirm
                        </button>
                        <button
                          class="btn custom-button"
                          (click)="cancelEditReason()"
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                  <!-- Review Modal -->
                  <div
                    class="modal-overlay1"
                    *ngIf="showReviewModal"
                    (click)="closeReviewModal()"
                  >
                    <!-- Close Button -->
                    <span class="close-button1" (click)="closeReviewModal()"
                      >×</span
                    >
                    <div
                      class="modal-content1"
                      (click)="$event.stopPropagation()"
                    >
                      <div class="checkbox-group">
                        <div class="form-check" style="margin-top: 20px">
                          <input
                            type="checkbox"
                            id="reviewedByDataMonitor"
                            name="reviewedByDataMonitor"
                            [(ngModel)]="reviewOptions.dataMonitor"
                            [disabled]="
                              !hasDispensingDData ||
                              userDesignation !== 'data monitor'
                            "
                            (change)="onReviewCheckboxChange()"
                          />
                          <label for="reviewedByDataMonitor"
                            >Reviewed by Data Monitor</label
                          >
                        </div>
                      </div>
                      <div class="checkbox-group">
                        <div class="form-check">
                          <input
                            type="checkbox"
                            id="reviewedByMonitor"
                            name="reviewedByMonitor"
                            [(ngModel)]="reviewOptions.monitor"
                             [disabled]="
                              !hasDispensingDData ||
                              !reviewOptions.dataMonitor ||
                              userDesignation !== 'monitor'
                            "
                            (change)="onReviewCheckboxChange()"
                          />
                          <label for="reviewedByMonitor"
                            >Reviewed by Monitor</label
                          >
                        </div>
                      </div>
                      <div class="checkbox-group">
                        <div class="form-check">
                          <input
                            type="checkbox"
                            id="reviewedByPI"
                            name="reviewedByPI"
                            [(ngModel)]="reviewOptions.pi"
                            [disabled]="
                              !hasDispensingDData ||
                              !reviewOptions.dataMonitor ||
                              !reviewOptions.monitor ||
                              userDesignation !== 'pi'
                            "
                          />
                          <label for="reviewedByPI">Reviewed by PI</label>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="modal-overlay" *ngIf="isModalOpen">
                    <div class="modal-content">
                      <button class="close-btn" (click)="closeModal()">
                        &times;
                      </button>

                      <!-- Tab Bar -->
                      <div class="tab-bar">
                        <div
                          class="tab"
                          *ngFor="let tab of tabs; let idx = index"
                          [class.active]="selectedTab === idx"
                          (click)="selectTab(idx)"
                        >
                          {{ tab.title }}
                          <span
                            class="close-tab"
                            *ngIf="tabs.length > 1"
                            (click)="closeTab(idx, $event)"
                            >×</span
                          >
                        </div>

                        <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
                        <div
                          *ngIf="tabs[selectedTab].type === 'query'"
                          class="add-btn-wrapper"
                        >
                          <button  type="button" class="add-btn" (click)="addQuery(i)">
                            +
                          </button>
                          <span class="add-query-tooltip">Add Query</span>
                        </div>
                      </div>

                      <!-- Modal Body -->
                      <div class="modal-body">
                        <ng-container [ngSwitch]="tabs[selectedTab].type">
                          <!-- Query Tab -->
                          <div *ngSwitchCase="'query'">
                            <div
                              *ngFor="let query of queries; let i = index"
                              class="query-box"
                            >
                              <div class="input-checkbox-container">
                                <input
                                  type="text"
                                  class="form-control"
                                  [value]="''"
                                  (input)="query.text = $event.target.value"
                                  [readonly]="query.isClosed"
                                  [ngClass]="{ 'query-closed': query.isClosed }"
                                  placeholder="Enter your query"
                                />
                              </div>

                              <!-- Audit Trail -->
                              <div class="audit-trail">
                                <h4>Audit Trail</h4>
                                <div
                                  class="audit-entry"
                                  *ngFor="let entry of query.auditTrail"
                                >
                                  <strong>{{ entry.user }}</strong
                                  >-
                                  {{
                                    entry.timestamp
                                      | date : "dd-MMM-yyyy h:mm a"
                                  }}

                                  <p>{{ entry.message }}</p>
                                </div>
                              </div>
                              <div class="modal-footer">
                                <button
                                  class="btn custom-button"
                                  (click)="confirmCloseQuery(i)"
                                type="button">
                                  Close Query
                                </button>
                                <button
                                  class="btn custom-button ms-2"
                                  (click)="confirmSubmitQuery(i)"
                                 type="button">
                                  Submit
                                </button>
                              </div>
                            </div>
                          </div>

                          <!-- Field History Tab -->
                          <div *ngSwitchCase="'fieldHistory'">
                            <div
                              *ngIf="fieldHistoryData?.length > 0; else noData"
                            >
                              <div
                                *ngFor="let entry of fieldHistoryData"
                                class="history-box"
                              >
                                <div class="history-header">
                                  <strong>{{ entry.updated_by }}</strong> -
                                  {{ entry.updated_at | date : "medium" }}
                                </div>
                                <div class="history-value">
                                  {{ entry.value }}
                                </div>
                                <!-- ✅ Show edit reason if available -->
                                <div
                                  class="edit-reason"
                                  *ngIf="entry.edit_reason"
                                >
                                  <em
                                    >Reason for change:
                                    {{ entry.edit_reason }}</em
                                  >
                                </div>
                              </div>
                            </div>
                            <ng-template #noData>
                              <p>No history available for this field.</p>
                            </ng-template>
                          </div>
                        </ng-container>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- New Fields for Asana Churna Herbal Drink -->
                <div class="mt-3" >
                  <div
                    class="card-header d-flex justify-content-between align-items-center"
                  >
                    <h5 class="m-0">i. Asana Churna Herbal Drink</h5>
                  </div>

                  <div
                    class="form-group mt-4"
                    data-label="1. Total Number of sachets/boxes dispensed in this visit:"
                  >
                  
                                                      <div
                    class="label-wrapper d-flex align-items-center justify-content-between"
                  >
                  <label
                      >1. Total Number of sachets/boxes dispensed in this
                      visit:</label
                    >

                    <div
                      class="menu-icon"
                      (click)="openOptionsModal($event, $event.target)"
                      style="margin-bottom: 8px;"

                    >
                      ⋮
                    </div>
                  </div>
                    <div
                      class="label-wrapper d-flex align-items-center justify-content-between"
                    >
                      <input
                        type="number"
                        [disabled]="isAsanaSachetsDisabled"
                        class="form-control"
                        [(ngModel)]="formData.asanaChurnaSachets"
                        name="asanaChurnaSachets"
                        required
                      />
                
                    </div>
                    <!-- Small Modal (Right-side) -->
                    <div
                      class="options-modal"
                      *ngIf="
                        isOptionsModalOpen &&
                        fieldLabel ===
                          '1. Total Number of sachets/boxes dispensed in this visit:'
                      "
                      (click)="$event.stopPropagation()"
                      style="margin-right: 55px; margin-top: 380px"
                    >
                      <div class="modal-buttons">
                        <button type="button" (click)="openModal()">Query</button>
                        <button type="button" (click)="editStudy()">Edit</button>
                        <button type="button" (click)="openReviewModal()">Review</button>
                      </div>
                    </div>
                    <div class="modal-overlay" *ngIf="isReasonModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="cancelEditReason()">
                          ×
                        </button>
                        <h4>Please provide a reason for editing:</h4>
                        <textarea
                          class="form-control"
                          [(ngModel)]="editReason"
                          rows="4"
                          placeholder="Enter reason here..."
                        ></textarea>
                        <div class="modal-footer">
                          <button
                            class="btn custom-button"
                            (click)="confirmEditReason()"
                          >
                            Confirm
                          </button>
                          <button
                            class="btn custom-button"
                            (click)="cancelEditReason()"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                    <!-- Review Modal -->
                    <div
                      class="modal-overlay1"
                      *ngIf="showReviewModal"
                      (click)="closeReviewModal()"
                    >
                      <!-- Close Button -->
                      <span class="close-button1" (click)="closeReviewModal()"
                        >×</span
                      >
                      <div
                        class="modal-content1"
                        (click)="$event.stopPropagation()"
                      >
                        <div class="checkbox-group">
                          <div class="form-check" style="margin-top: 20px">
                            <input
                              type="checkbox"
                              id="reviewedByDataMonitor"
                              name="reviewedByDataMonitor"
                              [(ngModel)]="reviewOptions.dataMonitor"
                               [disabled]="
                              !hasAsanaSachetsData ||
                              userDesignation !== 'data monitor'
                            "
                            (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByDataMonitor"
                              >Reviewed by Data Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByMonitor"
                              name="reviewedByMonitor"
                              [(ngModel)]="reviewOptions.monitor"
                               [disabled]="
                              !hasAsanaSachetsData ||
                              !reviewOptions.dataMonitor ||
                              userDesignation !== 'monitor'
                            "
                            (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByMonitor"
                              >Reviewed by Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByPI"
                              name="reviewedByPI"
                              [(ngModel)]="reviewOptions.pi"
                              [disabled]="
                              !hasAsanaSachetsData ||
                              !reviewOptions.dataMonitor ||
                              !reviewOptions.monitor ||
                              userDesignation !== 'pi'
                            "
                            />
                            <label for="reviewedByPI">Reviewed by PI</label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="modal-overlay" *ngIf="isModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="closeModal()">
                          &times;
                        </button>

                        <!-- Tab Bar -->
                        <div class="tab-bar">
                          <div
                            class="tab"
                            *ngFor="let tab of tabs; let idx = index"
                            [class.active]="selectedTab === idx"
                            (click)="selectTab(idx)"
                          >
                            {{ tab.title }}
                            <span
                              class="close-tab"
                              *ngIf="tabs.length > 1"
                              (click)="closeTab(idx, $event)"
                              >×</span
                            >
                          </div>

                          <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
                          <div
                            *ngIf="tabs[selectedTab].type === 'query'"
                            class="add-btn-wrapper"
                          >
                            <button  type="button" class="add-btn" (click)="addQuery(i)">
                              +
                            </button>
                            <span class="add-query-tooltip">Add Query</span>
                          </div>
                        </div>

                        <!-- Modal Body -->
                        <div class="modal-body">
                          <ng-container [ngSwitch]="tabs[selectedTab].type">
                            <!-- Query Tab -->
                            <div *ngSwitchCase="'query'">
                              <div
                                *ngFor="let query of queries; let i = index"
                                class="query-box"
                              >
                                <div class="input-checkbox-container">
                                  <input
                                    type="text"
                                    class="form-control"
                                    [value]="''"
                                    (input)="query.text = $event.target.value"
                                    [readonly]="query.isClosed"
                                    [ngClass]="{
                                      'query-closed': query.isClosed
                                    }"
                                    placeholder="Enter your query"
                                  />
                                </div>

                                <!-- Audit Trail -->
                                <div class="audit-trail">
                                  <h4>Audit Trail</h4>
                                  <div
                                    class="audit-entry"
                                    *ngFor="let entry of query.auditTrail"
                                  >
                                    <strong>{{ entry.user }}</strong
                                    >-
                                    {{
                                      entry.timestamp
                                        | date : "dd-MMM-yyyy h:mm a"
                                    }}

                                    <p>{{ entry.message }}</p>
                                  </div>
                                </div>
                                <div class="modal-footer">
                                  <button
                                    class="btn custom-button"
                                    (click)="confirmCloseQuery(i)"
                                  >
                                    Close Query
                                  </button>
                                  <button
                                    class="btn custom-button ms-2"
                                    (click)="confirmSubmitQuery(i)"
                                  >
                                    Submit
                                  </button>
                                </div>
                              </div>
                            </div>

                            <!-- Field History Tab -->
                            <div *ngSwitchCase="'fieldHistory'">
                              <div
                                *ngIf="
                                  fieldHistoryData?.length > 0;
                                  else noData
                                "
                              >
                                <div
                                  *ngFor="let entry of fieldHistoryData"
                                  class="history-box"
                                >
                                  <div class="history-header">
                                    <strong>{{ entry.updated_by }}</strong> -
                                    {{ entry.updated_at | date : "medium" }}
                                  </div>
                                  <div class="history-value">
                                    {{ entry.value }}
                                  </div>
                                  <!-- ✅ Show edit reason if available -->
                                  <div
                                    class="edit-reason"
                                    *ngIf="entry.edit_reason"
                                  >
                                    <em
                                      >Reason for change:
                                      {{ entry.edit_reason }}</em
                                    >
                                  </div>
                                </div>
                              </div>
                              <ng-template #noData>
                                <p>No history available for this field.</p>
                              </ng-template>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="form-group"
                    data-label="2. Total Study Product quantity dispensed in this visit:"
                  >
                
                                                                      <div
                    class="label-wrapper d-flex align-items-center justify-content-between"
                  >
                  <label
                      >2. Total Study Product quantity dispensed in this
                      visit:</label
                    >

                    <div
                      class="menu-icon"
                      (click)="openOptionsModal($event, $event.target)"
                      style="margin-bottom: 8px;"
                    >
                      ⋮
                    </div>
                  </div>
                    <div
                      class="label-wrapper d-flex align-items-center justify-content-between"
                    >
                      <input
                        type="text"
                        [disabled]="isAsanaQuantityDisabled"
                        class="form-control"
                        [(ngModel)]="formData.asanaChurnaQuantity"
                        name="asanaChurnaQuantity"
                        placeholder="000g"
                        pattern="^\d{3}$"
                        required
                        #asanaChurnaQuantity="ngModel"
                      />
                  
                    </div>
                    <!-- Small Modal (Right-side) -->
                    <div
                      class="options-modal"
                      *ngIf="
                        isOptionsModalOpen &&
                        fieldLabel ===
                          '2. Total Study Product quantity dispensed in this visit:'
                      "
                      (click)="$event.stopPropagation()"
                      style="margin-right: 55px; margin-top: 478px"
                    >
                      <div class="modal-buttons">
                        <button type="button" (click)="openModal()">Query</button>
                        <button type="button" (click)="editStudy()">Edit</button>
                        <button type="button"  (click)="openReviewModal()">Review</button>
                      </div>
                    </div>
                    <div class="modal-overlay" *ngIf="isReasonModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="cancelEditReason()">
                          ×
                        </button>
                        <h4>Please provide a reason for editing:</h4>
                        <textarea
                          class="form-control"
                          [(ngModel)]="editReason"
                          rows="4"
                          placeholder="Enter reason here..."
                        ></textarea>
                        <div class="modal-footer">
                          <button
                            class="btn custom-button"
                            (click)="confirmEditReason()"
                          >
                            Confirm
                          </button>
                          <button
                            class="btn custom-button"
                            (click)="cancelEditReason()"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>

                    <!-- Review Modal -->
                    <div
                      class="modal-overlay1"
                      *ngIf="showReviewModal"
                      (click)="closeReviewModal()"
                    >
                      <!-- Close Button -->
                      <span class="close-button1" (click)="closeReviewModal()"
                        >×</span
                      >
                      <div
                        class="modal-content1"
                        (click)="$event.stopPropagation()"
                      >
                        <div class="checkbox-group">
                          <div class="form-check" style="margin-top: 20px">
                            <input
                              type="checkbox"
                              id="reviewedByDataMonitor"
                              name="reviewedByDataMonitor"
                              [(ngModel)]="reviewOptions.dataMonitor"
                               [disabled]="
                              !hasAsanaQuantityData ||
                              userDesignation !== 'data monitor'
                            "
                            (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByDataMonitor"
                              >Reviewed by Data Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByMonitor"
                              name="reviewedByMonitor"
                              [(ngModel)]="reviewOptions.monitor"
                               [disabled]="
                              !hasAsanaQuantityData ||
                              !reviewOptions.dataMonitor ||
                              userDesignation !== 'monitor'
                            "
                            (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByMonitor"
                              >Reviewed by Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByPI"
                              name="reviewedByPI"
                              [(ngModel)]="reviewOptions.pi"
                              [disabled]="
                              !hasAsanaQuantityData ||
                              !reviewOptions.dataMonitor ||
                              !reviewOptions.monitor ||
                              userDesignation !== 'pi'
                            "
                            />
                            <label for="reviewedByPI">Reviewed by PI</label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="modal-overlay" *ngIf="isModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="closeModal()">
                          &times;
                        </button>

                        <!-- Tab Bar -->
                        <div class="tab-bar">
                          <div
                            class="tab"
                            *ngFor="let tab of tabs; let idx = index"
                            [class.active]="selectedTab === idx"
                            (click)="selectTab(idx)"
                          >
                            {{ tab.title }}
                            <span
                              class="close-tab"
                              *ngIf="tabs.length > 1"
                              (click)="closeTab(idx, $event)"
                              >×</span
                            >
                          </div>

                          <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
                          <div
                            *ngIf="tabs[selectedTab].type === 'query'"
                            class="add-btn-wrapper"
                          >
                            <button  type="button" class="add-btn" (click)="addQuery(i)">
                              +
                            </button>
                            <span class="add-query-tooltip">Add Query</span>
                          </div>
                        </div>

                        <!-- Modal Body -->
                        <div class="modal-body">
                          <ng-container [ngSwitch]="tabs[selectedTab].type">
                            <!-- Query Tab -->
                            <div *ngSwitchCase="'query'">
                              <div
                                *ngFor="let query of queries; let i = index"
                                class="query-box"
                              >
                                <div class="input-checkbox-container">
                                  <input
                                    type="text"
                                    class="form-control"
                                    [value]="''"
                                    (input)="query.text = $event.target.value"
                                    [readonly]="query.isClosed"
                                    [ngClass]="{
                                      'query-closed': query.isClosed
                                    }"
                                    placeholder="Enter your query"
                                  />
                                </div>

                                <!-- Audit Trail -->
                                <div class="audit-trail">
                                  <h4>Audit Trail</h4>
                                  <div
                                    class="audit-entry"
                                    *ngFor="let entry of query.auditTrail"
                                  >
                                    <strong>{{ entry.user }}</strong
                                    >-
                                    {{
                                      entry.timestamp
                                        | date : "dd-MMM-yyyy h:mm a"
                                    }}

                                    <p>{{ entry.message }}</p>
                                  </div>
                                </div>
                                <div class="modal-footer">
                                  <button
                                    class="btn custom-button"
                                    [ngClass]="{
                                      'btn-disabled': query.isClosed
                                    }"
                                    (click)="
                                      !query.isClosed && confirmCloseQuery(i)
                                    "
                                  >
                                    Close
                                  </button>
                                  <button
                                    class="btn custom-button ms-2"
                                    (click)="confirmSubmitQuery(i)"
                                    [disabled]="query.isClosed"
                                  >
                                    Submit
                                  </button>
                                </div>
                              </div>
                            </div>

                            <!-- Field History Tab -->
                            <div *ngSwitchCase="'fieldHistory'">
                              <div
                                *ngIf="
                                  fieldHistoryData?.length > 0;
                                  else noData
                                "
                              >
                                <div
                                  *ngFor="let entry of fieldHistoryData"
                                  class="history-box"
                                >
                                  <div class="history-header">
                                    <strong>{{ entry.updated_by }}</strong> -
                                    {{ entry.updated_at | date : "medium" }}
                                  </div>
                                  <div class="history-value">
                                    {{ entry.value }}
                                  </div>
                                  <!-- ✅ Show edit reason if available -->
                                  <div
                                    class="edit-reason"
                                    *ngIf="entry.edit_reason"
                                  >
                                    <em
                                      >Reason for change:
                                      {{ entry.edit_reason }}</em
                                    >
                                  </div>
                                </div>
                              </div>
                              <ng-template #noData>
                                <p>No history available for this field.</p>
                              </ng-template>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="form-group" data-label="3. Batch Number:">
                                                         <div
                    class="label-wrapper d-flex align-items-center justify-content-between"
                  >
                    <label>3. Batch Number:</label>

                    <div
                      class="menu-icon"
                      (click)="openOptionsModal($event, $event.target)"
                      style="margin-bottom: 8px;"

                    >
                      ⋮
                    </div>
                  </div>
                    <div
                      class="label-wrapper d-flex align-items-center justify-content-between"
                    >
                      <input
                        type="number"
                        [disabled]="isAsanaBatchDisabled"
                        class="form-control"
                        [(ngModel)]="formData.asanaChurnaBatchNumber"
                        name="asanaChurnaBatchNumber"
                        required
                      />                 
                    </div>
                    <!-- Small Modal (Right-side) -->
                    <div
                      class="options-modal"
                      *ngIf="
                        isOptionsModalOpen && fieldLabel === '3. Batch Number:'
                      "
                      (click)="$event.stopPropagation()"
                      style="margin-right: 55px; margin-top: 578px"
                    >
                      <div class="modal-buttons">
                        <button type="button" (click)="openModal()">Query</button>
                        <button type="button" (click)="editStudy()">Edit</button>
                        <button type="button"  (click)="openReviewModal()">Review</button>
                      </div>
                    </div>
                    <div class="modal-overlay" *ngIf="isReasonModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="cancelEditReason()">
                          ×
                        </button>
                        <h4>Please provide a reason for editing:</h4>
                        <textarea
                          class="form-control"
                          [(ngModel)]="editReason"
                          rows="4"
                          placeholder="Enter reason here..."
                        ></textarea>
                        <div class="modal-footer">
                          <button
                            class="btn custom-button"
                            (click)="confirmEditReason()"
                          >
                            Confirm
                          </button>
                          <button
                            class="btn custom-button"
                            (click)="cancelEditReason()"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>

                    <!-- Review Modal -->
                    <div
                      class="modal-overlay1"
                      *ngIf="showReviewModal"
                      (click)="closeReviewModal()"
                    >
                      <!-- Close Button -->
                      <span class="close-button1" (click)="closeReviewModal()"
                        >×</span
                      >
                      <div
                        class="modal-content1"
                        (click)="$event.stopPropagation()"
                      >
                        <div class="checkbox-group">
                          <div class="form-check" style="margin-top: 20px">
                            <input
                              type="checkbox"
                              id="reviewedByDataMonitor"
                              name="reviewedByDataMonitor"
                              [(ngModel)]="reviewOptions.dataMonitor"
                              [disabled]="
                              !hasAsanaBatchData ||
                              userDesignation !== 'data monitor'
                            "
                            (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByDataMonitor"
                              >Reviewed by Data Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByMonitor"
                              name="reviewedByMonitor"
                              [(ngModel)]="reviewOptions.monitor"
                               [disabled]="
                              !hasAsanaBatchData ||
                              !reviewOptions.dataMonitor ||
                              userDesignation !== 'monitor'
                            "
                            (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByMonitor"
                              >Reviewed by Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByPI"
                              name="reviewedByPI"
                              [(ngModel)]="reviewOptions.pi"
                               [disabled]="
                              !hasAsanaBatchData ||
                              !reviewOptions.dataMonitor ||
                              !reviewOptions.monitor ||
                              userDesignation !== 'pi'
                            "
                            />
                            <label for="reviewedByPI">Reviewed by PI</label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="modal-overlay" *ngIf="isModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="closeModal()">
                          &times;
                        </button>

                        <!-- Tab Bar -->
                        <div class="tab-bar">
                          <div
                            class="tab"
                            *ngFor="let tab of tabs; let idx = index"
                            [class.active]="selectedTab === idx"
                            (click)="selectTab(idx)"
                          >
                            {{ tab.title }}
                            <span
                              class="close-tab"
                              *ngIf="tabs.length > 1"
                              (click)="closeTab(idx, $event)"
                              >×</span
                            >
                          </div>

                          <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
                          <div
                            *ngIf="tabs[selectedTab].type === 'query'"
                            class="add-btn-wrapper"
                          >
                            <button  type="button" class="add-btn" (click)="addQuery(i)">
                              +
                            </button>
                            <span class="add-query-tooltip">Add Query</span>
                          </div>
                        </div>

                        <!-- Modal Body -->
                        <div class="modal-body">
                          <ng-container [ngSwitch]="tabs[selectedTab].type">
                            <!-- Query Tab -->
                            <div *ngSwitchCase="'query'">
                              <div
                                *ngFor="let query of queries; let i = index"
                                class="query-box"
                              >
                                <div class="input-checkbox-container">
                                  <input
                                    type="text"
                                    class="form-control"
                                    [value]="''"
                                    (input)="query.text = $event.target.value"
                                    [readonly]="query.isClosed"
                                    [ngClass]="{
                                      'query-closed': query.isClosed
                                    }"
                                    placeholder="Enter your query"
                                  />
                                </div>

                                <!-- Audit Trail -->
                                <div class="audit-trail">
                                  <h4>Audit Trail</h4>
                                  <div
                                    class="audit-entry"
                                    *ngFor="let entry of query.auditTrail"
                                  >
                                    <strong>{{ entry.user }}</strong
                                    >-
                                    {{
                                      entry.timestamp
                                        | date : "dd-MMM-yyyy h:mm a"
                                    }}

                                    <p>{{ entry.message }}</p>
                                  </div>
                                </div>
                                <div class="modal-footer">
                                  <button
                                    class="btn custom-button"
                                    (click)="confirmCloseQuery(i)"
                                  >
                                    Close Query
                                  </button>
                                  <button
                                    class="btn custom-button ms-2"
                                    (click)="confirmSubmitQuery(i)"
                                  >
                                    Submit
                                  </button>
                                </div>
                              </div>
                            </div>

                            <!-- Field History Tab -->
                            <div *ngSwitchCase="'fieldHistory'">
                              <div
                                *ngIf="
                                  fieldHistoryData?.length > 0;
                                  else noData
                                "
                              >
                                <div
                                  *ngFor="let entry of fieldHistoryData"
                                  class="history-box"
                                >
                                  <div class="history-header">
                                    <strong>{{ entry.updated_by }}</strong> -
                                    {{ entry.updated_at | date : "medium" }}
                                  </div>
                                  <div class="history-value">
                                    {{ entry.value }}
                                  </div>
                                  <!-- ✅ Show edit reason if available -->
                                  <div
                                    class="edit-reason"
                                    *ngIf="entry.edit_reason"
                                  >
                                    <em
                                      >Reason for change:
                                      {{ entry.edit_reason }}</em
                                    >
                                  </div>
                                </div>
                              </div>
                              <ng-template #noData>
                                <p>No history available for this field.</p>
                              </ng-template>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-group" data-label="4. Date of Expiry:">
                                                            <div
                    class="label-wrapper d-flex align-items-center justify-content-between"
                  >
                                    <label>4. Date of Expiry:</label>


                    <div
                      class="menu-icon"
                      (click)="openOptionsModal($event, $event.target)"
                      style="margin-bottom: 8px;"

                    >
                      ⋮
                    </div>
                  </div>
                   <div
                    class="d-flex align-items-center justify-content-between"
                  >
                    <input
                      type="date"
                      class="form-control"
                      [(ngModel)]="formData.asanaChurnaExpiryDate"
                      [disabled]="isAsanaExpiryDisabled"
                      name="asanaChurnaExpiryDate"
                      [min]="screeningMinDate"
                      [max]="todayDate"
                      required
                    />
               
                  </div>
 <!-- Small Modal (Right-side) -->
                  <div
                    class="options-modal"
                    *ngIf="
                      isOptionsModalOpen &&
                      fieldLabel === '4. Date of Expiry
                      :'
                    "
                    (click)="$event.stopPropagation()"
                    style="margin-right: 55px; margin-top: 678px"
                  >
                    <div class="modal-buttons">
                      <button type="button" (click)="openModal()">Query</button>
                      <button type="button" (click)="editStudy()">Edit</button>
                      <button type="button" (click)="openReviewModal()">
                        Review
                      </button>
                    </div>
                  </div>

                  <div class="modal-overlay" *ngIf="isReasonModalOpen">
                    <div class="modal-content">
                      <button class="close-btn" (click)="cancelEditReason()">
                        ×
                      </button>
                      <h4>Please provide a reason for editing:</h4>
                      <textarea
                        class="form-control"
                        [(ngModel)]="editReason"
                        rows="4"
                        placeholder="Enter reason here..."
                      ></textarea>
                      <div class="modal-footer">
                        <button
                          class="btn custom-button"
                          (click)="confirmEditReason()"
                        >
                          Confirm
                        </button>
                        <button
                          class="btn custom-button"
                          (click)="cancelEditReason()"
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>

                  <!-- Review Modal -->
                  <div
                    class="modal-overlay1"
                    *ngIf="showReviewModal"
                    (click)="closeReviewModal()"
                  >
                    <!-- Close Button -->
                    <span class="close-button1" (click)="closeReviewModal()"
                      >×</span
                    >
                    <div
                      class="modal-content1"
                      (click)="$event.stopPropagation()"
                    >
                      <div class="checkbox-group">
                        <div class="form-check" style="margin-top: 20px">
                          <input
                            type="checkbox"
                            id="reviewedByDataMonitor"
                            name="reviewedByDataMonitor"
                            [(ngModel)]="reviewOptions.dataMonitor"
                            [disabled]="
                              !hasAsanaExpiryData ||
                              userDesignation !== 'data monitor'
                            "
                            (change)="onReviewCheckboxChange()"
                          />
                          <label for="reviewedByDataMonitor"
                            >Reviewed by Data Monitor</label
                          >
                        </div>
                      </div>
                      <div class="checkbox-group">
                        <div class="form-check">
                          <input
                            type="checkbox"
                            id="reviewedByMonitor"
                            name="reviewedByMonitor"
                            [(ngModel)]="reviewOptions.monitor"
                            [disabled]="
                              !hasAsanaExpiryData ||
                              !reviewOptions.dataMonitor ||
                              userDesignation !== 'monitor'
                            "
                            (change)="onReviewCheckboxChange()"
                          />
                          <label for="reviewedByMonitor"
                            >Reviewed by Monitor</label
                          >
                        </div>
                      </div>
                      <div class="checkbox-group">
                        <div class="form-check">
                          <input
                            type="checkbox"
                            id="reviewedByPI"
                            name="reviewedByPI"
                            [(ngModel)]="reviewOptions.pi"
                            [disabled]="
                              !hasAsanaExpiryData ||
                              !reviewOptions.dataMonitor ||
                              !reviewOptions.monitor ||
                              userDesignation !== 'pi'
                            "
                          />
                          <label for="reviewedByPI">Reviewed by PI</label>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="modal-overlay" *ngIf="isModalOpen">
                    <div class="modal-content">
                      <button class="close-btn" (click)="closeModal()">
                        &times;
                      </button>

                      <!-- Tab Bar -->
                      <div class="tab-bar">
                        <div
                          class="tab"
                          *ngFor="let tab of tabs; let idx = index"
                          [class.active]="selectedTab === idx"
                          (click)="selectTab(idx)"
                        >
                          {{ tab.title }}
                          <span
                            class="close-tab"
                            *ngIf="tabs.length > 1"
                            (click)="closeTab(idx, $event)"
                            >×</span
                          >
                        </div>

                        <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
                        <div
                          *ngIf="tabs[selectedTab].type === 'query'"
                          class="add-btn-wrapper"
                        >
                          <button  type="button" class="add-btn" (click)="addQuery(i)">
                            +
                          </button>
                          <span class="add-query-tooltip">Add Query</span>
                        </div>
                      </div>

                      <!-- Modal Body -->
                      <div class="modal-body">
                        <ng-container [ngSwitch]="tabs[selectedTab].type">
                          <!-- Query Tab -->
                          <div *ngSwitchCase="'query'">
                            <div
                              *ngFor="let query of queries; let i = index"
                              class="query-box"
                            >
                              <div class="input-checkbox-container">
                                <input
                                  type="text"
                                  class="form-control"
                                  [value]="''"
                                  (input)="query.text = $event.target.value"
                                  [readonly]="query.isClosed"
                                  [ngClass]="{ 'query-closed': query.isClosed }"
                                  placeholder="Enter your query"
                                />
                              </div>

                              <!-- Audit Trail -->
                              <div class="audit-trail">
                                <h4>Audit Trail</h4>
                                <div
                                  class="audit-entry"
                                  *ngFor="let entry of query.auditTrail"
                                >
                                  <strong>{{ entry.user }}</strong
                                  >-
                                  {{
                                    entry.timestamp
                                      | date : "dd-MMM-yyyy h:mm a"
                                  }}

                                  <p>{{ entry.message }}</p>
                                </div>
                              </div>
                              <div class="modal-footer">
                                <button
                                  class="btn custom-button"
                                  (click)="confirmCloseQuery(i)"
                                type="button">
                                  Close Query
                                </button>
                                <button
                                  class="btn custom-button ms-2"
                                  (click)="confirmSubmitQuery(i)"
                                 type="button">
                                  Submit
                                </button>
                              </div>
                            </div>
                          </div>

                          <!-- Field History Tab -->
                          <div *ngSwitchCase="'fieldHistory'">
                            <div
                              *ngIf="fieldHistoryData?.length > 0; else noData"
                            >
                              <div
                                *ngFor="let entry of fieldHistoryData"
                                class="history-box"
                              >
                                <div class="history-header">
                                  <strong>{{ entry.updated_by }}</strong> -
                                  {{ entry.updated_at | date : "medium" }}
                                </div>
                                <div class="history-value">
                                  {{ entry.value }}
                                </div>
                                <!-- ✅ Show edit reason if available -->
                                <div
                                  class="edit-reason"
                                  *ngIf="entry.edit_reason"
                                >
                                  <em
                                    >Reason for change:
                                    {{ entry.edit_reason }}</em
                                  >
                                </div>
                              </div>
                            </div>
                            <ng-template #noData>
                              <p>No history available for this field.</p>
                            </ng-template>
                          </div>
                        </ng-container>
                      </div>
                    </div>
                  </div>
                  </div>
                </div>

                <!-- New Fields for Triphala Tablet -->
                <div class="mt-3">
                  <div
                    class="card-header d-flex justify-content-between align-items-center"
                  >
                    <h5 class="m-0">ii. Triphala Tablet</h5>
                  </div>
                  <div class="form-group mt-4" data-label="1. Total Number of sachets/boxes dispensed in this visit:">
                    <label
                      >1. Total Number of sachets/boxes dispensed in this
                      visit:</label
                    >
                    <div
                      class="label-wrapper d-flex align-items-center justify-content-between"
                    >
                    <input
                      type="number"
                      class="form-control"
                      [(ngModel)]="formData.triphalaSachets"
                      [disabled]="isTriphalaSachetsDisabled"
                      name="triphalaSachets"
                      required
                    />
                     <div
                        class="menu-icon"
                        (click)="openOptionsModal($event, $event.target)"
                      >
                        ⋮
                      </div>
                    </div>
                      <!-- Small Modal (Right-side) -->
                    <div
                      class="options-modal"
                      *ngIf="
                        isOptionsModalOpen &&
                        fieldLabel ===
                          '1. Total Number of sachets/boxes dispensed in this visit:'
                      "
                      (click)="$event.stopPropagation()"
                      style="margin-right: 50px; margin-top: -10px"
                    >
                      <div class="modal-buttons">
                        <button (click)="openModal()">Query</button>
                        <button (click)="editStudy()">Edit</button>
                        <button type="button" (click)="openReviewModal()">
                          Review
                        </button>
                      </div>
                    </div>
                    <div class="modal-overlay" *ngIf="isReasonModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="cancelEditReason()">
                          ×
                        </button>
                        <h4>Please provide a reason for editing:</h4>
                        <textarea
                          class="form-control"
                          [(ngModel)]="editReason"
                          rows="4"
                          placeholder="Enter reason here..."
                        ></textarea>
                        <div class="modal-footer">
                          <button
                            class="btn custom-button"
                            (click)="confirmEditReason()"
                          >
                            Confirm
                          </button>
                          <button
                            class="btn custom-button"
                            (click)="cancelEditReason()"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>

                    <!-- Review Modal -->
                    <div
                      class="modal-overlay1"
                      *ngIf="showReviewModal"
                      (click)="closeReviewModal()"
                    >
                      <!-- Close Button -->
                      <span class="close-button1" (click)="closeReviewModal()"
                        >×</span
                      >
                      <div
                        class="modal-content1"
                        (click)="$event.stopPropagation()"
                      >
                        <div class="checkbox-group">
                          <div class="form-check" style="margin-top: 20px">
                            <input
                              type="checkbox"
                              id="reviewedByDataMonitor"
                              name="reviewedByDataMonitor"
                              [(ngModel)]="reviewOptions.dataMonitor"
                              [disabled]="
                                !hasTriphalaSachetsData ||
                                userDesignation !== 'data monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByDataMonitor"
                              >Reviewed by Data Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByMonitor"
                              name="reviewedByMonitor"
                              [(ngModel)]="reviewOptions.monitor"
                              [disabled]="
                                !hasTriphalaSachetsSData ||
                                !reviewOptions.dataMonitor ||
                                userDesignation !== 'monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByMonitor"
                              >Reviewed by Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByPI"
                              name="reviewedByPI"
                              [(ngModel)]="reviewOptions.pi"
                              [disabled]="
                                !hasTriphalaSachetsData ||
                                !reviewOptions.dataMonitor ||
                                !reviewOptions.monitor ||
                                userDesignation !== 'pi'
                              "
                            />
                            <label for="reviewedByPI">Reviewed by PI</label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="modal-overlay" *ngIf="isModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="closeModal()">
                          &times;
                        </button>

                        <!-- Tab Bar -->
                        <div class="tab-bar">
                          <div
                            class="tab"
                            *ngFor="let tab of tabs; let idx = index"
                            [class.active]="selectedTab === idx"
                            (click)="selectTab(idx)"
                          >
                            {{ tab.title }}
                            <span
                              class="close-tab"
                              *ngIf="tabs.length > 1"
                              (click)="closeTab(idx, $event)"
                              >×</span
                            >
                          </div>

                          <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
                          <div
                            *ngIf="tabs[selectedTab].type === 'query'"
                            class="add-btn-wrapper"
                          >
                            <button class="add-btn" (click)="addQuery(i)">
                              +
                            </button>
                            <span class="add-query-tooltip">Add Query</span>
                          </div>
                        </div>

                        <!-- Modal Body -->
                        <div class="modal-body">
                          <ng-container [ngSwitch]="tabs[selectedTab].type">
                            <!-- Query Tab -->
                            <div *ngSwitchCase="'query'">
                              <div
                                *ngFor="let query of queries; let i = index"
                                class="query-box"
                              >
                                <div class="input-checkbox-container">
                                  <input
                                    type="text"
                                    class="form-control"
                                    [value]="''"
                                    (input)="query.text = $event.target.value"
                                    [readonly]="query.isClosed"
                                    [ngClass]="{
                                      'query-closed': query.isClosed
                                    }"
                                    placeholder="Enter your query"
                                  />
                                </div>

                                <!-- Audit Trail -->
                                <div class="audit-trail">
                                  <h4>Audit Trail</h4>
                                  <div
                                    class="audit-entry"
                                    *ngFor="let entry of query.auditTrail"
                                  >
                                    <strong>{{ entry.user }}</strong
                                    >-
                                    {{
                                      entry.timestamp
                                        | date : "dd-MMM-yyyy h:mm a"
                                    }}

                                    <p>{{ entry.message }}</p>
                                  </div>
                                </div>
                                <div class="modal-footer">
                                  <button
                                    class="btn custom-button"
                                    [ngClass]="{
                                      'btn-disabled': query.isClosed
                                    }"
                                    (click)="
                                      !query.isClosed && confirmCloseQuery(i)
                                    "
                                  >
                                    Close
                                  </button>
                                  <button
                                    class="btn custom-button ms-2"
                                    (click)="confirmSubmitQuery(i)"
                                    [disabled]="query.isClosed"
                                  >
                                    Submit
                                  </button>
                                </div>
                              </div>
                            </div>

                            <!-- Field History Tab -->
                            <div *ngSwitchCase="'fieldHistory'">
                              <div
                                *ngIf="
                                  fieldHistoryData?.length > 0;
                                  else noData
                                "
                              >
                                <div
                                  *ngFor="let entry of fieldHistoryData"
                                  class="history-box"
                                >
                                  <div class="history-header">
                                    <strong>{{ entry.updated_by }}</strong> -
                                    {{ entry.updated_at | date : "medium" }}
                                  </div>
                                  <div class="history-value">
                                    {{ entry.value }}
                                  </div>
                                  <!-- ✅ Show edit reason if available -->
                                  <div
                                    class="edit-reason"
                                    *ngIf="entry.edit_reason"
                                  >
                                    <em
                                      >Reason for change:
                                      {{ entry.edit_reason }}</em
                                    >
                                  </div>
                                </div>
                              </div>
                              <ng-template #noData>
                                <p>No history available for this field.</p>
                              </ng-template>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-group" data-label="2. Total Study Product quantity dispensed in this visit:">
                    <label
                      >2. Total Study Product quantity dispensed in this
                      visit:</label
                    >
                    <div
                      class="label-wrapper d-flex align-items-center justify-content-between"
                    >
                    <input
                      type="number"
                      class="form-control"
                      [(ngModel)]="formData.triphalaQuantity"
                      name="triphalaQuantity"
                      placeholder="000g"
                      [disabled]="isTriphalaQuantityDisabled"
                      pattern="^\d{3}$"
                      required
                      #triphalaQuantity="ngModel"
                    />
                    <div
                        class="menu-icon"
                        (click)="openOptionsModal($event, $event.target)"
                      >
                        ⋮
                      </div>

                    </div>
                    <!-- Small Modal (Right-side) -->
                    <div
                      class="options-modal"
                      *ngIf="
                        isOptionsModalOpen &&
                        fieldLabel ===
                          '2. Total Study Product quantity dispensed in this visit:'
                      "
                      (click)="$event.stopPropagation()"
                      style="margin-right: 50px; margin-top: -10px"
                    >
                      <div class="modal-buttons">
                        <button (click)="openModal()">Query</button>
                        <button (click)="editStudy()">Edit</button>
                        <button type="button" (click)="openReviewModal()">
                          Review
                        </button>
                      </div>
                    </div>
                    <div class="modal-overlay" *ngIf="isReasonModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="cancelEditReason()">
                          ×
                        </button>
                        <h4>Please provide a reason for editing:</h4>
                        <textarea
                          class="form-control"
                          [(ngModel)]="editReason"
                          rows="4"
                          placeholder="Enter reason here..."
                        ></textarea>
                        <div class="modal-footer">
                          <button
                            class="btn custom-button"
                            (click)="confirmEditReason()"
                          >
                            Confirm
                          </button>
                          <button
                            class="btn custom-button"
                            (click)="cancelEditReason()"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>

                    <!-- Review Modal -->
                    <div
                      class="modal-overlay1"
                      *ngIf="showReviewModal"
                      (click)="closeReviewModal()"
                    >
                      <!-- Close Button -->
                      <span class="close-button1" (click)="closeReviewModal()"
                        >×</span
                      >
                      <div
                        class="modal-content1"
                        (click)="$event.stopPropagation()"
                      >
                        <div class="checkbox-group">
                          <div class="form-check" style="margin-top: 20px">
                            <input
                              type="checkbox"
                              id="reviewedByDataMonitor"
                              name="reviewedByDataMonitor"
                              [(ngModel)]="reviewOptions.dataMonitor"
                              [disabled]="
                                !hasTriphalaQuantityData  ||
                                userDesignation !== 'data monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByDataMonitor"
                              >Reviewed by Data Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByMonitor"
                              name="reviewedByMonitor"
                              [(ngModel)]="reviewOptions.monitor"
                              [disabled]="
                                !hasTriphalaQuantityData  ||
                                !reviewOptions.dataMonitor ||
                                userDesignation !== 'monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByMonitor"
                              >Reviewed by Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByPI"
                              name="reviewedByPI"
                              [(ngModel)]="reviewOptions.pi"
                              [disabled]="
                                !hasTriphalaQuantityData ||
                                !reviewOptions.dataMonitor ||
                                !reviewOptions.monitor ||
                                userDesignation !== 'pi'
                              "
                            />
                            <label for="reviewedByPI">Reviewed by PI</label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="modal-overlay" *ngIf="isModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="closeModal()">
                          &times;
                        </button>

                        <!-- Tab Bar -->
                        <div class="tab-bar">
                          <div
                            class="tab"
                            *ngFor="let tab of tabs; let idx = index"
                            [class.active]="selectedTab === idx"
                            (click)="selectTab(idx)"
                          >
                            {{ tab.title }}
                            <span
                              class="close-tab"
                              *ngIf="tabs.length > 1"
                              (click)="closeTab(idx, $event)"
                              >×</span
                            >
                          </div>

                          <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
                          <div
                            *ngIf="tabs[selectedTab].type === 'query'"
                            class="add-btn-wrapper"
                          >
                            <button class="add-btn" (click)="addQuery(i)">
                              +
                            </button>
                            <span class="add-query-tooltip">Add Query</span>
                          </div>
                        </div>

                        <!-- Modal Body -->
                        <div class="modal-body">
                          <ng-container [ngSwitch]="tabs[selectedTab].type">
                            <!-- Query Tab -->
                            <div *ngSwitchCase="'query'">
                              <div
                                *ngFor="let query of queries; let i = index"
                                class="query-box"
                              >
                                <div class="input-checkbox-container">
                                  <input
                                    type="text"
                                    class="form-control"
                                    [value]="''"
                                    (input)="query.text = $event.target.value"
                                    [readonly]="query.isClosed"
                                    [ngClass]="{
                                      'query-closed': query.isClosed
                                    }"
                                    placeholder="Enter your query"
                                  />
                                </div>

                                <!-- Audit Trail -->
                                <div class="audit-trail">
                                  <h4>Audit Trail</h4>
                                  <div
                                    class="audit-entry"
                                    *ngFor="let entry of query.auditTrail"
                                  >
                                    <strong>{{ entry.user }}</strong
                                    >-
                                    {{
                                      entry.timestamp
                                        | date : "dd-MMM-yyyy h:mm a"
                                    }}

                                    <p>{{ entry.message }}</p>
                                  </div>
                                </div>
                                <div class="modal-footer">
                                  <button
                                    class="btn custom-button"
                                    [ngClass]="{
                                      'btn-disabled': query.isClosed
                                    }"
                                    (click)="
                                      !query.isClosed && confirmCloseQuery(i)
                                    "
                                  >
                                    Close
                                  </button>
                                  <button
                                    class="btn custom-button ms-2"
                                    (click)="confirmSubmitQuery(i)"
                                    [disabled]="query.isClosed"
                                  >
                                    Submit
                                  </button>
                                </div>
                              </div>
                            </div>

                            <!-- Field History Tab -->
                            <div *ngSwitchCase="'fieldHistory'">
                              <div
                                *ngIf="
                                  fieldHistoryData?.length > 0;
                                  else noData
                                "
                              >
                                <div
                                  *ngFor="let entry of fieldHistoryData"
                                  class="history-box"
                                >
                                  <div class="history-header">
                                    <strong>{{ entry.updated_by }}</strong> -
                                    {{ entry.updated_at | date : "medium" }}
                                  </div>
                                  <div class="history-value">
                                    {{ entry.value }}
                                  </div>
                                  <!-- ✅ Show edit reason if available -->
                                  <div
                                    class="edit-reason"
                                    *ngIf="entry.edit_reason"
                                  >
                                    <em
                                      >Reason for change:
                                      {{ entry.edit_reason }}</em
                                    >
                                  </div>
                                </div>
                              </div>
                              <ng-template #noData>
                                <p>No history available for this field.</p>
                              </ng-template>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </div>

                  </div>
                  <div class="form-group" data-label="3. Batch Number:">
                    <label>3. Batch Number:</label>
                     <div
                      class="label-wrapper d-flex align-items-center justify-content-between"
                    >
                    <input
                      type="number"
                      class="form-control"
                      [(ngModel)]="formData.triphalaBatchNumber"
                      name="triphalaBatchNumber"
                      [disabled]="isTriphalaBatchDisabled"
                      required
                    />
 <div
                        class="menu-icon"
                        (click)="openOptionsModal($event, $event.target)"
                      >
                        ⋮
                      </div>
                       <!-- Small Modal (Right-side) -->
                    <div
                      class="options-modal"
                      *ngIf="
                        isOptionsModalOpen &&
                        fieldLabel ===
                          '3. Batch Number:'
                      "
                      (click)="$event.stopPropagation()"
                      style="margin-right: 50px; margin-top: -10px"
                    >
                      <div class="modal-buttons">
                        <button (click)="openModal()">Query</button>
                        <button (click)="editStudy()">Edit</button>
                        <button type="button" (click)="openReviewModal()">
                          Review
                        </button>
                      </div>
                    </div>
                    <div class="modal-overlay" *ngIf="isReasonModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="cancelEditReason()">
                          ×
                        </button>
                        <h4>Please provide a reason for editing:</h4>
                        <textarea
                          class="form-control"
                          [(ngModel)]="editReason"
                          rows="4"
                          placeholder="Enter reason here..."
                        ></textarea>
                        <div class="modal-footer">
                          <button
                            class="btn custom-button"
                            (click)="confirmEditReason()"
                          >
                            Confirm
                          </button>
                          <button
                            class="btn custom-button"
                            (click)="cancelEditReason()"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>

                    <!-- Review Modal -->
                    <div
                      class="modal-overlay1"
                      *ngIf="showReviewModal"
                      (click)="closeReviewModal()"
                    >
                      <!-- Close Button -->
                      <span class="close-button1" (click)="closeReviewModal()"
                        >×</span
                      >
                      <div
                        class="modal-content1"
                        (click)="$event.stopPropagation()"
                      >
                        <div class="checkbox-group">
                          <div class="form-check" style="margin-top: 20px">
                            <input
                              type="checkbox"
                              id="reviewedByDataMonitor"
                              name="reviewedByDataMonitor"
                              [(ngModel)]="reviewOptions.dataMonitor"
                              [disabled]="
                                !hasTriphalaBatchData||
                                userDesignation !== 'data monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByDataMonitor"
                              >Reviewed by Data Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByMonitor"
                              name="reviewedByMonitor"
                              [(ngModel)]="reviewOptions.monitor"
                              [disabled]="
                                !hasTriphalaBatchData ||
                                !reviewOptions.dataMonitor ||
                                userDesignation !== 'monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByMonitor"
                              >Reviewed by Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByPI"
                              name="reviewedByPI"
                              [(ngModel)]="reviewOptions.pi"
                              [disabled]="
                                !hasTriphalaBatchData||
                                !reviewOptions.dataMonitor ||
                                !reviewOptions.monitor ||
                                userDesignation !== 'pi'
                              "
                            />
                            <label for="reviewedByPI">Reviewed by PI</label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="modal-overlay" *ngIf="isModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="closeModal()">
                          &times;
                        </button>

                        <!-- Tab Bar -->
                        <div class="tab-bar">
                          <div
                            class="tab"
                            *ngFor="let tab of tabs; let idx = index"
                            [class.active]="selectedTab === idx"
                            (click)="selectTab(idx)"
                          >
                            {{ tab.title }}
                            <span
                              class="close-tab"
                              *ngIf="tabs.length > 1"
                              (click)="closeTab(idx, $event)"
                              >×</span
                            >
                          </div>

                          <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
                          <div
                            *ngIf="tabs[selectedTab].type === 'query'"
                            class="add-btn-wrapper"
                          >
                            <button class="add-btn" (click)="addQuery(i)">
                              +
                            </button>
                            <span class="add-query-tooltip">Add Query</span>
                          </div>
                        </div>

                        <!-- Modal Body -->
                        <div class="modal-body">
                          <ng-container [ngSwitch]="tabs[selectedTab].type">
                            <!-- Query Tab -->
                            <div *ngSwitchCase="'query'">
                              <div
                                *ngFor="let query of queries; let i = index"
                                class="query-box"
                              >
                                <div class="input-checkbox-container">
                                  <input
                                    type="text"
                                    class="form-control"
                                    [value]="''"
                                    (input)="query.text = $event.target.value"
                                    [readonly]="query.isClosed"
                                    [ngClass]="{
                                      'query-closed': query.isClosed
                                    }"
                                    placeholder="Enter your query"
                                  />
                                </div>

                                <!-- Audit Trail -->
                                <div class="audit-trail">
                                  <h4>Audit Trail</h4>
                                  <div
                                    class="audit-entry"
                                    *ngFor="let entry of query.auditTrail"
                                  >
                                    <strong>{{ entry.user }}</strong
                                    >-
                                    {{
                                      entry.timestamp
                                        | date : "dd-MMM-yyyy h:mm a"
                                    }}

                                    <p>{{ entry.message }}</p>
                                  </div>
                                </div>
                                <div class="modal-footer">
                                  <button
                                    class="btn custom-button"
                                    [ngClass]="{
                                      'btn-disabled': query.isClosed
                                    }"
                                    (click)="
                                      !query.isClosed && confirmCloseQuery(i)
                                    "
                                  >
                                    Close
                                  </button>
                                  <button
                                    class="btn custom-button ms-2"
                                    (click)="confirmSubmitQuery(i)"
                                    [disabled]="query.isClosed"
                                  >
                                    Submit
                                  </button>
                                </div>
                              </div>
                            </div>

                            <!-- Field History Tab -->
                            <div *ngSwitchCase="'fieldHistory'">
                              <div
                                *ngIf="
                                  fieldHistoryData?.length > 0;
                                  else noData
                                "
                              >
                                <div
                                  *ngFor="let entry of fieldHistoryData"
                                  class="history-box"
                                >
                                  <div class="history-header">
                                    <strong>{{ entry.updated_by }}</strong> -
                                    {{ entry.updated_at | date : "medium" }}
                                  </div>
                                  <div class="history-value">
                                    {{ entry.value }}
                                  </div>
                                  <!-- ✅ Show edit reason if available -->
                                  <div
                                    class="edit-reason"
                                    *ngIf="entry.edit_reason"
                                  >
                                    <em
                                      >Reason for change:
                                      {{ entry.edit_reason }}</em
                                    >
                                  </div>
                                </div>
                              </div>
                              <ng-template #noData>
                                <p>No history available for this field.</p>
                              </ng-template>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </div>

                    </div>

                  </div>
                  <div class="form-group" data-label="4. Date of Expiry:">
                    <label>4. Date of Expiry:</label>
                  <div
                      class="label-wrapper d-flex align-items-center justify-content-between"
                    >
                    <input
                      type="date"
                      class="form-control"
                      [(ngModel)]="formData.triphalaExpiryDate"
                      name="triphalaExpiryDate"
                      [disabled]="isTriphalaExpiryDisabled"
                      [min]="screeningMinDate"
                      [max]="todayDate"
                  
                      required
                    />
                               <div
                        class="menu-icon"
                        (click)="openOptionsModal($event, $event.target)"
                      >
                        ⋮
                      </div>
                    </div>
<!-- Small Modal (Right-side) -->
                    <div
                      class="options-modal"
                      *ngIf="
                        isOptionsModalOpen &&
                        fieldLabel ===
                          '4. Date of Expiry:'
                      "
                      (click)="$event.stopPropagation()"
                      style="margin-right: 50px; margin-top: 197px"
                    >
                      <div class="modal-buttons">
                        <button (click)="openModal()">Query</button>
                        <button (click)="editStudy()">Edit</button>
                        <button type="button" (click)="openReviewModal()">
                          Review
                        </button>
                      </div>
                    </div>
                    <div class="modal-overlay" *ngIf="isReasonModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="cancelEditReason()">
                          ×
                        </button>
                        <h4>Please provide a reason for editing:</h4>
                        <textarea
                          class="form-control"
                          [(ngModel)]="editReason"
                          rows="4"
                          placeholder="Enter reason here..."
                        ></textarea>
                        <div class="modal-footer">
                          <button
                            class="btn custom-button"
                            (click)="confirmEditReason()"
                          >
                            Confirm
                          </button>
                          <button
                            class="btn custom-button"
                            (click)="cancelEditReason()"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                    <!-- Review Modal -->
                    <div
                      class="modal-overlay1"
                      *ngIf="showReviewModal"
                      (click)="closeReviewModal()"
                    >
                      <!-- Close Button -->
                      <span class="close-button1" (click)="closeReviewModal()"
                        >×</span
                      >
                      <div
                        class="modal-content1"
                        (click)="$event.stopPropagation()"
                      >
                        <div class="checkbox-group">
                          <div class="form-check" style="margin-top: 20px">
                            <input
                              type="checkbox"
                              id="reviewedByDataMonitor"
                              name="reviewedByDataMonitor"
                              [(ngModel)]="reviewOptions.dataMonitor"
                              [disabled]="
                                !hasTriphalaExpiryData||
                                userDesignation !== 'data monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByDataMonitor"
                              >Reviewed by Data Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByMonitor"
                              name="reviewedByMonitor"
                              [(ngModel)]="reviewOptions.monitor"
                              [disabled]="
                                !hasTriphalaExpiryData||
                                !reviewOptions.dataMonitor ||
                                userDesignation !== 'monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByMonitor"
                              >Reviewed by Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByPI"
                              name="reviewedByPI"
                              [(ngModel)]="reviewOptions.pi"
                              [disabled]="
                                !hasTriphalaExpiryData ||
                                !reviewOptions.dataMonitor ||
                                !reviewOptions.monitor ||
                                userDesignation !== 'pi'
                              "
                            />
                            <label for="reviewedByPI">Reviewed by PI</label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="modal-overlay" *ngIf="isModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="closeModal()">
                          &times;
                        </button>

                        <!-- Tab Bar -->
                        <div class="tab-bar">
                          <div
                            class="tab"
                            *ngFor="let tab of tabs; let idx = index"
                            [class.active]="selectedTab === idx"
                            (click)="selectTab(idx)"
                          >
                            {{ tab.title }}
                            <span
                              class="close-tab"
                              *ngIf="tabs.length > 1"
                              (click)="closeTab(idx, $event)"
                              >×</span
                            >
                          </div>

                          <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
                          <div
                            *ngIf="tabs[selectedTab].type === 'query'"
                            class="add-btn-wrapper"
                          >
                            <button class="add-btn" (click)="addQuery(i)">
                              +
                            </button>
                            <span class="add-query-tooltip">Add Query</span>
                          </div>
                        </div>

                        <!-- Modal Body -->
                        <div class="modal-body">
                          <ng-container [ngSwitch]="tabs[selectedTab].type">
                            <!-- Query Tab -->
                            <div *ngSwitchCase="'query'">
                              <div
                                *ngFor="let query of queries; let i = index"
                                class="query-box"
                              >
                                <div class="input-checkbox-container">
                                  <input
                                    type="text"
                                    class="form-control"
                                    [value]="''"
                                    (input)="query.text = $event.target.value"
                                    [readonly]="query.isClosed"
                                    [ngClass]="{
                                      'query-closed': query.isClosed
                                    }"
                                    placeholder="Enter your query"
                                  />
                                </div>

                                <!-- Audit Trail -->
                                <div class="audit-trail">
                                  <h4>Audit Trail</h4>
                                  <div
                                    class="audit-entry"
                                    *ngFor="let entry of query.auditTrail"
                                  >
                                    <strong>{{ entry.user }}</strong
                                    >-
                                    {{
                                      entry.timestamp
                                        | date : "dd-MMM-yyyy h:mm a"
                                    }}

                                    <p>{{ entry.message }}</p>
                                  </div>
                                </div>
                                <div class="modal-footer">
                                  <button
                                    class="btn custom-button"
                                    (click)="confirmCloseQuery(i)"
                                  >
                                    Close Query
                                  </button>
                                  <button
                                    class="btn custom-button ms-2"
                                    (click)="confirmSubmitQuery(i)"
                                  >
                                    Submit
                                  </button>
                                </div>
                              </div>
                            </div>

                            <!-- Field History Tab -->
                            <div *ngSwitchCase="'fieldHistory'">
                              <div
                                *ngIf="
                                  fieldHistoryData?.length > 0;
                                  else noData
                                "
                              >
                                <div
                                  *ngFor="let entry of fieldHistoryData"
                                  class="history-box"
                                >
                                  <div class="history-header">
                                    <strong>{{ entry.updated_by }}</strong> -
                                    {{ entry.updated_at | date : "medium" }}
                                  </div>
                                  <div class="history-value">
                                    {{ entry.value }}
                                  </div>
                                  <!-- ✅ Show edit reason if available -->
                                  <div
                                    class="edit-reason"
                                    *ngIf="entry.edit_reason"
                                  >
                                    <em
                                      >Reason for change:
                                      {{ entry.edit_reason }}</em
                                    >
                                  </div>
                                </div>
                              </div>
                              <ng-template #noData>
                                <p>No history available for this field.</p>
                              </ng-template>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                 

                  </div>
                </div>

                <!-- New Fields for Yava Churna -->
                <div class="mt-3">
                  <div
                    class="card-header d-flex justify-content-between align-items-center"
                  >
                    <h5 class="m-0">iii. Yava Churna</h5>
                  </div>

                  <div class="form-group mt-4" data-label="1. Total Number of sachets/boxes dispensed in this visit:">
                    <label
                      >1. Total Number of sachets/boxes dispensed in this
                      visit:</label
                    >
                     <div
                      class="label-wrapper d-flex align-items-center justify-content-between"
                    >
                    <input
                      type="number"
                      class="form-control"
                      [(ngModel)]="formData.yavaChurnaSachets"
                      name="yavaChurnaSachets"
                      [disabled]="isYavaSachetsDisabled"
                      required
                    />
                       <div
                        class="menu-icon"
                        (click)="openOptionsModal($event, $event.target)"
                      >
                        ⋮
                      </div>
                    </div>
                      <!-- Small Modal (Right-side) -->
                    <div
                      class="options-modal"
                      *ngIf="
                        isOptionsModalOpen &&
                        fieldLabel === '1. Total Number of sachets/boxes dispensed in this visit:'
                      "
                      (click)="$event.stopPropagation()"
                      style="margin-right: 50px; margin-top: -10px"
                    >
                      <div class="modal-buttons">
                        <button (click)="openModal()">Query</button>
                        <button (click)="editStudy()">Edit</button>
                        <button type="button" (click)="openReviewModal()">
                          Review
                        </button>
                      </div>
                    </div>
                    <div class="modal-overlay" *ngIf="isReasonModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="cancelEditReason()">
                          ×
                        </button>
                        <h4>Please provide a reason for editing:</h4>
                        <textarea
                          class="form-control"
                          [(ngModel)]="editReason"
                          rows="4"
                          placeholder="Enter reason here..."
                        ></textarea>
                        <div class="modal-footer">
                          <button
                            class="btn custom-button"
                            (click)="confirmEditReason()"
                          >
                            Confirm
                          </button>
                          <button
                            class="btn custom-button"
                            (click)="cancelEditReason()"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>

                    <!-- Review Modal -->
                    <div
                      class="modal-overlay1"
                      *ngIf="showReviewModal"
                      (click)="closeReviewModal()"
                    >
                      <!-- Close Button -->
                      <span class="close-button1" (click)="closeReviewModal()"
                        >×</span
                      >
                      <div
                        class="modal-content1"
                        (click)="$event.stopPropagation()"
                      >
                        <div class="checkbox-group">
                          <div class="form-check" style="margin-top: 20px">
                            <input
                              type="checkbox"
                              id="reviewedByDataMonitor"
                              name="reviewedByDataMonitor"
                              [(ngModel)]="reviewOptions.dataMonitor"
                              [disabled]="
                                !hasYavaSachetsData ||
                                userDesignation !== 'data monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByDataMonitor"
                              >Reviewed by Data Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByMonitor"
                              name="reviewedByMonitor"
                              [(ngModel)]="reviewOptions.monitor"
                              [disabled]="
                                !hasYavaSachetsData ||
                                !reviewOptions.dataMonitor ||
                                userDesignation !== 'monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByMonitor"
                              >Reviewed by Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByPI"
                              name="reviewedByPI"
                              [(ngModel)]="reviewOptions.pi"
                              [disabled]="
                                !hasYavaSachetsData ||
                                !reviewOptions.dataMonitor ||
                                !reviewOptions.monitor ||
                                userDesignation !== 'pi'
                              "
                            />
                            <label for="reviewedByPI">Reviewed by PI</label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="modal-overlay" *ngIf="isModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="closeModal()">
                          &times;
                        </button>

                        <!-- Tab Bar -->
                        <div class="tab-bar">
                          <div
                            class="tab"
                            *ngFor="let tab of tabs; let idx = index"
                            [class.active]="selectedTab === idx"
                            (click)="selectTab(idx)"
                          >
                            {{ tab.title }}
                            <span
                              class="close-tab"
                              *ngIf="tabs.length > 1"
                              (click)="closeTab(idx, $event)"
                              >×</span
                            >
                          </div>

                          <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
                          <div
                            *ngIf="tabs[selectedTab].type === 'query'"
                            class="add-btn-wrapper"
                          >
                            <button class="add-btn" (click)="addQuery(i)">
                              +
                            </button>
                            <span class="add-query-tooltip">Add Query</span>
                          </div>
                        </div>

                        <!-- Modal Body -->
                        <div class="modal-body">
                          <ng-container [ngSwitch]="tabs[selectedTab].type">
                            <!-- Query Tab -->
                            <div *ngSwitchCase="'query'">
                              <div
                                *ngFor="let query of queries; let i = index"
                                class="query-box"
                              >
                                <div class="input-checkbox-container">
                                  <input
                                    type="text"
                                    class="form-control"
                                    [value]="''"
                                    (input)="query.text = $event.target.value"
                                    [readonly]="query.isClosed"
                                    [ngClass]="{
                                      'query-closed': query.isClosed
                                    }"
                                    placeholder="Enter your query"
                                  />
                                </div>

                                <!-- Audit Trail -->
                                <div class="audit-trail">
                                  <h4>Audit Trail</h4>
                                  <div
                                    class="audit-entry"
                                    *ngFor="let entry of query.auditTrail"
                                  >
                                    <strong>{{ entry.user }}</strong
                                    >-
                                    {{
                                      entry.timestamp
                                        | date : "dd-MMM-yyyy h:mm a"
                                    }}

                                    <p>{{ entry.message }}</p>
                                  </div>
                                </div>
                                <div class="modal-footer">
                                  <button
                                    class="btn custom-button"
                                    [ngClass]="{
                                      'btn-disabled': query.isClosed
                                    }"
                                    (click)="
                                      !query.isClosed && confirmCloseQuery(i)
                                    "
                                  >
                                    Close
                                  </button>
                                  <button
                                    class="btn custom-button ms-2"
                                    (click)="confirmSubmitQuery(i)"
                                    [disabled]="query.isClosed"
                                  >
                                    Submit
                                  </button>
                                </div>
                              </div>
                            </div>

                            <!-- Field History Tab -->
                            <div *ngSwitchCase="'fieldHistory'">
                              <div
                                *ngIf="
                                  fieldHistoryData?.length > 0;
                                  else noData
                                "
                              >
                                <div
                                  *ngFor="let entry of fieldHistoryData"
                                  class="history-box"
                                >
                                  <div class="history-header">
                                    <strong>{{ entry.updated_by }}</strong> -
                                    {{ entry.updated_at | date : "medium" }}
                                  </div>
                                  <div class="history-value">
                                    {{ entry.value }}
                                  </div>
                                  <!-- ✅ Show edit reason if available -->
                                  <div
                                    class="edit-reason"
                                    *ngIf="entry.edit_reason"
                                  >
                                    <em
                                      >Reason for change:
                                      {{ entry.edit_reason }}</em
                                    >
                                  </div>
                                </div>
                              </div>
                              <ng-template #noData>
                                <p>No history available for this field.</p>
                              </ng-template>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-group" data-label="2. Total Study Product quantity dispensed in this visit:">
                    <label
                      >2. Total Study Product quantity dispensed in this
                      visit:</label
                    >
                     <div
                      class="label-wrapper d-flex align-items-center justify-content-between"
                    >
                    <input
                      type="number"
                      class="form-control"
                      [(ngModel)]="formData.yavaChurnaQuantity"
                      name="yavaChurnaQuantity"
                      [disabled]="isYavaQuantityDisabled"
                      placeholder="000g"
                      pattern="^\d{3}$"
                      required
                      #yavaChurnaQuantity="ngModel"
                    />
                       <div
                        class="menu-icon"
                        (click)="openOptionsModal($event, $event.target)"
                      >
                        ⋮
                      </div>
                       <!-- Small Modal (Right-side) -->
                    <div
                      class="options-modal"
                      *ngIf="
                        isOptionsModalOpen &&
                        fieldLabel === '2. Total Study Product quantity dispensed in this visit:'
                      "
                      (click)="$event.stopPropagation()"
                      style="margin-right: 50px; margin-top: -10px"
                    >
                      <div class="modal-buttons">
                        <button (click)="openModal()">Query</button>
                        <button (click)="editStudy()">Edit</button>
                        <button type="button" (click)="openReviewModal()">
                          Review
                        </button>
                      </div>
                    </div>
                    <div class="modal-overlay" *ngIf="isReasonModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="cancelEditReason()">
                          ×
                        </button>
                        <h4>Please provide a reason for editing:</h4>
                        <textarea
                          class="form-control"
                          [(ngModel)]="editReason"
                          rows="4"
                          placeholder="Enter reason here..."
                        ></textarea>
                        <div class="modal-footer">
                          <button
                            class="btn custom-button"
                            (click)="confirmEditReason()"
                          >
                            Confirm
                          </button>
                          <button
                            class="btn custom-button"
                            (click)="cancelEditReason()"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>

                    <!-- Review Modal -->
                    <div
                      class="modal-overlay1"
                      *ngIf="showReviewModal"
                      (click)="closeReviewModal()"
                    >
                      <!-- Close Button -->
                      <span class="close-button1" (click)="closeReviewModal()"
                        >×</span
                      >
                      <div
                        class="modal-content1"
                        (click)="$event.stopPropagation()"
                      >
                        <div class="checkbox-group">
                          <div class="form-check" style="margin-top: 20px">
                            <input
                              type="checkbox"
                              id="reviewedByDataMonitor"
                              name="reviewedByDataMonitor"
                              [(ngModel)]="reviewOptions.dataMonitor"
                              [disabled]="
                                !hasYavaQuantityData ||
                                userDesignation !== 'data monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByDataMonitor"
                              >Reviewed by Data Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByMonitor"
                              name="reviewedByMonitor"
                              [(ngModel)]="reviewOptions.monitor"
                              [disabled]="
                                !hasYavaQuantityData ||
                                !reviewOptions.dataMonitor ||
                                userDesignation !== 'monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByMonitor"
                              >Reviewed by Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByPI"
                              name="reviewedByPI"
                              [(ngModel)]="reviewOptions.pi"
                              [disabled]="
                                !hasYavaQuantityData ||
                                !reviewOptions.dataMonitor ||
                                !reviewOptions.monitor ||
                                userDesignation !== 'pi'
                              "
                            />
                            <label for="reviewedByPI">Reviewed by PI</label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="modal-overlay" *ngIf="isModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="closeModal()">
                          &times;
                        </button>

                        <!-- Tab Bar -->
                        <div class="tab-bar">
                          <div
                            class="tab"
                            *ngFor="let tab of tabs; let idx = index"
                            [class.active]="selectedTab === idx"
                            (click)="selectTab(idx)"
                          >
                            {{ tab.title }}
                            <span
                              class="close-tab"
                              *ngIf="tabs.length > 1"
                              (click)="closeTab(idx, $event)"
                              >×</span
                            >
                          </div>

                          <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
                          <div
                            *ngIf="tabs[selectedTab].type === 'query'"
                            class="add-btn-wrapper"
                          >
                            <button class="add-btn" (click)="addQuery(i)">
                              +
                            </button>
                            <span class="add-query-tooltip">Add Query</span>
                          </div>
                        </div>

                        <!-- Modal Body -->
                        <div class="modal-body">
                          <ng-container [ngSwitch]="tabs[selectedTab].type">
                            <!-- Query Tab -->
                            <div *ngSwitchCase="'query'">
                              <div
                                *ngFor="let query of queries; let i = index"
                                class="query-box"
                              >
                                <div class="input-checkbox-container">
                                  <input
                                    type="text"
                                    class="form-control"
                                    [value]="''"
                                    (input)="query.text = $event.target.value"
                                    [readonly]="query.isClosed"
                                    [ngClass]="{
                                      'query-closed': query.isClosed
                                    }"
                                    placeholder="Enter your query"
                                  />
                                </div>

                                <!-- Audit Trail -->
                                <div class="audit-trail">
                                  <h4>Audit Trail</h4>
                                  <div
                                    class="audit-entry"
                                    *ngFor="let entry of query.auditTrail"
                                  >
                                    <strong>{{ entry.user }}</strong
                                    >-
                                    {{
                                      entry.timestamp
                                        | date : "dd-MMM-yyyy h:mm a"
                                    }}

                                    <p>{{ entry.message }}</p>
                                  </div>
                                </div>
                                <div class="modal-footer">
                                  <button
                                    class="btn custom-button"
                                    [ngClass]="{
                                      'btn-disabled': query.isClosed
                                    }"
                                    (click)="
                                      !query.isClosed && confirmCloseQuery(i)
                                    "
                                  >
                                    Close
                                  </button>
                                  <button
                                    class="btn custom-button ms-2"
                                    (click)="confirmSubmitQuery(i)"
                                    [disabled]="query.isClosed"
                                  >
                                    Submit
                                  </button>
                                </div>
                              </div>
                            </div>

                            <!-- Field History Tab -->
                            <div *ngSwitchCase="'fieldHistory'">
                              <div
                                *ngIf="
                                  fieldHistoryData?.length > 0;
                                  else noData
                                "
                              >
                                <div
                                  *ngFor="let entry of fieldHistoryData"
                                  class="history-box"
                                >
                                  <div class="history-header">
                                    <strong>{{ entry.updated_by }}</strong> -
                                    {{ entry.updated_at | date : "medium" }}
                                  </div>
                                  <div class="history-value">
                                    {{ entry.value }}
                                  </div>
                                  <!-- ✅ Show edit reason if available -->
                                  <div
                                    class="edit-reason"
                                    *ngIf="entry.edit_reason"
                                  >
                                    <em
                                      >Reason for change:
                                      {{ entry.edit_reason }}</em
                                    >
                                  </div>
                                </div>
                              </div>
                              <ng-template #noData>
                                <p>No history available for this field.</p>
                              </ng-template>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                    </div>
                  </div>
                  <div class="form-group" data-label="3. Batch Number:">
                    <label>3. Batch Number:</label>
                     <div
                      class="label-wrapper d-flex align-items-center justify-content-between"
                    >
                    <input
                      type="number"
                      class="form-control"
                      [(ngModel)]="formData.yavaChurnaBatchNumber"
                      name="yavaChurnaBatchNumber"
                      [disabled]="isYavaBatchDisabled"
                      required
                    />
                       <div
                        class="menu-icon"
                        (click)="openOptionsModal($event, $event.target)"
                      >
                        ⋮
                      </div>
                    </div>
                    <!-- Small Modal (Right-side) -->
                    <div
                      class="options-modal"
                      *ngIf="
                        isOptionsModalOpen && fieldLabel === '3. Batch Number:'
                      "
                      (click)="$event.stopPropagation()"
                      style="margin-right: 50px; margin-top: 9px"
                    >
                      <div class="modal-buttons">
                        <button (click)="openModal()">Query</button>
                        <button (click)="editStudy()">Edit</button>
                        <button type="button" (click)="openReviewModal()">
                          Review
                        </button>
                      </div>
                    </div>
                    <div class="modal-overlay" *ngIf="isReasonModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="cancelEditReason()">
                          ×
                        </button>
                        <h4>Please provide a reason for editing:</h4>
                        <textarea
                          class="form-control"
                          [(ngModel)]="editReason"
                          rows="4"
                          placeholder="Enter reason here..."
                        ></textarea>
                        <div class="modal-footer">
                          <button
                            class="btn custom-button"
                            (click)="confirmEditReason()"
                          >
                            Confirm
                          </button>
                          <button
                            class="btn custom-button"
                            (click)="cancelEditReason()"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                    <!-- Review Modal -->
                    <div
                      class="modal-overlay1"
                      *ngIf="showReviewModal"
                      (click)="closeReviewModal()"
                    >
                      <!-- Close Button -->
                      <span class="close-button1" (click)="closeReviewModal()"
                        >×</span
                      >
                      <div
                        class="modal-content1"
                        (click)="$event.stopPropagation()"
                      >
                        <div class="checkbox-group">
                          <div class="form-check" style="margin-top: 20px">
                            <input
                              type="checkbox"
                              id="reviewedByDataMonitor"
                              name="reviewedByDataMonitor"
                              [(ngModel)]="reviewOptions.dataMonitor"
                              [disabled]="
                                !hasYavaBatchData ||
                                userDesignation !== 'data monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByDataMonitor"
                              >Reviewed by Data Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByMonitor"
                              name="reviewedByMonitor"
                              [(ngModel)]="reviewOptions.monitor"
                              [disabled]="
                                !hasYavaBatchData ||
                                !reviewOptions.dataMonitor ||
                                userDesignation !== 'monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByMonitor"
                              >Reviewed by Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByPI"
                              name="reviewedByPI"
                              [(ngModel)]="reviewOptions.pi"
                              [disabled]="
                                !hasYavaBatchData ||
                                !reviewOptions.dataMonitor ||
                                !reviewOptions.monitor ||
                                userDesignation !== 'pi'
                              "
                            />
                            <label for="reviewedByPI">Reviewed by PI</label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="modal-overlay" *ngIf="isModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="closeModal()">
                          &times;
                        </button>

                        <!-- Tab Bar -->
                        <div class="tab-bar">
                          <div
                            class="tab"
                            *ngFor="let tab of tabs; let idx = index"
                            [class.active]="selectedTab === idx"
                            (click)="selectTab(idx)"
                          >
                            {{ tab.title }}
                            <span
                              class="close-tab"
                              *ngIf="tabs.length > 1"
                              (click)="closeTab(idx, $event)"
                              >×</span
                            >
                          </div>

                          <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
                          <div
                            *ngIf="tabs[selectedTab].type === 'query'"
                            class="add-btn-wrapper"
                          >
                            <button
                              type="button"
                              class="add-btn"
                              (click)="addQuery(i)"
                            >
                              +
                            </button>
                            <span class="add-query-tooltip">Add Query</span>
                          </div>
                        </div>

                        <!-- Modal Body -->
                        <div class="modal-body">
                          <ng-container [ngSwitch]="tabs[selectedTab].type">
                            <!-- Query Tab -->
                            <div *ngSwitchCase="'query'">
                              <div
                                *ngFor="let query of queries; let i = index"
                                class="query-box"
                              >
                                <div class="input-checkbox-container">
                                  <input
                                    type="text"
                                    class="form-control"
                                    [value]="''"
                                    (input)="query.text = $event.target.value"
                                    [readonly]="query.isClosed"
                                    [ngClass]="{
                                      'query-closed': query.isClosed
                                    }"
                                    placeholder="Enter your query"
                                  />
                                </div>

                                <!-- Audit Trail -->
                                <div class="audit-trail">
                                  <h4>Audit Trail</h4>
                                  <div
                                    class="audit-entry"
                                    *ngFor="let entry of query.auditTrail"
                                  >
                                    <strong>{{ entry.user }}</strong
                                    >-
                                    {{
                                      entry.timestamp
                                        | date : "dd-MMM-yyyy h:mm a"
                                    }}

                                    <p>{{ entry.message }}</p>
                                  </div>
                                </div>
                                <div class="modal-footer">
                                  <button
                                    class="btn custom-button"
                                    (click)="confirmCloseQuery(i)"
                                  >
                                    Close Query
                                  </button>
                                  <button
                                    class="btn custom-button ms-2"
                                    (click)="confirmSubmitQuery(i)"
                                  >
                                    Submit
                                  </button>
                                </div>
                              </div>
                            </div>

                            <!-- Field History Tab -->
                            <div *ngSwitchCase="'fieldHistory'">
                              <div
                                *ngIf="
                                  fieldHistoryData?.length > 0;
                                  else noData
                                "
                              >
                                <div
                                  *ngFor="let entry of fieldHistoryData"
                                  class="history-box"
                                >
                                  <div class="history-header">
                                    <strong>{{ entry.updated_by }}</strong> -
                                    {{ entry.updated_at | date : "medium" }}
                                  </div>
                                  <div class="history-value">
                                    {{ entry.value }}
                                  </div>
                                  <!-- ✅ Show edit reason if available -->
                                  <div
                                    class="edit-reason"
                                    *ngIf="entry.edit_reason"
                                  >
                                    <em
                                      >Reason for change:
                                      {{ entry.edit_reason }}</em
                                    >
                                  </div>
                                </div>
                              </div>
                              <ng-template #noData>
                                <p>No history available for this field.</p>
                              </ng-template>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-group" data-label="4. Date of Expiry:">
                    <label>4. Date of Expiry:</label>
                      <div
                      class="label-wrapper d-flex align-items-center justify-content-between"
                    >
                    <input
                      type="date"
                      class="form-control"
                      [(ngModel)]="formData.yavaChurnaExpiryDate"
                      name="yavaChurnaExpiryDate"
                      [min]="screeningMinDate"
                      [max]="todayDate"
                      [disabled]="isYavaExpiryDisabled"
                      required
                    />
                       <div
                        class="menu-icon"
                        (click)="openOptionsModal($event, $event.target)"
                      >
                        ⋮
                      </div>
                    </div>
                     <!-- Small Modal (Right-side) -->
                    <div
                      class="options-modal"
                      *ngIf="
                        isOptionsModalOpen && fieldLabel === '4. Date of Expiry:'
                      "
                      (click)="$event.stopPropagation()"
                      style="margin-right: 50px; margin-top: 9px"
                    >
                      <div class="modal-buttons">
                        <button (click)="openModal()">Query</button>
                        <button (click)="editStudy()">Edit</button>
                        <button type="button" (click)="openReviewModal()">
                          Review
                        </button>
                      </div>
                    </div>
                    <div class="modal-overlay" *ngIf="isReasonModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="cancelEditReason()">
                          ×
                        </button>
                        <h4>Please provide a reason for editing:</h4>
                        <textarea
                          class="form-control"
                          [(ngModel)]="editReason"
                          rows="4"
                          placeholder="Enter reason here..."
                        ></textarea>
                        <div class="modal-footer">
                          <button
                            class="btn custom-button"
                            (click)="confirmEditReason()"
                          >
                            Confirm
                          </button>
                          <button
                            class="btn custom-button"
                            (click)="cancelEditReason()"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                    <!-- Review Modal -->
                    <div
                      class="modal-overlay1"
                      *ngIf="showReviewModal"
                      (click)="closeReviewModal()"
                    >
                      <!-- Close Button -->
                      <span class="close-button1" (click)="closeReviewModal()"
                        >×</span
                      >
                      <div
                        class="modal-content1"
                        (click)="$event.stopPropagation()"
                      >
                        <div class="checkbox-group">
                          <div class="form-check" style="margin-top: 20px">
                            <input
                              type="checkbox"
                              id="reviewedByDataMonitor"
                              name="reviewedByDataMonitor"
                              [(ngModel)]="reviewOptions.dataMonitor"
                              [disabled]="
                                !hasYavaExpiryData ||
                                userDesignation !== 'data monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByDataMonitor"
                              >Reviewed by Data Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByMonitor"
                              name="reviewedByMonitor"
                              [(ngModel)]="reviewOptions.monitor"
                              [disabled]="
                                !hasYavaExpiryData ||
                                !reviewOptions.dataMonitor ||
                                userDesignation !== 'monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByMonitor"
                              >Reviewed by Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByPI"
                              name="reviewedByPI"
                              [(ngModel)]="reviewOptions.pi"
                              [disabled]="
                                !hasYavaExpiryData ||
                                !reviewOptions.dataMonitor ||
                                !reviewOptions.monitor ||
                                userDesignation !== 'pi'
                              "
                            />
                            <label for="reviewedByPI">Reviewed by PI</label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="modal-overlay" *ngIf="isModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="closeModal()">
                          &times;
                        </button>

                        <!-- Tab Bar -->
                        <div class="tab-bar">
                          <div
                            class="tab"
                            *ngFor="let tab of tabs; let idx = index"
                            [class.active]="selectedTab === idx"
                            (click)="selectTab(idx)"
                          >
                            {{ tab.title }}
                            <span
                              class="close-tab"
                              *ngIf="tabs.length > 1"
                              (click)="closeTab(idx, $event)"
                              >×</span
                            >
                          </div>

                          <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
                          <div
                            *ngIf="tabs[selectedTab].type === 'query'"
                            class="add-btn-wrapper"
                          >
                            <button
                              type="button"
                              class="add-btn"
                              (click)="addQuery(i)"
                            >
                              +
                            </button>
                            <span class="add-query-tooltip">Add Query</span>
                          </div>
                        </div>

                        <!-- Modal Body -->
                        <div class="modal-body">
                          <ng-container [ngSwitch]="tabs[selectedTab].type">
                            <!-- Query Tab -->
                            <div *ngSwitchCase="'query'">
                              <div
                                *ngFor="let query of queries; let i = index"
                                class="query-box"
                              >
                                <div class="input-checkbox-container">
                                  <input
                                    type="text"
                                    class="form-control"
                                    [value]="''"
                                    (input)="query.text = $event.target.value"
                                    [readonly]="query.isClosed"
                                    [ngClass]="{
                                      'query-closed': query.isClosed
                                    }"
                                    placeholder="Enter your query"
                                  />
                                </div>

                                <!-- Audit Trail -->
                                <div class="audit-trail">
                                  <h4>Audit Trail</h4>
                                  <div
                                    class="audit-entry"
                                    *ngFor="let entry of query.auditTrail"
                                  >
                                    <strong>{{ entry.user }}</strong
                                    >-
                                    {{
                                      entry.timestamp
                                        | date : "dd-MMM-yyyy h:mm a"
                                    }}

                                    <p>{{ entry.message }}</p>
                                  </div>
                                </div>
                                <div class="modal-footer">
                                  <button
                                    class="btn custom-button"
                                    (click)="confirmCloseQuery(i)"
                                  >
                                    Close Query
                                  </button>
                                  <button
                                    class="btn custom-button ms-2"
                                    (click)="confirmSubmitQuery(i)"
                                  >
                                    Submit
                                  </button>
                                </div>
                              </div>
                            </div>

                            <!-- Field History Tab -->
                            <div *ngSwitchCase="'fieldHistory'">
                              <div
                                *ngIf="
                                  fieldHistoryData?.length > 0;
                                  else noData
                                "
                              >
                                <div
                                  *ngFor="let entry of fieldHistoryData"
                                  class="history-box"
                                >
                                  <div class="history-header">
                                    <strong>{{ entry.updated_by }}</strong> -
                                    {{ entry.updated_at | date : "medium" }}
                                  </div>
                                  <div class="history-value">
                                    {{ entry.value }}
                                  </div>
                                  <!-- ✅ Show edit reason if available -->
                                  <div
                                    class="edit-reason"
                                    *ngIf="entry.edit_reason"
                                  >
                                    <em
                                      >Reason for change:
                                      {{ entry.edit_reason }}</em
                                    >
                                  </div>
                                </div>
                              </div>
                              <ng-template #noData>
                                <p>No history available for this field.</p>
                              </ng-template>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- New Fields for Dietary and Lifestyle Guidelines -->
                <div
                  class="form-group"
                  data-label="1. Was the dietary consumption guidelines document given to the subject"
                >
         
                                                                      <div
                    class="label-wrapper d-flex align-items-center justify-content-between"
                  >
                                           <label
                    >1. Was the dietary consumption guidelines document given to
                    the subject?</label
                  >

                    <div
                      class="menu-icon"
                      (click)="openOptionsModal($event, $event.target)"

                    >
                      ⋮
                    </div>
                  </div>

                  <div
                    class="label-wrapper d-flex align-items-center justify-content-between"
                  >
                    <div class="radio-group">
                      <label class="radio-label">
                        <input
                          type="radio"
                          [disabled]="isDietaryGuidelinesDisabled"
                          id="dietaryYes"
                          name="dietaryGuidelines"
                          value="yes"
                          [(ngModel)]="formData.dietaryGuidelines"
                          required
                        />
                        <span>Yes</span>
                      </label>
                      <label class="radio-label">
                        <input
                          type="radio"
                          [disabled]="isDietaryGuidelinesDisabled"
                          id="dietaryNo"
                          name="dietaryGuidelines"
                          value="no"
                          [(ngModel)]="formData.dietaryGuidelines"
                          required
                        />
                        <span>No</span>
                      </label>
                    </div>
               
                  </div>
                  <!-- Small Modal (Right-side) -->
                  <div
                    class="options-modal"
                    *ngIf="
                      isOptionsModalOpen &&
                      fieldLabel ===
                        '1. Was the dietary consumption guidelines document given to the subject'
                    "
                    (click)="$event.stopPropagation()"
                    style="margin-right: 55px; margin-top: 1620px"
                  >
                    <div class="modal-buttons">
                      <button type="button" (click)="openModal()">Query</button>
                      <button type="button" (click)="editStudy()">Edit</button>
                      <button type="button"  (click)="openReviewModal()">Review</button>
                    </div>
                  </div>
                  <div class="modal-overlay" *ngIf="isReasonModalOpen">
                    <div class="modal-content">
                      <button class="close-btn" (click)="cancelEditReason()">
                        ×
                      </button>
                      <h4>Please provide a reason for editing:</h4>
                      <textarea
                        class="form-control"
                        [(ngModel)]="editReason"
                        rows="4"
                        placeholder="Enter reason here..."
                      ></textarea>
                      <div class="modal-footer">
                        <button
                          class="btn custom-button"
                          (click)="confirmEditReason()"
                        >
                          Confirm
                        </button>
                        <button
                          class="btn custom-button"
                          (click)="cancelEditReason()"
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>

                  <!-- Review Modal -->
                  <div
                    class="modal-overlay1"
                    *ngIf="showReviewModal"
                    (click)="closeReviewModal()"
                  >
                    <!-- Close Button -->
                    <span class="close-button1" (click)="closeReviewModal()"
                      >×</span
                    >
                    <div
                      class="modal-content1"
                      (click)="$event.stopPropagation()"
                    >
                      <div class="checkbox-group">
                        <div class="form-check" style="margin-top: 20px">
                          <input
                            type="checkbox"
                            id="reviewedByDataMonitor"
                            name="reviewedByDataMonitor"
                            [(ngModel)]="reviewOptions.dataMonitor"
                            [disabled]="
                              !hasDiet2Data ||
                              userDesignation !== 'data monitor'
                            "
                            (change)="onReviewCheckboxChange()"
                          />
                          <label for="reviewedByDataMonitor"
                            >Reviewed by Data Monitor</label
                          >
                        </div>
                      </div>
                      <div class="checkbox-group">
                        <div class="form-check">
                          <input
                            type="checkbox"
                            id="reviewedByMonitor"
                            name="reviewedByMonitor"
                            [(ngModel)]="reviewOptions.monitor"
                             [disabled]="
                              !hasDiet2Data ||
                              !reviewOptions.dataMonitor ||
                              userDesignation !== 'monitor'
                            "
                            (change)="onReviewCheckboxChange()"
                          />
                          <label for="reviewedByMonitor"
                            >Reviewed by Monitor</label
                          >
                        </div>
                      </div>
                      <div class="checkbox-group">
                        <div class="form-check">
                          <input
                            type="checkbox"
                            id="reviewedByPI"
                            name="reviewedByPI"
                            [(ngModel)]="reviewOptions.pi"
                             [disabled]="
                              !hasDiet2Data ||
                              !reviewOptions.dataMonitor ||
                              !reviewOptions.monitor ||
                              userDesignation !== 'pi'
                            "
                          />
                          <label for="reviewedByPI">Reviewed by PI</label>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="modal-overlay" *ngIf="isModalOpen">
                    <div class="modal-content">
                      <button class="close-btn" (click)="closeModal()">
                        &times;
                      </button>

                      <!-- Tab Bar -->
                      <div class="tab-bar">
                        <div
                          class="tab"
                          *ngFor="let tab of tabs; let idx = index"
                          [class.active]="selectedTab === idx"
                          (click)="selectTab(idx)"
                        >
                          {{ tab.title }}
                          <span
                            class="close-tab"
                            *ngIf="tabs.length > 1"
                            (click)="closeTab(idx, $event)"
                            >×</span
                          >
                        </div>

                        <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
                        <div
                          *ngIf="tabs[selectedTab].type === 'query'"
                          class="add-btn-wrapper"
                        >
                          <button
                            type="button"
                            class="add-btn"
                            (click)="addQuery(i)"
                          >
                            +
                          </button>
                          <span class="add-query-tooltip">Add Query</span>
                        </div>
                      </div>

                      <!-- Modal Body -->
                      <div class="modal-body">
                        <ng-container [ngSwitch]="tabs[selectedTab].type">
                          <!-- Query Tab -->
                          <div *ngSwitchCase="'query'">
                            <div
                              *ngFor="let query of queries; let i = index"
                              class="query-box"
                            >
                              <div class="input-checkbox-container">
                                <input
                                  type="text"
                                  class="form-control"
                                  [value]="''"
                                  (input)="query.text = $event.target.value"
                                  [readonly]="query.isClosed"
                                  [ngClass]="{ 'query-closed': query.isClosed }"
                                  placeholder="Enter your query"
                                />
                              </div>

                              <!-- Audit Trail -->
                              <div class="audit-trail">
                                <h4>Audit Trail</h4>
                                <div
                                  class="audit-entry"
                                  *ngFor="let entry of query.auditTrail"
                                >
                                  <strong>{{ entry.user }}</strong
                                  >-
                                  {{
                                    entry.timestamp
                                      | date : "dd-MMM-yyyy h:mm a"
                                  }}

                                  <p>{{ entry.message }}</p>
                                </div>
                              </div>
                              <div class="modal-footer">
                                <button
                                  class="btn custom-button"
                                  [ngClass]="{ 'btn-disabled': query.isClosed }"
                                  (click)="
                                    !query.isClosed && confirmCloseQuery(i)
                                  "
                                >
                                  Close
                                </button>
                                <button
                                  class="btn custom-button ms-2"
                                  (click)="confirmSubmitQuery(i)"
                                  [disabled]="query.isClosed"
                                 type="button">
                                  Submit
                                </button>
                              </div>
                            </div>
                          </div>

                          <!-- Field History Tab -->
                          <div *ngSwitchCase="'fieldHistory'">
                            <div
                              *ngIf="fieldHistoryData?.length > 0; else noData"
                            >
                              <div
                                *ngFor="let entry of fieldHistoryData"
                                class="history-box"
                              >
                                <div class="history-header">
                                  <strong>{{ entry.updated_by }}</strong> -
                                  {{ entry.updated_at | date : "medium" }}
                                </div>
                                <div class="history-value">
                                  {{ entry.value }}
                                </div>
                                <!-- ✅ Show edit reason if available -->
                                <div
                                  class="edit-reason"
                                  *ngIf="entry.edit_reason"
                                >
                                  <em
                                    >Reason for change:
                                    {{ entry.edit_reason }}</em
                                  >
                                </div>
                              </div>
                            </div>
                            <ng-template #noData>
                              <p>No history available for this field.</p>
                            </ng-template>
                          </div>
                        </ng-container>
                      </div>
                    </div>
                  </div>

                  <div class="mt-3" *ngIf="formData.dietaryGuidelines === 'no'">
                    <label>Comments:</label>
                    <textarea
                      class="form-control"
                      [(ngModel)]="formData.dietaryGuidelinesComments"
                      name="dietaryGuidelinesComments"
                    ></textarea>
                  </div>
                </div>

                <div class="form-group" data-label="2. Was the lifestyle guidelines document given to the subject">
                  <label
                    >2. Was the lifestyle guidelines document given to the
                    subject?</label
                  >
                  <div
                      class="label-wrapper d-flex align-items-center justify-content-between"
                    >
                  <div class="radio-group">
                    <label class="radio-label">
                      <input
                        type="radio"
                        id="lifestyleYes"
                        name="lifestyleGuidelines"
                        value="yes"
                        [(ngModel)]="formData.lifestyleGuidelines"
                        [disabled]="isLifestyle2Disabled"
                        required
                      />
                      <span>Yes</span>
                    </label>
                    <label class="radio-label">
                      <input
                        type="radio"
                        id="lifestyleNo"
                        name="lifestyleGuidelines"
                        value="no"
                        [(ngModel)]="formData.lifestyleGuidelines"
                          [disabled]="isLifestyle2Disabled"
                        required
                      />
                      <span>No</span>
                    </label>
                  </div>
                  <div
                        class="menu-icon"
                        (click)="openOptionsModal($event, $event.target)"
                      >
                        ⋮
                      </div>
                    </div>
                      <!-- Small Modal (Right-side) -->
                    <div
                      class="options-modal"
                      *ngIf="
                        isOptionsModalOpen &&
                        fieldLabel ===
                          '2. Was the lifestyle guidelines document given to the subject'
                      "
                      (click)="$event.stopPropagation()"
                      style="margin-right: 50px; margin-top: -10px"
                    >
                      <div class="modal-buttons">
                        <button (click)="openModal()">Query</button>
                        <button (click)="editStudy()">Edit</button>
                        <button type="button" (click)="openReviewModal()">
                          Review
                        </button>
                      </div>
                    </div>
                    <div class="modal-overlay" *ngIf="isReasonModalOpen">
                      <div class="modal-content">
                        <button class="close-btn" (click)="cancelEditReason()">
                          ×
                        </button>
                        <h4>Please provide a reason for editing:</h4>
                        <textarea
                          class="form-control"
                          [(ngModel)]="editReason"
                          rows="4"
                          placeholder="Enter reason here..."
                        ></textarea>
                        <div class="modal-footer">
                          <button
                            class="btn custom-button"
                            (click)="confirmEditReason()"
                          >
                            Confirm
                          </button>
                          <button
                            class="btn custom-button"
                            (click)="cancelEditReason()"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>

                    <!-- Review Modal -->
                    <div
                      class="modal-overlay1"
                      *ngIf="showReviewModal"
                      (click)="closeReviewModal()"
                    >
                      <!-- Close Button -->
                      <span class="close-button1" (click)="closeReviewModal()"
                        >×</span
                      >
                      <div
                        class="modal-content1"
                        (click)="$event.stopPropagation()"
                      >
                        <div class="checkbox-group">
                          <div class="form-check" style="margin-top: 20px">
                            <input
                              type="checkbox"
                              id="reviewedByDataMonitor"
                              name="reviewedByDataMonitor"
                              [(ngModel)]="reviewOptions.dataMonitor"
                              [disabled]="
                                !hasLifestyle2Data ||
                                userDesignation !== 'data monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByDataMonitor"
                              >Reviewed by Data Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByMonitor"
                              name="reviewedByMonitor"
                              [(ngModel)]="reviewOptions.monitor"
                              [disabled]="
                                !hasLifestyle2Data ||
                                !reviewOptions.dataMonitor ||
                                userDesignation !== 'monitor'
                              "
                              (change)="onReviewCheckboxChange()"
                            />
                            <label for="reviewedByMonitor"
                              >Reviewed by Monitor</label
                            >
                          </div>
                        </div>
                        <div class="checkbox-group">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              id="reviewedByPI"
                              name="reviewedByPI"
                              [(ngModel)]="reviewOptions.pi"
                              [disabled]="
                                !hasLifestyle2Data ||
                                !reviewOptions.dataMonitor ||
                                !reviewOptions.monitor ||
                                userDesignation !== 'pi'
                              "
                            />
                            <label for="reviewedByPI">Reviewed by PI</label>
                          </div>
                        </div>
                      </div>
                    </div>


                  <div
                    class="mt-3"
                    *ngIf="formData.lifestyleGuidelines === 'no'"
                  >
                    <label>Comments:</label>
                    <textarea
                      class="form-control"
                      [(ngModel)]="formData.lifestyleGuidelinesComments"
                      name="lifestyleGuidelinesComments"
                    ></textarea>
                  </div>
                </div>

                <!-- Submit and Back Buttons -->
               <div class="text-end">
                   <!--<button type="button" class="btn custom-button" (click)="goBack()">Back</button> -->
                  <button type="submit" class="btn custom-button">
                    Submit
                  </button>
                </div>
                </div>
              </form>
            </div>
          </div>

          <!-- Review of Adverse Events and Concomitant Medication Form -->
          <div *ngIf="formName === 'baseline-adverse-events'" class="card mt-4">
            <div
              class="card-header d-flex justify-content-between align-items-center"
            >
              <h5 class="m-0">
                Review of Adverse Events and Concomitant Medication
              </h5>
              <!--<button type="button" class="btn custom-button">Create Field</button>-->
            </div>

            <div class="card-body">
              <form (ngSubmit)="submitForm()">
                <div
                  class="form-group"
                  data-label="1. Did the subject experience any adverse event since last visit"
                >
               
                                                          <div
                    class="label-wrapper d-flex align-items-center justify-content-between"
                  >
                                <label
                    >1. Did the subject experience any adverse event since last
                    visit?</label
                  >

                    <div
                      class="menu-icon"
                      (click)="openOptionsModal($event, $event.target)"

                    >
                      ⋮
                    </div>
                  </div>

                  <div
                    class="label-wrapper d-flex align-items-center justify-content-between"
                  >
                    <div class="radio-group">
                      <label class="radio-label">
                        <input
                          type="radio"
                          [disabled]="isAdverseDisabled"
                          id="aeYes"
                          name="adverseEvents"
                          value="yes"
                          [(ngModel)]="formData.adverseEvents"
                          required
                        />
                        <span>Yes</span>
                      </label>
                      <label class="radio-label">
                        <input
                          type="radio"
                          [disabled]="isAdverseDisabled"
                          id="aeNo"
                          name="adverseEvents"
                          value="no"
                          [(ngModel)]="formData.adverseEvents"
                          required
                        />
                        <span>No</span>
                      </label>
                    </div>
                 
                  </div>
                  <!-- Small Modal (Right-side) -->
                  <div
                    class="options-modal"
                    *ngIf="
                      isOptionsModalOpen &&
                      fieldLabel ===
                        '1. Did the subject experience any adverse event since last visit'
                    "
                    (click)="$event.stopPropagation()"
                    style="margin-right: 55px; margin-top: 40px"
                  >
                    <div class="modal-buttons">
                      <button type="button" (click)="openModal()">Query</button>
                      <button type="button" (click)="editStudy()">Edit</button>
                      <button  type="button"   (click)="openReviewModal()">Review</button>
                    </div>
                  </div>
                  <div class="modal-overlay" *ngIf="isReasonModalOpen">
                    <div class="modal-content">
                      <button class="close-btn" (click)="cancelEditReason()">
                        ×
                      </button>
                      <h4>Please provide a reason for editing:</h4>
                      <textarea
                        class="form-control"
                        [(ngModel)]="editReason"
                        rows="4"
                        placeholder="Enter reason here..."
                      ></textarea>
                      <div class="modal-footer">
                        <button
                          class="btn custom-button"
                          (click)="confirmEditReason()"
                        >
                          Confirm
                        </button>
                        <button
                          class="btn custom-button"
                          (click)="cancelEditReason()"
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                  <!-- Review Modal -->
                  <div
                    class="modal-overlay1"
                    *ngIf="showReviewModal"
                    (click)="closeReviewModal()"
                  >
                    <!-- Close Button -->
                    <span class="close-button1" (click)="closeReviewModal()"
                      >×</span
                    >
                    <div
                      class="modal-content1"
                      (click)="$event.stopPropagation()"
                    >
                      <div class="checkbox-group">
                        <div class="form-check" style="margin-top: 20px">
                          <input
                            type="checkbox"
                            id="reviewedByDataMonitor"
                            name="reviewedByDataMonitor"
                            [(ngModel)]="reviewOptions.dataMonitor"
                            [disabled]="
                              !hasAdverseData ||
                              userDesignation !== 'data monitor'
                            "
                            (change)="onReviewCheckboxChange()"
                          />
                          <label for="reviewedByDataMonitor"
                            >Reviewed by Data Monitor</label
                          >
                        </div>
                      </div>
                      <div class="checkbox-group">
                        <div class="form-check">
                          <input
                            type="checkbox"
                            id="reviewedByMonitor"
                            name="reviewedByMonitor"
                            [(ngModel)]="reviewOptions.monitor"
                             [disabled]="
                              !hasAdverseData ||
                              !reviewOptions.dataMonitor ||
                              userDesignation !== 'monitor'
                            "
                            (change)="onReviewCheckboxChange()"
                          />
                          <label for="reviewedByMonitor"
                            >Reviewed by Monitor</label
                          >
                        </div>
                      </div>
                      <div class="checkbox-group">
                        <div class="form-check">
                          <input
                            type="checkbox"
                            id="reviewedByPI"
                            name="reviewedByPI"
                            [(ngModel)]="reviewOptions.pi"
                            [disabled]="
                              !hasAdverseData ||
                              !reviewOptions.dataMonitor ||
                              !reviewOptions.monitor ||
                              userDesignation !== 'pi'
                            "
                          />
                          <label for="reviewedByPI">Reviewed by PI</label>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="modal-overlay" *ngIf="isModalOpen">
                    <div class="modal-content">
                      <button class="close-btn" (click)="closeModal()">
                        &times;
                      </button>

                      <!-- Tab Bar -->
                      <div class="tab-bar">
                        <div
                          class="tab"
                          *ngFor="let tab of tabs; let idx = index"
                          [class.active]="selectedTab === idx"
                          (click)="selectTab(idx)"
                        >
                          {{ tab.title }}
                          <span
                            class="close-tab"
                            *ngIf="tabs.length > 1"
                            (click)="closeTab(idx, $event)"
                            >×</span
                          >
                        </div>

                        <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
                        <div
                          *ngIf="tabs[selectedTab].type === 'query'"
                          class="add-btn-wrapper"
                        >
                          <button  type="button" class="add-btn" (click)="addQuery(i)">
                            +
                          </button>
                          <span class="add-query-tooltip">Add Query</span>
                        </div>
                      </div>

                      <!-- Modal Body -->
                      <div class="modal-body">
                        <ng-container [ngSwitch]="tabs[selectedTab].type">
                          <!-- Query Tab -->
                          <div *ngSwitchCase="'query'">
                            <div
                              *ngFor="let query of queries; let i = index"
                              class="query-box"
                            >
                              <div class="input-checkbox-container">
                                <input
                                  type="text"
                                  class="form-control"
                                  [value]="''"
                                  (input)="query.text = $event.target.value"
                                  [readonly]="query.isClosed"
                                  [ngClass]="{ 'query-closed': query.isClosed }"
                                  placeholder="Enter your query"
                                />
                              </div>

                              <!-- Audit Trail -->
                              <div class="audit-trail">
                                <h4>Audit Trail</h4>
                                <div
                                  class="audit-entry"
                                  *ngFor="let entry of query.auditTrail"
                                >
                                  <strong>{{ entry.user }}</strong
                                  >-
                                  {{
                                    entry.timestamp
                                      | date : "dd-MMM-yyyy h:mm a"
                                  }}

                                  <p>{{ entry.message }}</p>
                                </div>
                              </div>
                              <div class="modal-footer">
                                <button
                                  class="btn custom-button"
                                  (click)="confirmCloseQuery(i)"
                                type="button">
                                  Close Query
                                </button>
                                <button
                                  class="btn custom-button ms-2"
                                  (click)="confirmSubmitQuery(i)"
                                 type="button">
                                  Submit
                                </button>
                              </div>
                            </div>
                          </div>

                          <!-- Field History Tab -->
                          <div *ngSwitchCase="'fieldHistory'">
                            <div
                              *ngIf="fieldHistoryData?.length > 0; else noData"
                            >
                              <div
                                *ngFor="let entry of fieldHistoryData"
                                class="history-box"
                              >
                                <div class="history-header">
                                  <strong>{{ entry.updated_by }}</strong> -
                                  {{ entry.updated_at | date : "medium" }}
                                </div>
                                <div class="history-value">
                                  {{ entry.value }}
                                </div>
                                <!-- ✅ Show edit reason if available -->
                                <div
                                  class="edit-reason"
                                  *ngIf="entry.edit_reason"
                                >
                                  <em
                                    >Reason for change:
                                    {{ entry.edit_reason }}</em
                                  >
                                </div>
                              </div>
                            </div>
                            <ng-template #noData>
                              <p>No history available for this field.</p>
                            </ng-template>
                          </div>
                        </ng-container>
                      </div>
                    </div>
                  </div>
                  <!-- Show the button only when "Yes" is selected for Adverse Events -->
                  <div class="mt-3" *ngIf="formData.adverseEvents === 'yes'">
                    <button
                      type="button"
                      class="btn btn-success"
                      (click)="navigateToAdverseEvents()"
                    >
                      Add Adverse Event Data
                    </button>
                  </div>
                </div>

                <div
                  class="form-group"
                  data-label="2. Did the subject take any new or change in concomitant medications since last visit"
                >
              
                                        <div
                    class="label-wrapper d-flex align-items-center justify-content-between"
                  >
                      <label
                    >2. Did the subject take any new or change in concomitant
                    medications since last visit?</label
                  >

                    <div
                      class="menu-icon"
                      (click)="openOptionsModal($event, $event.target)"

                    >
                      ⋮
                    </div>
                  </div>
                  <div
                    class="label-wrapper d-flex align-items-center justify-content-between"
                  >
                    <div class="radio-group">
                      <label class="radio-label">
                        <input
                          type="radio"
                          [disabled]="isAdverseDisabled2"
                          id="medYes"
                          name="concomitantMedications"
                          value="yes"
                          [(ngModel)]="formData.concomitantMedications"
                          required
                        />
                        <span>Yes</span>
                      </label>
                      <label class="radio-label">
                        <input
                          type="radio"
                          id="medNo"
                          [disabled]="isAdverseDisabled2"
                          name="concomitantMedications"
                          value="no"
                          [(ngModel)]="formData.concomitantMedications"
                          required
                        />
                        <span>No</span>
                      </label>
                    </div>
                 
                  </div>
                  <!-- Small Modal (Right-side) -->
                  <div
                    class="options-modal"
                    *ngIf="
                      isOptionsModalOpen &&
                      fieldLabel ===
                        '2. Did the subject take any new or change in concomitant medications since last visit'
                    "
                    (click)="$event.stopPropagation()"
                    style="margin-right: 55px; margin-top: 115px"
                  >
                    <div class="modal-buttons">
                      <button type="button" (click)="openModal()">Query</button>
                      <button type="button" (click)="editStudy()">Edit</button>
                      <button type="button"   (click)="openReviewModal()">Review</button>
                    </div>
                  </div>
                  <div class="modal-overlay" *ngIf="isReasonModalOpen">
                    <div class="modal-content">
                      <button class="close-btn" (click)="cancelEditReason()">
                        ×
                      </button>
                      <h4>Please provide a reason for editing:</h4>
                      <textarea
                        class="form-control"
                        [(ngModel)]="editReason"
                        rows="4"
                        placeholder="Enter reason here..."
                      ></textarea>
                      <div class="modal-footer">
                        <button
                          class="btn custom-button"
                          (click)="confirmEditReason()"
                        >
                          Confirm
                        </button>
                        <button
                          class="btn custom-button"
                          (click)="cancelEditReason()"
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                  <!-- Review Modal -->
                  <div
                    class="modal-overlay1"
                    *ngIf="showReviewModal"
                    (click)="closeReviewModal()"
                  >
                    <!-- Close Button -->
                    <span class="close-button1" (click)="closeReviewModal()"
                      >×</span
                    >
                    <div
                      class="modal-content1"
                      (click)="$event.stopPropagation()"
                    >
                      <div class="checkbox-group">
                        <div class="form-check" style="margin-top: 20px">
                          <input
                            type="checkbox"
                            id="reviewedByDataMonitor"
                            name="reviewedByDataMonitor"
                            [(ngModel)]="reviewOptions.dataMonitor"
                             [disabled]="
                              !hasAdverse2Data ||
                              userDesignation !== 'data monitor'
                            "
                            (change)="onReviewCheckboxChange()"
                          />
                          <label for="reviewedByDataMonitor"
                            >Reviewed by Data Monitor</label
                          >
                        </div>
                      </div>
                      <div class="checkbox-group">
                        <div class="form-check">
                          <input
                            type="checkbox"
                            id="reviewedByMonitor"
                            name="reviewedByMonitor"
                            [(ngModel)]="reviewOptions.monitor"
                             [disabled]="
                              !hasAdverse2Data ||
                              !reviewOptions.dataMonitor ||
                              userDesignation !== 'monitor'
                            "
                            (change)="onReviewCheckboxChange()"
                          />
                          <label for="reviewedByMonitor"
                            >Reviewed by Monitor</label
                          >
                        </div>
                      </div>
                      <div class="checkbox-group">
                        <div class="form-check">
                          <input
                            type="checkbox"
                            id="reviewedByPI"
                            name="reviewedByPI"
                            [(ngModel)]="reviewOptions.pi"
                             [disabled]="
                              !hasAdverse2Data ||
                              !reviewOptions.dataMonitor ||
                              !reviewOptions.monitor ||
                              userDesignation !== 'pi'
                            "
                          />
                          <label for="reviewedByPI">Reviewed by PI</label>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="modal-overlay" *ngIf="isModalOpen">
                    <div class="modal-content">
                      <button class="close-btn" (click)="closeModal()">
                        &times;
                      </button>

                      <!-- Tab Bar -->
                      <div class="tab-bar">
                        <div
                          class="tab"
                          *ngFor="let tab of tabs; let idx = index"
                          [class.active]="selectedTab === idx"
                          (click)="selectTab(idx)"
                        >
                          {{ tab.title }}
                          <span
                            class="close-tab"
                            *ngIf="tabs.length > 1"
                            (click)="closeTab(idx, $event)"
                            >×</span
                          >
                        </div>

                        <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
                        <div
                          *ngIf="tabs[selectedTab].type === 'query'"
                          class="add-btn-wrapper"
                        >
                          <button  type="button" class="add-btn" (click)="addQuery(i)">
                            +
                          </button>
                          <span class="add-query-tooltip">Add Query</span>
                        </div>
                      </div>

                      <!-- Modal Body -->
                      <div class="modal-body">
                        <ng-container [ngSwitch]="tabs[selectedTab].type">
                          <!-- Query Tab -->
                          <div *ngSwitchCase="'query'">
                            <div
                              *ngFor="let query of queries; let i = index"
                              class="query-box"
                            >
                              <div class="input-checkbox-container">
                                <input
                                  type="text"
                                  class="form-control"
                                  [value]="''"
                                  (input)="query.text = $event.target.value"
                                  [readonly]="query.isClosed"
                                  [ngClass]="{ 'query-closed': query.isClosed }"
                                  placeholder="Enter your query"
                                />
                              </div>

                              <!-- Audit Trail -->
                              <div class="audit-trail">
                                <h4>Audit Trail</h4>
                                <div
                                  class="audit-entry"
                                  *ngFor="let entry of query.auditTrail"
                                >
                                  <strong>{{ entry.user }}</strong
                                  >-
                                  {{
                                    entry.timestamp
                                      | date : "dd-MMM-yyyy h:mm a"
                                  }}

                                  <p>{{ entry.message }}</p>
                                </div>
                              </div>
                              <div class="modal-footer">
                                <button
                                  class="btn custom-button"
                                  (click)="confirmCloseQuery(i)"
                                type="button">
                                  Close Query
                                </button>
                                <button
                                  class="btn custom-button ms-2"
                                  (click)="confirmSubmitQuery(i)"
                                 type="button">
                                  Submit
                                </button>
                              </div>
                            </div>
                          </div>

                          <!-- Field History Tab -->
                          <div *ngSwitchCase="'fieldHistory'">
                            <div
                              *ngIf="fieldHistoryData?.length > 0; else noData"
                            >
                              <div
                                *ngFor="let entry of fieldHistoryData"
                                class="history-box"
                              >
                                <div class="history-header">
                                  <strong>{{ entry.updated_by }}</strong> -
                                  {{ entry.updated_at | date : "medium" }}
                                </div>
                                <div class="history-value">
                                  {{ entry.value }}
                                </div>
                                <!-- ✅ Show edit reason if available -->
                                <div
                                  class="edit-reason"
                                  *ngIf="entry.edit_reason"
                                >
                                  <em
                                    >Reason for change:
                                    {{ entry.edit_reason }}</em
                                  >
                                </div>
                              </div>
                            </div>
                            <ng-template #noData>
                              <p>No history available for this field.</p>
                            </ng-template>
                          </div>
                        </ng-container>
                      </div>
                    </div>
                  </div>

                  <!-- Show the button only when "Yes" is selected -->
                  <div
                    class="mt-3"
                    *ngIf="formData.concomitantMedications === 'yes'"
                  >
                    <button
                      type="button"
                      class="btn btn-success"
                      (click)="navigateToConcomitantMedication()"
                    >
                      Add Concomitant Data
                    </button>
                  </div>
                </div>

               <div class="text-end">
                   <!--<button type="button" class="btn custom-button" (click)="goBack()">Back</button> -->
                  <button type="submit" class="btn custom-button">
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>

          <!-- End of Baseline Visit Form -->
          <div *ngIf="formName === 'baseline-end-visit'" class="card mt-4">
            <div
              class="card-header d-flex justify-content-between align-items-center"
            >
              <h5 class="m-0">End of Baseline Visit</h5>
              <!--<button type="button" class="btn custom-button">Create Field</button>-->
            </div>

            <div class="card-body">
              <form (ngSubmit)="submitForm()">
                <div
                  class="form-group"
                  data-label="1. Principal Investigator’s Signature:"
                >
                                       <div
                    class="label-wrapper d-flex align-items-center justify-content-between"
                  >
                                <label>1. Principal Investigator’s Signature:</label>

                    <div
                      class="menu-icon"
                      (click)="openOptionsModal($event, $event.target)"
                      style="margin-bottom: 8px;"

                    >
                      ⋮
                    </div>
                  </div>
                  <div
                    class="label-wrapper d-flex align-items-center justify-content-between"
                  >
                    <input
                      type="text"
                      [disabled]="isSignatureDisabled"
                      class="form-control"
                      [(ngModel)]="formData.investigatorSignature"
                      name="investigatorSignature"
                      required
                    />
                
                  </div>
                  <!-- Small Modal (Right-side) -->
                  <div
                    class="options-modal"
                    *ngIf="
                      isOptionsModalOpen &&
                      fieldLabel === '1. Principal Investigator’s Signature:'
                    "
                    (click)="$event.stopPropagation()"
                    style="margin-right: 55px; margin-top: 40px"
                  >
                    <div class="modal-buttons">
                      <button type="button" (click)="openModal()">Query</button>
                      <button type="button" (click)="editStudy()">Edit</button>
                      <button type="button"   (click)="openReviewModal()">Review</button>
                    </div>
                  </div>
                  <div class="modal-overlay" *ngIf="isReasonModalOpen">
                    <div class="modal-content">
                      <button class="close-btn" (click)="cancelEditReason()">
                        ×
                      </button>
                      <h4>Please provide a reason for editing:</h4>
                      <textarea
                        class="form-control"
                        [(ngModel)]="editReason"
                        rows="4"
                        placeholder="Enter reason here..."
                      ></textarea>
                      <div class="modal-footer">
                        <button
                          class="btn custom-button"
                          (click)="confirmEditReason()"
                        >
                          Confirm
                        </button>
                        <button
                          class="btn custom-button"
                          (click)="cancelEditReason()"
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                  <!-- Review Modal -->
                  <div
                    class="modal-overlay1"
                    *ngIf="showReviewModal"
                    (click)="closeReviewModal()"
                  >
                    <!-- Close Button -->
                    <span class="close-button1" (click)="closeReviewModal()"
                      >×</span
                    >
                    <div
                      class="modal-content1"
                      (click)="$event.stopPropagation()"
                    >
                      <div class="checkbox-group">
                        <div class="form-check" style="margin-top: 20px">
                          <input
                            type="checkbox"
                            id="reviewedByDataMonitor"
                            name="reviewedByDataMonitor"
                            [(ngModel)]="reviewOptions.dataMonitor"
                             [disabled]="
                              !hasPrincipalSignData ||
                              userDesignation !== 'data monitor'
                            "
                            (change)="onReviewCheckboxChange()"
                            
                          />
                          <label for="reviewedByDataMonitor"
                            >Reviewed by Data Monitor</label
                          >
                        </div>
                      </div>
                      <div class="checkbox-group">
                        <div class="form-check">
                          <input
                            type="checkbox"
                            id="reviewedByMonitor"
                            name="reviewedByMonitor"
                            [(ngModel)]="reviewOptions.monitor"
                             [disabled]="
                              !hasPrincipalSignData ||
                              !reviewOptions.dataMonitor ||
                              userDesignation !== 'monitor'
                            "
                            (change)="onReviewCheckboxChange()"
                          />
                          <label for="reviewedByMonitor"
                            >Reviewed by Monitor</label
                          >
                        </div>
                      </div>
                      <div class="checkbox-group">
                        <div class="form-check">
                          <input
                            type="checkbox"
                            id="reviewedByPI"
                            name="reviewedByPI"
                            [(ngModel)]="reviewOptions.pi"
                            [disabled]="
                              !hasPrincipalSignData ||
                              !reviewOptions.dataMonitor ||
                              !reviewOptions.monitor ||
                              userDesignation !== 'pi'
                            "
                          />
                          <label for="reviewedByPI">Reviewed by PI</label>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="modal-overlay" *ngIf="isModalOpen">
                    <div class="modal-content">
                      <button class="close-btn" (click)="closeModal()">
                        &times;
                      </button>

                      <!-- Tab Bar -->
                      <div class="tab-bar">
                        <div
                          class="tab"
                          *ngFor="let tab of tabs; let idx = index"
                          [class.active]="selectedTab === idx"
                          (click)="selectTab(idx)"
                        >
                          {{ tab.title }}
                          <span
                            class="close-tab"
                            *ngIf="tabs.length > 1"
                            (click)="closeTab(idx, $event)"
                            >×</span
                          >
                        </div>

                        <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
                        <div
                          *ngIf="tabs[selectedTab].type === 'query'"
                          class="add-btn-wrapper"
                        >
                          <button  type="button" class="add-btn" (click)="addQuery(i)">
                            +
                          </button>
                          <span class="add-query-tooltip">Add Query</span>
                        </div>
                      </div>

                      <!-- Modal Body -->
                      <div class="modal-body">
                        <ng-container [ngSwitch]="tabs[selectedTab].type">
                          <!-- Query Tab -->
                          <div *ngSwitchCase="'query'">
                            <div
                              *ngFor="let query of queries; let i = index"
                              class="query-box"
                            >
                              <div class="input-checkbox-container">
                                <input
                                  type="text"
                                  class="form-control"
                                  [value]="''"
                                  (input)="query.text = $event.target.value"
                                  [readonly]="query.isClosed"
                                  [ngClass]="{ 'query-closed': query.isClosed }"
                                  placeholder="Enter your query"
                                />
                              </div>

                              <!-- Audit Trail -->
                              <div class="audit-trail">
                                <h4>Audit Trail</h4>
                                <div
                                  class="audit-entry"
                                  *ngFor="let entry of query.auditTrail"
                                >
                                  <strong>{{ entry.user }}</strong
                                  >-
                                  {{
                                    entry.timestamp
                                      | date : "dd-MMM-yyyy h:mm a"
                                  }}

                                  <p>{{ entry.message }}</p>
                                </div>
                              </div>
                              <div class="modal-footer">
                                <button
                                  class="btn custom-button"
                                  (click)="confirmCloseQuery(i)"
                                type="button">
                                  Close Query
                                </button>
                                <button
                                  class="btn custom-button ms-2"
                                  (click)="confirmSubmitQuery(i)"
                                 type="button">
                                  Submit
                                </button>
                              </div>
                            </div>
                          </div>

                          <!-- Field History Tab -->
                          <div *ngSwitchCase="'fieldHistory'">
                            <div
                              *ngIf="fieldHistoryData?.length > 0; else noData"
                            >
                              <div
                                *ngFor="let entry of fieldHistoryData"
                                class="history-box"
                              >
                                <div class="history-header">
                                  <strong>{{ entry.updated_by }}</strong> -
                                  {{ entry.updated_at | date : "medium" }}
                                </div>
                                <div class="history-value">
                                  {{ entry.value }}
                                </div>
                                <!-- ✅ Show edit reason if available -->
                                <div
                                  class="edit-reason"
                                  *ngIf="entry.edit_reason"
                                >
                                  <em
                                    >Reason for change:
                                    {{ entry.edit_reason }}</em
                                  >
                                </div>
                              </div>
                            </div>
                            <ng-template #noData>
                              <p>No history available for this field.</p>
                            </ng-template>
                          </div>
                        </ng-container>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="form-group" data-label="2. Date:">
                                                  <div
                    class="label-wrapper d-flex align-items-center justify-content-between"
                  >
                                               <label>2. Date:</label>


                    <div
                      class="menu-icon"
                      (click)="openOptionsModal($event, $event.target)"
                      style="margin-bottom: 8px;"

                    >
                      ⋮
                    </div>
                  </div>
                  <div
                    class="label-wrapper d-flex align-items-center justify-content-between"
                  >
                    <input
                      type="date"
                      [disabled]="isDateDisabled"
                      class="form-control"
                      [(ngModel)]="formData.endBaselineVisitDate"
                      name="endBaselineVisitDate"
                      [min]="screeningMinDate"
                      [max]="todayDate"
                      required
                    />
              
                  </div>
                  <!-- Small Modal (Right-side) -->
                  <div
                    class="options-modal"
                    *ngIf="isOptionsModalOpen && fieldLabel === '2. Date:'"
                    (click)="$event.stopPropagation()"
                    style="margin-right: 55px; margin-top: 140px"
                  >
                    <div class="modal-buttons">
                      <button type="button" (click)="openModal()">Query</button>
                      <button type="button" (click)="editStudy()">Edit</button>
                      <button type="button"  (click)="openReviewModal()">Review</button>
                    </div>
                  </div>
                  <div class="modal-overlay" *ngIf="isReasonModalOpen">
                    <div class="modal-content">
                      <button class="close-btn" (click)="cancelEditReason()">
                        ×
                      </button>
                      <h4>Please provide a reason for editing:</h4>
                      <textarea
                        class="form-control"
                        [(ngModel)]="editReason"
                        rows="4"
                        placeholder="Enter reason here..."
                      ></textarea>
                      <div class="modal-footer">
                        <button
                          class="btn custom-button"
                          (click)="confirmEditReason()"
                        >
                          Confirm
                        </button>
                        <button
                          class="btn custom-button"
                          (click)="cancelEditReason()"
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                  <!-- Review Modal -->
                  <div
                    class="modal-overlay1"
                    *ngIf="showReviewModal"
                    (click)="closeReviewModal()"
                  >
                    <!-- Close Button -->
                    <span class="close-button1" (click)="closeReviewModal()"
                      >×</span
                    >
                    <div
                      class="modal-content1"
                      (click)="$event.stopPropagation()"
                    >
                      <div class="checkbox-group">
                        <div class="form-check" style="margin-top: 20px">
                          <input
                            type="checkbox"
                            id="reviewedByDataMonitor"
                            name="reviewedByDataMonitor"
                            [(ngModel)]="reviewOptions.dataMonitor"
                            [disabled]="
                              !hasEndDData ||
                              userDesignation !== 'data monitor'
                            "
                            (change)="onReviewCheckboxChange()"
                          />
                          <label for="reviewedByDataMonitor"
                            >Reviewed by Data Monitor</label
                          >
                        </div>
                      </div>
                      <div class="checkbox-group">
                        <div class="form-check">
                          <input
                            type="checkbox"
                            id="reviewedByMonitor"
                            name="reviewedByMonitor"
                            [(ngModel)]="reviewOptions.monitor"
                             [disabled]="
                              !hasEndDData ||
                              !reviewOptions.dataMonitor ||
                              userDesignation !== 'monitor'
                            "
                            (change)="onReviewCheckboxChange()"
                          />
                          <label for="reviewedByMonitor"
                            >Reviewed by Monitor</label
                          >
                        </div>
                      </div>
                      <div class="checkbox-group">
                        <div class="form-check">
                          <input
                            type="checkbox"
                            id="reviewedByPI"
                            name="reviewedByPI"
                            [(ngModel)]="reviewOptions.pi"
                            [disabled]="
                              !hasEndDData ||
                              !reviewOptions.dataMonitor ||
                              !reviewOptions.monitor ||
                              userDesignation !== 'pi'
                            "
                          />
                          <label for="reviewedByPI">Reviewed by PI</label>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="modal-overlay" *ngIf="isModalOpen">
                    <div class="modal-content">
                      <button class="close-btn" (click)="closeModal()">
                        &times;
                      </button>

                      <!-- Tab Bar -->
                      <div class="tab-bar">
                        <div
                          class="tab"
                          *ngFor="let tab of tabs; let idx = index"
                          [class.active]="selectedTab === idx"
                          (click)="selectTab(idx)"
                        >
                          {{ tab.title }}
                          <span
                            class="close-tab"
                            *ngIf="tabs.length > 1"
                            (click)="closeTab(idx, $event)"
                            >×</span
                          >
                        </div>

                        <!-- <div class="add-tab" (click)="addTab('2. Date of Study Completion:')">+</div> -->
                        <div
                          *ngIf="tabs[selectedTab].type === 'query'"
                          class="add-btn-wrapper"
                        >
                          <button  type="button" class="add-btn" (click)="addQuery(i)">
                            +
                          </button>
                          <span class="add-query-tooltip">Add Query</span>
                        </div>
                      </div>

                      <!-- Modal Body -->
                      <div class="modal-body">
                        <ng-container [ngSwitch]="tabs[selectedTab].type">
                          <!-- Query Tab -->
                          <div *ngSwitchCase="'query'">
                            <div
                              *ngFor="let query of queries; let i = index"
                              class="query-box"
                            >
                              <div class="input-checkbox-container">
                                <input
                                  type="text"
                                  class="form-control"
                                  [value]="''"
                                  (input)="query.text = $event.target.value"
                                  [readonly]="query.isClosed"
                                  [ngClass]="{ 'query-closed': query.isClosed }"
                                  placeholder="Enter your query"
                                />
                              </div>

                              <!-- Audit Trail -->
                              <div class="audit-trail">
                                <h4>Audit Trail</h4>
                                <div
                                  class="audit-entry"
                                  *ngFor="let entry of query.auditTrail"
                                >
                                  <strong>{{ entry.user }}</strong
                                  >-
                                  {{
                                    entry.timestamp
                                      | date : "dd-MMM-yyyy h:mm a"
                                  }}

                                  <p>{{ entry.message }}</p>
                                </div>
                              </div>
                              <div class="modal-footer">
                                <button
                                  class="btn custom-button"
                                  (click)="confirmCloseQuery(i)"
                                type="button">
                                  Close Query
                                </button>
                                <button
                                  class="btn custom-button ms-2"
                                  (click)="confirmSubmitQuery(i)"
                                 type="button">
                                  Submit
                                </button>
                              </div>
                            </div>
                          </div>

                          <!-- Field History Tab -->
                          <div *ngSwitchCase="'fieldHistory'">
                            <div
                              *ngIf="fieldHistoryData?.length > 0; else noData"
                            >
                              <div
                                *ngFor="let entry of fieldHistoryData"
                                class="history-box"
                              >
                                <div class="history-header">
                                  <strong>{{ entry.updated_by }}</strong> -
                                  {{ entry.updated_at | date : "medium" }}
                                </div>
                                <div class="history-value">
                                  {{ entry.value }}
                                </div>
                                <!-- ✅ Show edit reason if available -->
                                <div
                                  class="edit-reason"
                                  *ngIf="entry.edit_reason"
                                >
                                  <em
                                    >Reason for change:
                                    {{ entry.edit_reason }}</em
                                  >
                                </div>
                              </div>
                            </div>
                            <ng-template #noData>
                              <p>No history available for this field.</p>
                            </ng-template>
                          </div>
                        </ng-container>
                      </div>
                    </div>
                  </div>
                </div>

               <div class="text-end">
                   <!--<button type="button" class="btn custom-button" (click)="goBack()">Back</button> -->
                  <button type="submit" class="btn custom-button">
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
